export interface LookupEntry {
  category: string
  text: string
}

export const dtcSpnLookupMapEvertiFeed: Record<number, LookupEntry> = {
  10068: { category: "Fehler", text: "LV-Batteriespannung ist zu niedrig" },
  10270: { category: "Fehler", text: "Hydrauliköl-Temperatur zu niedrig" },
  10271: { category: "Fehler", text: "Sehr hohe Hydrauliköl-Temperatur" },
  10272: { category: "Fehler", text: "Kuehlwasser-Temperatur zu niedrig" },
  10273: { category: "Fehler", text: "Kuehlwasser-Temperatur zu hoch" },
  10274: { category: "Fehler", text: "Wartung erforderlich" },
  10275: { category: "Fehler", text: "Wartung unbedingt erforderlich" },
  10280: { category: "Fehler", text: "Hydrauliköl-Temperatur zu hoch" },
  10281: { category: "Fehler", text: "Hohe Hydrauliköl-Temperatur" },
  10500: { category: "Fehler", text: "Not-Aus ist betätigt" },
  10501: { category: "Fehler", text: "HVIL ist unterbrochen" },
  10502: { category: "Fehler", text: "Isolationsfehler bei letzter Nutzung" },
  18200: { category: "Fehler", text: "Update Fehlerhafte Dateien" },
  18201: { category: "Fehler", text: "Update Fehler bei Verbindungsaufbau" },
  18202: { category: "Fehler", text: "Update keine Firmware Backup-Datei" },
  18203: {
    category: "Fehler",
    text: "Update Fehler beim Auslesen der Software",
  },
  18204: {
    category: "Fehler",
    text: "Update Fehler beim Speichern der Software",
  },
  18205: { category: "Fehler", text: "Update Fehler beim Laden der Firmware" },
  18206: { category: "Fehler", text: "Update Fehler beim Laden der Software" },
  18207: {
    category: "Fehler",
    text: "Update Fehler beim Beenden der Verbindung",
  },
  18208: {
    category: "Fehler",
    text: "Update Fehler beim Laden der Backup-Software",
  },
  18209: {
    category: "Fehler",
    text: "Update Fehler beim Laden der Backup-Firmware",
  },
  18210: {
    category: "Fehler",
    text: "Update Fehler beim Speichern der Perisistenten Daten",
  },
  18211: {
    category: "Fehler",
    text: "Update Fehler beim Kopieren des Display-Updates",
  },
  18212: {
    category: "Fehler",
    text: "Update Fehler beim Speichern der Update-Dateien",
  },
  18213: {
    category: "Fehler",
    text: "Update Fehler beim Löschen der Update-Dateien",
  },
  21015: { category: "Fehler", text: "Niedriger Ladezustand" },
  21016: { category: "Fehler", text: "Sehr niedriger Ladezustand" },
  21057: { category: "Fehler", text: "DCDC Kommunikationsfehler" },
  21058: { category: "Fehler", text: "DCDC Eingang Überspannung" },
  21059: { category: "Fehler", text: "DCDC Eingang Unterspannung" },
  21060: { category: "Fehler", text: "DCDC interner Schutz" },
  21061: { category: "Fehler", text: "DCDC Ausgang Überstrom" },
  21062: { category: "Fehler", text: "DCDC Ausgang Überspannung" },
  21063: { category: "Fehler", text: "DCDC Ausgang Kurzschluss-Schutz" },
  21064: { category: "Fehler", text: "DCDC Ausgang Unterspannung" },
  21065: { category: "Fehler", text: "DCDC Abschalten bei Übertemperatur" },
  21067: { category: "Fehler", text: "OBC Hardwareschutz" },
  21068: { category: "Fehler", text: "OBC Abschalten bei Übertemperatur" },
  21069: { category: "Fehler", text: "OBC Eingangsspannung Fehler" },
  21070: { category: "Fehler", text: "OBC Batteriespannung fehlt" },
  21071: { category: "Fehler", text: "OBC Kommunikation fehlt" },
  21072: { category: "Fehler", text: "OBC Ladestecker Übertemperatur" },
  21073: { category: "Fehler", text: "OBC Ladestecker CC Fehler" },
  21074: { category: "Fehler", text: "OBC Ladestecker CP Fehler" },
  21075: { category: "Fehler", text: "BMS Entladestrom zu groß" },
  21076: { category: "Fehler", text: "BMS Charger Safety Relais" },
  21077: { category: "Fehler", text: "BMS interner Hardwarefehler" },
  21078: { category: "Fehler", text: "BMS interner Temperatursensor" },
  21079: { category: "Fehler", text: "BMS interner Softwarefehler" },
  21080: { category: "Fehler", text: "BMS höchste Zellspannung zu hoch" },
  21081: { category: "Fehler", text: "BMS niedrigste Zellspannung zu niedrig" },
  21082: { category: "Fehler", text: "BMS Batterietemperatur zu hoch" },
  21083: { category: "Fehler", text: "BMS interner Kommunikationsfehler" },
  21084: { category: "Fehler", text: "BMS Balancing Fehler" },
  21085: { category: "Fehler", text: "BMS schwache Zelle" },
  21086: { category: "Fehler", text: "BMS Zellspannung zu niedrig" },
  21087: { category: "Fehler", text: "BMS Zelle nicht angeschlossen" },
  21088: { category: "Fehler", text: "BMS Stromsensorfehler" },
  21089: { category: "Fehler", text: "BMS Zellspannung zu hoch" },
  21090: { category: "Fehler", text: "BMS interner Messfehler" },
  21091: { category: "Fehler", text: "BMS SOH zu niedrig" },
  21092: { category: "Fehler", text: "BMS Lüfterfehler" },
  21093: { category: "Fehler", text: "BMS Temperatursensorfehler" },
  21094: { category: "Fehler", text: "BMS externer Kommunikationsfehler" },
  21095: { category: "Fehler", text: "BMS redundante Spannungsversorgung" },
  21096: { category: "Fehler", text: "BMS Isolationsfehler" },
  21097: { category: "Fehler", text: "BMS Fehler Versorgungsspannung" },
  21098: { category: "Fehler", text: "BMS Ladestrom zu groß" },
  21099: { category: "Fehler", text: "DCDC-Wandler ist deaktiviert" },
  21105: { category: "Fehler", text: "Strombegrenzung aktiv" },
  21106: { category: "Fehler", text: "Elektromotor Mischer gestoppt" },
  21400: { category: "Fehler", text: "Baterriesystem interner Fehler" },
  21401: { category: "Fehler", text: "Batteriesystem IO Fehler" },
  21402: { category: "Fehler", text: "Batteriesystem allgemeiner CAN Fehler" },
  21403: { category: "Fehler", text: "Batteriesystem HVIL unterbrochen" },
  21404: { category: "Fehler", text: "Batteriesystem Notfallabschaltung" },
  21405: { category: "Fehler", text: "Batteriesystem Schütze fehlerhaft" },
  21406: {
    category: "Fehler",
    text: "Batteriesystem BMS konnte nicht gestartet werden",
  },
  21407: {
    category: "Fehler",
    text: "Batteriesystem Schütze nicht geschlossen",
  },
  21408: {
    category: "Fehler",
    text: "Batteriesystem Precharge fehlgeschlagen",
  },
  21409: { category: "Fehler", text: "Batteriesystem Active Discharge Fehler" },
  21410: {
    category: "Fehler",
    text: "Batteriesystem Ein- oder Ausschalten fehlgeschlagen",
  },
  21411: { category: "Fehler", text: "Batteriesystem Zellspannung zu hoch" },
  21412: { category: "Fehler", text: "Batteriesystem Zelltemperatur zu hoch" },
  21413: { category: "Fehler", text: "Batteriesystem Temperatur zu hoch" },
  21414: { category: "Fehler", text: "Batteriesystem Zellspannung zu niedrig" },
  21415: {
    category: "Fehler",
    text: "Batteriesystem Zelltemperatur zu niedrig",
  },
  21416: { category: "Fehler", text: "Batteriesystem Ladestrom zu hoch" },
  21417: {
    category: "Fehler",
    text: "Batteriesystem Leistungsentnahme zu hoch",
  },
  21418: {
    category: "Fehler",
    text: "Batteriesystem Kommunikation Fehler OBC",
  },
  21419: {
    category: "Fehler",
    text: "Batteriesystem Eingangsspannung Fehler OBC",
  },
  21420: {
    category: "Fehler",
    text: "Batteriesystem Ausgangsspannung Fehler OBC",
  },
  21421: { category: "Fehler", text: "Batteriesystem OBC Temperatur erhöht" },
  21422: { category: "Fehler", text: "Batteriesystem OBC Temperatur zu hoch" },
  21423: { category: "Fehler", text: "Batteriesystem Notfallabschaltung OBC" },
  21424: { category: "Fehler", text: "Batteriesystem interner Fehler OBC" },
  21425: { category: "Fehler", text: "Batteriesystem Gesamtspannung zu hoch" },
  21426: {
    category: "Fehler",
    text: "Batteriesystem Gesamtspannung zu niedrig",
  },
  21427: { category: "Fehler", text: "Batteriesystem allgemeiner Fehler OBC" },
  21428: {
    category: "Fehler",
    text: "Batteriesystem Ladesteckerverriegelung Fehler",
  },
  21429: {
    category: "Fehler",
    text: "Batteriesystem einphasiges Laden Fehler",
  },
  21430: {
    category: "Fehler",
    text: "Batteriesystem Ausgangsspannung OBC zu hoch",
  },
  21431: {
    category: "Fehler",
    text: "Batteriesystem Ausgangsspannung OBC zu niedrig",
  },
  21432: { category: "Fehler", text: "Batteriesystem Kabelbruch Pumpe" },
  21433: {
    category: "Fehler",
    text: "Batteriesystem Kurzschluss gegen 24 V Pumpe",
  },
  21434: { category: "Fehler", text: "Batteriesystem Strom der Pumpe zu hoch" },
  21435: {
    category: "Fehler",
    text: "Batteriesystem Kurzschluss gegen Masse Pumpe",
  },
  21436: {
    category: "Fehler",
    text: "Batteriesystem Versorgung Pumpe unplausibel",
  },
  21437: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 1 Kabelbruch",
  },
  21438: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 1 Kurzschluss",
  },
  21439: {
    category: "Fehler",
    text: "Batteriesystem Signal Kable 1 Überstrom",
  },
  21440: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 1 Kurzschluss Masse",
  },
  21441: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 1 unplausibel",
  },
  21442: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 2 Kabelbruch",
  },
  21443: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 2 Kurzschluss",
  },
  21444: {
    category: "Fehler",
    text: "Batteriesystem Signal Kable 2 Überstrom",
  },
  21445: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 2 Kurzschluss Masse",
  },
  21446: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 2 unplausibel",
  },
  21447: { category: "Fehler", text: "Batteriesystem Fehler beim Hochfahren" },
  21448: { category: "Fehler", text: "Batteriesystem CAN Fehler extern" },
  21449: { category: "Fehler", text: "Batteriesystem Ladezustand gering" },
  21450: { category: "Fehler", text: "Batteriesystem Ladezustand zu gering" },
  21451: { category: "Fehler", text: "Batteriesystem Ladezustand leer" },
  21452: {
    category: "Fehler",
    text: "Batteriesystem Isolationsüberwachung Fehler",
  },
  21453: { category: "Fehler", text: "Batteriesystem Isolation Warnung" },
  21454: { category: "Fehler", text: "Batteriesystem Isolation Fehler" },
  21455: { category: "Fehler", text: "Batteriesystem DCDC Fehler" },
  21456: { category: "Fehler", text: "Batteriesystem Vorwärm Warnung" },
  21800: {
    category: "Fehler",
    text: "Elektromotor Mischer Kommunikationsverlust",
  },
  21801: {
    category: "Fehler",
    text: "Elektromotor Mischer angefragtes Drehmoment zu hoch",
  },
  21802: { category: "Fehler", text: "Elektromotor Mischer HVIL Fehler" },
  21803: {
    category: "Fehler",
    text: "Elektromotor Mischer Active Discharge Fehler",
  },
  21804: {
    category: "Fehler",
    text: "Elektromotor Mischer Temperatursensor Motor",
  },
  21805: {
    category: "Fehler",
    text: "Elektromotor Mischer Temperatursensor Inverter",
  },
  21812: {
    category: "Fehler",
    text: "Elektromotor Mischer Temperatur Motor zu hoch",
  },
  21813: {
    category: "Fehler",
    text: "Elektromotor Mischer Temperatur Inverter zu hoch",
  },
  21814: {
    category: "Fehler",
    text: "Elektromotor Mischer Eingangsspannung zu hoch",
  },
  21815: {
    category: "Fehler",
    text: "Elektromotor Mischer Eingangsspannung zu niedrig",
  },
  21816: {
    category: "Fehler",
    text: "Elektromotor Mischer Strom im Motor zu hoch",
  },
  21817: { category: "Fehler", text: "Elektromotor Mischer Last zu hoch" },
  21818: {
    category: "Fehler",
    text: "Elektromotor Mischer Spannungsversorgung zu niedrig",
  },
  21819: {
    category: "Fehler",
    text: "Elektromotor Mischer interner Fehler Inverter",
  },
  21820: { category: "Fehler", text: "Elektromotor Mischer Resolver Fehler" },
  21821: {
    category: "Fehler",
    text: "Elektromotor Mischer Stromsensor Fehler",
  },
  21822: {
    category: "Fehler",
    text: "Elektromotor Mischer Spannungssensor Eingang",
  },
  21823: {
    category: "Fehler",
    text: "Elektromotor Mischer Kommunikation Fehler",
  },
  21824: { category: "Fehler", text: "Elektromotor Mischer Drehzahl zu hoch" },
  21825: {
    category: "Fehler",
    text: "Elektromotor Mischer Motor Phasenverlust",
  },
  22100: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Kommunikationsverlust",
  },
  22101: {
    category: "Fehler",
    text: "Elektromotor Hydraulik angefragtes Drehmoment zu hoch",
  },
  22102: { category: "Fehler", text: "Elektromotor Hydraulik HVIL Fehler" },
  22103: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Active Discharge Fehler",
  },
  22104: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Temperatursensor Motor",
  },
  22105: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Temperatursensor Inverter",
  },
  22112: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Temperatur Motor zu hoch",
  },
  22113: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Temperatur Inverter zu hoch",
  },
  22114: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Eingangsspannung zu hoch",
  },
  22115: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Eingangsspannung zu niedrig",
  },
  22116: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Strom im Motor zu hoch",
  },
  22117: { category: "Fehler", text: "Elektromotor Hydraulik Last zu hoch" },
  22118: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Spannungsversorgung zu niedrig",
  },
  22119: {
    category: "Fehler",
    text: "Elektromotor Hydraulik interner Fehler Inverter",
  },
  22120: { category: "Fehler", text: "Elektromotor Hydraulik Resolver Fehler" },
  22121: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Stromsensor Fehler",
  },
  22122: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Spannungssensor Eingang",
  },
  22123: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Kommunikation Fehler",
  },
  22124: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Drehzahl zu hoch",
  },
  22125: {
    category: "Fehler",
    text: "Elektromotor Hydraulik Motor Phasenverlust",
  },
}

export const dtcSpnLookupMapPrimus: Record<number, LookupEntry> = {
  1001: { category: "Fehler", text: "Diagnoseinterface Fräse ungültig" },
  1002: { category: "Fehler", text: "CAN-Interface Fräse ist ungültig" },
  1003: {
    category: "Fehler",
    text: "Fräspumpen vor und reversiert gleichzeitig bestromt",
  },
  1004: {
    category: "Fehler",
    text: "Interface Freigaben für Fräse ist ungültig",
  },
  1005: {
    category: "Fehler",
    text: "Sollgeschwindigkeit der Fräse ist außerhalb des zulässigen Bereiches",
  },
  1006: {
    category: "Fehler",
    text: "Falsche Soll-Laufrichtung für Fräse erkannt",
  },
  1007: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Fräse gefunden",
  },
  1008: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Fräse gefunden",
  },
  1010: {
    category: "Fehler",
    text: "Nicht initialisierte Überwachung für Fräse gefunden",
  },
  1011: {
    category: "Fehler",
    text: "Can-Interface für neue Daten ist ungültig für Fräse",
  },
  1012: {
    category: "Fehler",
    text: "Ungültige Laufrichtung vom CAN-Bus für Fräse gefunden",
  },
  1013: {
    category: "Fehler",
    text: "Ungültige Geschwindigkeit vom CAN-Bus für Fräse",
  },
  1014: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Fräse in clsFraese gefunden",
  },
  1015: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Fräse",
  },
  1016: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Fräse",
  },
  1017: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Fräspumpe arbeiten ist ungültig",
  },
  1018: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Fräspumpe reversiert ist ungültig",
  },
  1019: {
    category: "Fehler",
    text: "Interface des analogen Einganges Fräsdruck 600bar ist ungültig",
  },
  1020: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Ansteuerung Zentralschmierung ist ungültig",
  },
  1021: {
    category: "Fehler",
    text: "Interface Primus-Management ist nicht initialisiert in Klasse clsFraese",
  },
  1022: {
    category: "Fehler",
    text: "Interface Primus-Management ist null in Klasse clsFraese",
  },
  1023: {
    category: "Fehler",
    text: "Betriebsmodus in Klasse clsFraese ist undefiniert",
  },
  1024: {
    category: "Fehler",
    text: "Zentralschmierung über das Display angefragt, diese läuft aber bereits",
  },
  1025: {
    category: "Fehler",
    text: "Interface Dosierschieber 1 ist null in Klasse clsFraese",
  },
  1026: {
    category: "Fehler",
    text: "Interface Dosierschieber 1 ist nicht initialisiert in Klasse clsFraese",
  },
  1027: {
    category: "Fehler",
    text: "Interface Dosierschieber 2 ist null in Klasse clsFraese",
  },
  1028: {
    category: "Fehler",
    text: "Interface Dosierschieber 2 ist nicht initialisiert in Klasse clsFraese",
  },
  1029: {
    category: "Fehler",
    text: "Interface Dosierschieber 3 ist null in Klasse clsFraese",
  },
  1030: {
    category: "Fehler",
    text: "Interface Dosierschieber 3 ist nicht initialisiert in Klasse clsFraese",
  },
  1031: {
    category: "Fehler",
    text: "Interface Dosierschieber 4 ist null in Klasse clsFraese",
  },
  1032: {
    category: "Fehler",
    text: "Interface Dosierschieber 4 ist nicht initialisiert in Klasse clsFraese",
  },
  1033: {
    category: "Fehler",
    text: "Mindestens ein Schieber ist geöffnet, die Fräse arbeitet",
  },
  1034: {
    category: "Fehler",
    text: "Fräse kann nicht eingeschaltet werden, bitte zunächst über Neutralposition gehen",
  },
  1035: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  1036: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  1040: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Fräsarm heben ist null",
  },
  1041: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Fräsarm senken ist null",
  },
  1042: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Fräsarm Druckreduzierung ist null",
  },
  1050: {
    category: "Fehler",
    text: "Gleichzeitige Bestromung von Fräswalzenschutz öffnen und schließen",
  },
  1051: {
    category: "Fehler",
    text: "Diagnoseinterface Fräswalzenschutz ist ungültig",
  },
  1052: {
    category: "Fehler",
    text: "CAN-Interface Fräswalzenschutz ist ungültig",
  },
  1053: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik Fräswalzenschutz ist ungültig",
  },
  1054: {
    category: "Fehler",
    text: "Interface Freigaben für Fräswalzenschutz ist ungültig",
  },
  1055: {
    category: "Fehler",
    text: "Ungültige Aktion für Fräswalzenschutz gefunden",
  },
  1056: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Fräswalzenschutz gefunden",
  },
  1057: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Fräswalzenschutz gefunden",
  },
  1058: {
    category: "Fehler",
    text: "Nicht initialisierte Überwachung für Fräswalzenschutz gefunden",
  },
  1059: {
    category: "Fehler",
    text: "Can-Interface für neue Daten ist ungültig für Fräswalzenschutz",
  },
  1060: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Fräswalzenschutz in clsFraeswalzenschutz gefunden",
  },
  1061: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Fräswalzenschutz öffnen ist ungültig",
  },
  1062: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Fräswalzenschutz schließen ist ungültig",
  },
  1063: {
    category: "Fehler",
    text: "Interface Ansteuerung Fräswalzenschutz ist ungültig in Klasse clsFraeswalzenschutz",
  },
  1064: {
    category: "Fehler",
    text: "Gleichzeitige Bestromung von Vorwahl A und B für den Fräswalzenschutz erkannt",
  },
  1065: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik ist nicht initialisiert in Klasse clsFraeswalzenschutz",
  },
  1066: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik ist null in Klasse clsFraeswalzenschutz",
  },
  1067: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse clsFraeswalzenschutz",
  },
  1068: {
    category: "Fehler",
    text: "Parameter-Interface ist null in Klasse clsFraeswalzenschutz",
  },
  1069: {
    category: "Fehler",
    text: "Falscher Betriebsmodus zum Öffnen des Fräswalzenschutzes",
  },
  1070: {
    category: "Fehler",
    text: "Interface Management für Fräswalzenschutz ist ungültig",
  },
  1071: {
    category: "Fehler",
    text: "Interface Management für Fräswalzenschutz ist null",
  },
  1072: {
    category: "Fehler",
    text: "Fräswalzenschutz kann nicht geöffnet werden, bitte zunächst über Neutralposition gehen",
  },
  1073: {
    category: "Fehler",
    text: "Fräswalzenschutz kann nicht geschlossen werden, bitte zunächst über Neutralposition gehen",
  },
  1074: {
    category: "Fehler",
    text: "Interface Demo Modus ist nicht initialisiert",
  },
  1075: { category: "Fehler", text: "Interface Demo Modus ist null" },
  1080: {
    category: "Fehler",
    text: "Diagnoseinterface Gegenschneiden ist ungültig",
  },
  1081: {
    category: "Fehler",
    text: "CAN-Interface Gegenschneiden ist ungültig",
  },
  1082: {
    category: "Fehler",
    text: "Interface Freigaben für Gegenschneiden ist ungültig",
  },
  1083: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik für Gegenschneiden ist ungültig",
  },
  1084: {
    category: "Fehler",
    text: "Ungültige Aktion für Gegenschneiden gefunden",
  },
  1085: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Gegenschneiden gefunden",
  },
  1086: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Gegenschneiden gefunden",
  },
  1087: {
    category: "Fehler",
    text: "Nicht initialisierte Überwachung für Gegenschneiden gefunden",
  },
  1088: {
    category: "Fehler",
    text: "Nicht initialisierte Vorwahlhydraulik für Gegenschneiden gefunden",
  },
  1089: {
    category: "Fehler",
    text: "Eingehendes CAN-Gerät ist null in Klasse Gegenschneiden",
  },
  1090: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Gegenschneiden in clsGegenschneiden gefunden",
  },
  1091: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Gegenschneiden",
  },
  1092: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Gegenschneiden",
  },
  1093: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Ansteuerung Gegenschneiden ist ungültig",
  },
  1094: {
    category: "Fehler",
    text: "Gegenschneiden können nicht verfahren werden, bitte zunächst über Neutralposition gehen",
  },
  1095: {
    category: "Fehler",
    text: "Komfortfunktion: Gegenschneide automatisch eingestellt",
  },
  1110: {
    category: "Fehler",
    text: "Diagnoseinterface für Elevatorband ist ungültig",
  },
  1111: {
    category: "Fehler",
    text: "CAN-Interface für Elevatorband ist ungültig",
  },
  1112: {
    category: "Fehler",
    text: "Falsche Soll-Laufrichtung für Elevatorband erkannt",
  },
  1113: {
    category: "Fehler",
    text: "Can-Interface für neue Daten ist ungültig für Elevatorband",
  },
  1114: {
    category: "Fehler",
    text: "Ungültige Soll-Laufrichtung für Elevatorband gefunden",
  },
  1115: {
    category: "Fehler",
    text: "Ungültige Soll-Geschwindigkeit für Elevatorband gefunden",
  },
  1116: { category: "Fehler", text: "Ungültiger Bandtyp für Elevator" },
  1117: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Elevator in clsElevator gefunden",
  },
  1118: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Elevator vor ist ungültig",
  },
  1119: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Elevator rev ist ungültig",
  },
  1120: {
    category: "Fehler",
    text: "Interface des analogen Einganges Sensor Druck Schrägförderer ist ungültig",
  },
  1121: {
    category: "Fehler",
    text: "Fehlerhafte Laufrichtung für das Elevator von einer externen Klasse gefunden",
  },
  1122: {
    category: "Fehler",
    text: "Externe Klasse (nicht CAN) möchte Elevatorband steuern, das Interface ist aber null",
  },
  1123: {
    category: "Fehler",
    text: "Ungültige Laufrichtung Elevatorband von externer nicht-CAN Klasse gefunden",
  },
  1124: {
    category: "Fehler",
    text: "Ungültige Geschwindigkeit Elevatorband von externer nicht-CAN Klasse gefunden",
  },
  1125: {
    category: "Fehler",
    text: "Elevatorband wird von CAN und Futterklappe gesteuert",
  },
  1126: {
    category: "Fehler",
    text: "Austragsband kann nicht eingeschaltet werden, bitte zunächst in Neutralposition schalten",
  },
  1127: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  1128: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  1129: {
    category: "Fehler",
    text: "Interface Fräsarm ist nicht initialisiert",
  },
  1130: { category: "Fehler", text: "Interface Fräsarm ist null" },
  1131: {
    category: "Fehler",
    text: "Initialisierung der Klasse Elevator fehlerhaft",
  },
  1132: {
    category: "Fehler",
    text: "Fehler beim Lesen der red. Elevatorgeschwindigkeit",
  },
  1133: {
    category: "Fehler",
    text: "Aufgrund von Komponentenschutz ist das Reversieren des Elevatorbandes zeitlich begrenzt",
  },
  1150: {
    category: "Fehler",
    text: "Diagnoseinterface für Waage ist ungültig",
  },
  1151: { category: "Fehler", text: "CAN-Interface für Waage ist ungültig" },
  1152: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Waage gefunden",
  },
  1153: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Waage gefunden",
  },
  1154: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Waage in clsWaage gefunden",
  },
  1155: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Waage",
  },
  1156: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Waage",
  },
  1157: { category: "Fehler", text: "Klasse clsWaage ist nicht initialisiert" },
  1158: {
    category: "Fehler",
    text: "Eingehender CAN-Bus ist nicht initialisiert in Klasse clsWaage",
  },
  1159: {
    category: "Fehler",
    text: "Aktueller Gewichtswert ist außerhalb des zulässigen Bereiches",
  },
  1160: {
    category: "Fehler",
    text: "neueDatenVorhanden aufgerufen, obwohl Gewichtsdaten nicht über CAN kommen",
  },
  1161: {
    category: "Fehler",
    text: "Ungültiger Wert eines Wiegesystems gefunden",
  },
  1162: { category: "Fehler", text: "Rezept erfolgreich abgeschlossen" },
  1163: { category: "Fehler", text: "Rezept automatisch neu geladen" },
  1164: { category: "Fehler", text: "Gewichtswerte Rezeptverwaltung pausiert" },
  1165: { category: "Fehler", text: "Gewichtswerte Rezeptverwaltung aktiv" },
  1166: {
    category: "Fehler",
    text: "Unterlauf Waage erkannt. Setze Gewicht auf 0kg",
  },
  1167: {
    category: "Fehler",
    text: "Interface Demo-Modus ist nicht initialisiert",
  },
  1168: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  1180: {
    category: "Fehler",
    text: "Diagnoseinterface für Strohhäcksler ist ungültig",
  },
  1181: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Strohhaecksler gefunden",
  },
  1250: {
    category: "Fehler",
    text: "Interface Anforderung Futterklappe Elevator starten ist null",
  },
  1251: {
    category: "Fehler",
    text: "Interface Elevatorband ist null in Klasse clsFutterKlappe",
  },
  1252: {
    category: "Fehler",
    text: "Interface Überwachung ist null in Klasse clsFutterKlappe",
  },
  1253: {
    category: "Fehler",
    text: "Klasse clsFutterKlappe ist nicht initialisiert",
  },
  1254: {
    category: "Fehler",
    text: "Diagnoseinterface nicht initialisiert in Klasse clsFutterKlappe",
  },
  1255: {
    category: "Fehler",
    text: "Diagnoseinterface gleich null in Klasse clsFutterKlappe",
  },
  1256: {
    category: "Fehler",
    text: "Interface Überwachung ist nicht initialisiert in Klasse clsFutterKlappe",
  },
  1257: { category: "Fehler", text: "Interface Anfrage Futterklappe ist null" },
  1258: {
    category: "Fehler",
    text: "Interface Anfrage Futterklappe kann nicht in einen digitalen Eingang konvertiert werden",
  },
  1259: {
    category: "Fehler",
    text: "Interface Elevatorband steuern ist nicht initialisiert in Klasse clsFutterKlappe",
  },
  1260: {
    category: "Fehler",
    text: "Interface Elevatorband steuern ist null in Klasse clsFutterKlappe",
  },
  1261: {
    category: "Fehler",
    text: "Interface Primus Management ist nicht initialisiert in Klasse clsFutterklappe",
  },
  1262: {
    category: "Fehler",
    text: "Interface Primus management ist null in Klasse clsFutterklappe",
  },
  1263: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Futterklappe",
  },
  1264: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Futterklappe",
  },
  1420: { category: "Fehler", text: "Diagnoseinterface Fräsarm ist ungültig" },
  1421: { category: "Fehler", text: "Interface Fräsarm zu Fräse ist ungültig" },
  1422: { category: "Fehler", text: "CAN-Interface Fräsarm ist ungültig" },
  1423: {
    category: "Fehler",
    text: "Gleichzeitige Bestromung Fräsarm heben und senken erkannt",
  },
  1424: {
    category: "Fehler",
    text: "Parameter-Interface für Fräsarm ist ungültig",
  },
  1425: {
    category: "Fehler",
    text: "Parameter Warnung Fräsdruck nicht gefunden",
  },
  1426: {
    category: "Fehler",
    text: "Interface Fräse ist nicht initialisiert für Fräsarm",
  },
  1427: {
    category: "Fehler",
    text: "Parameter max. Absenkstrom Fräsarm nicht gefunden",
  },
  1428: {
    category: "Fehler",
    text: "Parameter Maschinentyp in Fräsarm-Klasse nicht gefunden",
  },
  1429: {
    category: "Fehler",
    text: "Interface Freigaben für Fräsarm ist ungültig",
  },
  1430: { category: "Fehler", text: "Falsche Soll-Aktion für Fräsarm erkannt" },
  1431: {
    category: "Fehler",
    text: "Hebe-/Senkgeschwindigkeit des Fräsarmes ist außerhalb des zulässigen Bereiches",
  },
  1432: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Fräsarm gefunden",
  },
  1433: {
    category: "Fehler",
    text: "Nicht initialisierte Fräse für Fräsarm gefunden",
  },
  1434: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Fräsarm gefunden",
  },
  1435: {
    category: "Fehler",
    text: "Nicht initialisierter Parameret-Handler für Fräsarm gefunden",
  },
  1436: {
    category: "Fehler",
    text: "Nicht initialisierte Überwachung für Fräsarm gefunden",
  },
  1437: {
    category: "Fehler",
    text: "Can-Interface für neue Daten ist ungültig für Fräsarm",
  },
  1438: {
    category: "Fehler",
    text: "Ungültige Geschwindigkeit vom CAN-Bus für Fräsarm heben / senken",
  },
  1439: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Fräsarm in clsFraesarm gefunden",
  },
  1440: {
    category: "Fehler",
    text: "Interface PWM Ausgang Fräsarm heben ist ungültig",
  },
  1441: {
    category: "Fehler",
    text: "Interface PWM Ausgang Fräsarm senken ist ungültig",
  },
  1442: {
    category: "Fehler",
    text: "Interface PWM Ausgang Fräsarm Druckreduzierung ist ungültig",
  },
  1443: {
    category: "Fehler",
    text: "Interface Fahrantrieb ist nicht initialisiert in Klasse clsFraesarm",
  },
  1444: {
    category: "Fehler",
    text: "Interface Fahrantrieb ist null in Klasse clsFraesarm",
  },
  1445: {
    category: "Fehler",
    text: "Fahrgeschwindigkeit ist zu hoch, um den Fräsarm zu bewegen",
  },
  1446: {
    category: "Fehler",
    text: "Fräsarm kann nicht verfahren werden, bitte zunächst über Neutralposition gehen",
  },
  1447: { category: "Fehler", text: "Interface Position Fräsarm ist null" },
  1448: {
    category: "Fehler",
    text: "Interface Position Fräsarm kann nicht konvertiert werden",
  },
  1449: {
    category: "Fehler",
    text: "Sensor Position Fräsarm meldet einen Fehler",
  },
  1450: {
    category: "Fehler",
    text: "Fehler bei der Auswertung der Fräsarmposition",
  },
  1451: {
    category: "Fehler",
    text: "Fräsarm nicht auf Transportstellung. Bitte anheben!",
  },
  1452: {
    category: "Fehler",
    text: "Interface Management ist nicht initialisiert",
  },
  1453: { category: "Fehler", text: "Interface Management ist null" },
  1454: {
    category: "Fehler",
    text: "Transportstellung erreicht für Fahrmodus",
  },
  1455: {
    category: "Fehler",
    text: "Fräsarm nicht auf Transportstellung. Bitte absenken!",
  },
  1456: {
    category: "Fehler",
    text: "Interface itfInFraese_Zielgewicht ist ungültig",
  },
  1457: {
    category: "Fehler",
    text: "Zielgewicht zu 90% erreicht. Fraesarm wird verlangsamt",
  },
  1600: {
    category: "Fehler",
    text: "Diagnoseinterface ist nicht initialisiert in Klasse clsDosiertrichter",
  },
  1601: {
    category: "Fehler",
    text: "Diagnoseinterface ist null in clsDosiertrichter",
  },
  1602: {
    category: "Fehler",
    text: "Interface Anforderung Dosiertrichter ist null",
  },
  1603: {
    category: "Fehler",
    text: "Interface Ausgang Dosiertrichter schalten ist null",
  },
  1604: {
    category: "Fehler",
    text: "Interface Parameter ist nicht initialisiert in clsDosiertrichter",
  },
  1605: {
    category: "Fehler",
    text: "Interface Parameter ist null in clsDosiertrichter",
  },
  1606: {
    category: "Fehler",
    text: "Interface Überwachung ist nicht initialisiert in clsDosiertrichter",
  },
  1607: {
    category: "Fehler",
    text: "Interface Überwachung ist null in clsDosiertrichter",
  },
  1608: {
    category: "Fehler",
    text: "Interface Anfrage Dosiertrichter (Eingang) ist null",
  },
  1609: {
    category: "Fehler",
    text: "Interface Anfrage Dosiertrichter (Eingang) kann nicht konvertiert werden",
  },
  1610: {
    category: "Fehler",
    text: "Interface Ansteuerung Dosiertrichter (Ausgang) ist null",
  },
  1611: {
    category: "Fehler",
    text: "Interface Ansteuerung Dosiertrichter (Ausgang) kann nicht konvertiert werden",
  },
  1612: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Dosiertrichter in clsDosiertrichter gefunden",
  },
  1613: {
    category: "Fehler",
    text: "Interface Primus Management ist nicht initialisiert in Klasse clsDosiertrichter",
  },
  1614: {
    category: "Fehler",
    text: "Interface Primus management ist null in Klasse clsDosiertrichter",
  },
  1615: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik ist nicht initialisiert",
  },
  1616: { category: "Fehler", text: "Interface Vorwahlhydraulik ist null" },
  1617: {
    category: "Fehler",
    text: "Sperrventil Dosiertrichter kann nicht eingeschaltet werden",
  },
  1618: {
    category: "Fehler",
    text: "Vorwahlhydraulik Dosiertrichter kann nicht eingeschaltet werden",
  },
  1619: {
    category: "Fehler",
    text: "Interface Fahrantrieb ist nicht initialisiert",
  },
  1620: { category: "Fehler", text: "Interface Fahrantrieb ist null" },
  1621: {
    category: "Fehler",
    text: "Bitte Parkbremse für Dosiertrichter einlegen",
  },
  1901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  1902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  1903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  1904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  1905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  1906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  1907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  1908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  1909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  1910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  1911: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  1912: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  1913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  1914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  1915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  1916: { category: "Fehler", text: "PWM-Ausgang hat eine zu hohe Temperatur" },
  1917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  1918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  1919: { category: "Fehler", text: "Bereichsfehler PWM" },
  1920: { category: "Fehler", text: "Safety Fehler PWM" },
  1921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  1922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  1923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  1924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  1925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  1926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  1927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  1928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  1929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  1930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  1931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  1932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  1933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  1934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  1935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  1936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  1937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  1938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  1939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  1941: { category: "Fehler", text: "Digitaler Eingang zur Zeit in Benutzung" },
  1942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  1943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  1944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  1945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  1946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  1947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  1948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  1949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  1950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  1951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  1952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  1953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  1954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  1955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  1956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  1957: { category: "Fehler", text: "Digitaler Eingang Fehler Gruppenausgang" },
  1958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  1959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  1961: { category: "Fehler", text: "Digitaler Ausgang zur Zeit in Benutzung" },
  1962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  1963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  1964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  1965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  1966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  1967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  1968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  1969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  1970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  1971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  1972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  1973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  1974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  1975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  1976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  1977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  1978: { category: "Fehler", text: "Digitaler Ausgang Fehler Gruppenausgang" },
  1979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  1980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  1981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  1982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  1983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  1984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  1985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  1986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  1987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  1988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  1989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  1990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  1991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  1992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  1993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  1994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  1995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  1996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  1997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  1998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  1999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  2001: { category: "Fehler", text: "Falsche Position Schieber 1 angegeben" },
  2002: { category: "Fehler", text: "Falsche Position Schieber 2 angegeben" },
  2003: { category: "Fehler", text: "Falsche Position Schieber 3 angegeben" },
  2004: { category: "Fehler", text: "Falsche Position Schieber 4 angegeben" },
  2005: { category: "Fehler", text: "Falsche Schiebernummer angegeben" },
  2006: {
    category: "Fehler",
    text: "Diagnoseinterface Schieber 1 ist ungültig",
  },
  2007: {
    category: "Fehler",
    text: "Diagnoseinterface Schieber 2 ist ungültig",
  },
  2008: {
    category: "Fehler",
    text: "Diagnoseinterface Schieber 3 ist ungültig",
  },
  2009: {
    category: "Fehler",
    text: "Diagnoseinterface Schieber 4 ist ungültig",
  },
  2010: { category: "Fehler", text: "CAN-Interface Schieber 1 ist ungültig" },
  2011: { category: "Fehler", text: "CAN-Interface Schieber 2 ist ungültig" },
  2012: { category: "Fehler", text: "CAN-Interface Schieber 3 ist ungültig" },
  2013: { category: "Fehler", text: "CAN-Interface Schieber 4 ist ungültig" },
  2014: {
    category: "Fehler",
    text: "Ungültige Aktion für Schieber 1 empfangen",
  },
  2015: {
    category: "Fehler",
    text: "Ungültige Aktion für Schieber 2 empfangen",
  },
  2016: {
    category: "Fehler",
    text: "Ungültige Aktion für Schieber 3 empfangen",
  },
  2017: {
    category: "Fehler",
    text: "Ungültige Aktion für Schieber 4 empfangen",
  },
  2018: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik für Schieber 1 ist ungültig",
  },
  2019: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik für Schieber 2 ist ungültig",
  },
  2020: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik für Schieber 3 ist ungültig",
  },
  2021: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik für Schieber 4 ist ungültig",
  },
  2022: {
    category: "Fehler",
    text: "Parameter-Interface für Dosierschieber 1 ist ungültig",
  },
  2023: {
    category: "Fehler",
    text: "Parameter-Interface für Dosierschieber 2 ist ungültig",
  },
  2024: {
    category: "Fehler",
    text: "Parameter-Interface für Dosierschieber 3 ist ungültig",
  },
  2025: {
    category: "Fehler",
    text: "Parameter-Interface für Dosierschieber 4 ist ungültig",
  },
  2026: {
    category: "Fehler",
    text: "Interface Freigaben für Dosierschieber ist ungültig",
  },
  2027: {
    category: "Fehler",
    text: "Maschinentyp konnte in clsDosierschieber nicht gelesen werden",
  },
  2028: {
    category: "Fehler",
    text: "Ungültiger Fahrzeugtyp gefunden in clsDosierschieber",
  },
  2029: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Dosierschieber gefunden",
  },
  2030: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Dosierschieber gefunden",
  },
  2031: {
    category: "Fehler",
    text: "Nicht initialisierte Überwachung für Dosierschieber gefunden",
  },
  2032: {
    category: "Fehler",
    text: "Nicht initialisierte Vorwahlhydraulik für Dosierschieber gefunden",
  },
  2033: {
    category: "Fehler",
    text: "Nicht initialisierter Parameter-Handler für Dosierschieber gefunden",
  },
  2034: {
    category: "Fehler",
    text: "Eingehendes CAN-Gerät ist null in Klasse Dosierschieber",
  },
  2035: { category: "Fehler", text: "Ungültige Schieberposition gefunden" },
  2036: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Dosierschieber in clsDosierschieber gefunden",
  },
  2037: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Dosierschieber",
  },
  2038: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Dosierschieber",
  },
  2039: {
    category: "Fehler",
    text: "Interface des analogen Einganges Schieber 1 Position ist ungültig",
  },
  2040: {
    category: "Fehler",
    text: "Interface des analogen Einganges Schieber 2 Position ist ungültig",
  },
  2041: {
    category: "Fehler",
    text: "Interface des analogen Einganges Schieber 3 Position ist ungültig",
  },
  2042: {
    category: "Fehler",
    text: "Interface des analogen Einganges Schieber 4 Position ist ungültig",
  },
  2043: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Ansteuerung Schieber 1 ist ungültig",
  },
  2044: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Ansteuerung Schieber 2 ist ungültig",
  },
  2045: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Ansteuerung Schieber 3 ist ungültig",
  },
  2046: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Ansteuerung Schieber 4 ist ungültig",
  },
  2047: {
    category: "Fehler",
    text: "Vorwahl des Schiebers ist undefiniert in clsDosierschieber",
  },
  2048: {
    category: "Fehler",
    text: "Interface Primus-Management ist nicht initialisiert in Klasse clsDosierschieber",
  },
  2049: {
    category: "Fehler",
    text: "Interface Primus-Management ist null in Klasse clsDosierschieber",
  },
  2050: {
    category: "Fehler",
    text: "Betriebsmodus in Klasse clsDosierschieber ist ungültig",
  },
  2051: {
    category: "Fehler",
    text: "Parameter Ruhestrom Ventile kann nicht gelesen werden in Klasse clsDosierschieber",
  },
  2052: {
    category: "Fehler",
    text: "Schieber kann nicht geöffnet werden, bitte zunächst über Neutralposition gehen",
  },
  2053: {
    category: "Fehler",
    text: "Schieber kann nicht geschlossen werden, bitte zunächst über Neutralposition gehen",
  },
  2054: {
    category: "Fehler",
    text: "Bereichsfehler bei der Schieberposition erkannt.",
  },
  2055: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  2056: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  2057: { category: "Fehler", text: "Sensorfehler Position Dosierschieber" },
  2058: { category: "Fehler", text: "Ungültige Position Dosierschieber" },
  2060: {
    category: "Fehler",
    text: "Diagnoseinterface Austragsband 1 ist ungültig",
  },
  2061: {
    category: "Fehler",
    text: "Diagnoseinterface Austragsband 2 ist ungültig",
  },
  2062: {
    category: "Fehler",
    text: "CAN-Interface Austragsband 1 ist ungültig",
  },
  2063: {
    category: "Fehler",
    text: "CAN-Interface Austragsband 2 ist ungültig",
  },
  2064: {
    category: "Fehler",
    text: "Falsche Bandnummer für Austragsband angegeben",
  },
  2065: {
    category: "Fehler",
    text: "Falsche Bandposition für Austragsband 1 konfiguriert",
  },
  2066: {
    category: "Fehler",
    text: "Falsche Bandposition für Austragsband 2 konfiguriert",
  },
  2067: {
    category: "Fehler",
    text: "Gleichzeitige Bestromung Gleichlauf und Gegenlauf Förderband 1",
  },
  2068: {
    category: "Fehler",
    text: "Gleichzeitige Bestromung Gleichlauf und Gegenlauf Förderband 2",
  },
  2069: {
    category: "Fehler",
    text: "Interface Vorwahlhydraulik für Austragsband ist ungültig",
  },
  2070: {
    category: "Fehler",
    text: "Interface Freigaben für Querband ist ungültig",
  },
  2071: {
    category: "Fehler",
    text: "PWM Ausgänge Querband Links- und Rechtslauf gleichzeitig aktiv",
  },
  2072: {
    category: "Fehler",
    text: "Band 2 soll laufen, ist aber nicht verbaut",
  },
  2073: {
    category: "Fehler",
    text: "Direkte Umschaltung von Linkslauf nach Rechtslauf oder umgekehrt erkannt",
  },
  2074: {
    category: "Fehler",
    text: "Falsche Laufrichtung für Querband erkannt",
  },
  2075: {
    category: "Fehler",
    text: "Kein gültiges Interface für das Master-Querband vorhanden",
  },
  2076: {
    category: "Fehler",
    text: "Band kann nicht anlaufen - falsche Drehrichtung gesetzt",
  },
  2077: { category: "Fehler", text: "Falsche Bandnummer erkannt" },
  2078: {
    category: "Fehler",
    text: "Linkslauf für Querband kann nicht aktiviert werden - falsche Laufrichtung erkannt",
  },
  2079: {
    category: "Fehler",
    text: "Rechtslauf für Querband kann nicht aktiviert werden - falsche Laufrichtung erkannt",
  },
  2080: {
    category: "Fehler",
    text: "Ungültige Soll-Laufrichtung für Band 2 erkannt",
  },
  2081: {
    category: "Fehler",
    text: "Ungültige Auswahl Ansteuerung Band 2 erkannt",
  },
  2082: {
    category: "Fehler",
    text: "Direkter Richtungswechsel für Querband erkannt",
  },
  2083: {
    category: "Fehler",
    text: "Unzulässige Veränderung der Bandposition für aktuelles Band erkannt",
  },
  2084: {
    category: "Fehler",
    text: "Nicht initialisierte Vorwahlhydraulik für Austragsband gefunden",
  },
  2085: {
    category: "Fehler",
    text: "Master-Querband ist nicht initialisiert für Austragsband",
  },
  2086: {
    category: "Fehler",
    text: "Eingehendes CAN-Gerät ist null in Klasse Austragsband",
  },
  2087: {
    category: "Fehler",
    text: "Unzulässige Soll-Geschwindigkeit für Austragsband gefunden",
  },
  2088: {
    category: "Fehler",
    text: "Unzulässige Laufrichtung für Austragsband",
  },
  2089: {
    category: "Fehler",
    text: "Unzulässige Vorwahl des zu verschiebenden Austragsbandes",
  },
  2090: {
    category: "Fehler",
    text: "Unzulässige Vorwahl der Arbeitsfunktion Austragsband",
  },
  2091: {
    category: "Fehler",
    text: "Undefinierter Bandtyp für Austragsband gefunden",
  },
  2092: {
    category: "Fehler",
    text: "Ungültige Bandnummer für Masterband erkannt",
  },
  2093: {
    category: "Fehler",
    text: "Ungültige Bandnummer für Austragsband erkannt",
  },
  2094: {
    category: "Fehler",
    text: "Ungültige Bandposition für Austragsband erkannt",
  },
  2095: {
    category: "Fehler",
    text: "Eingehender Bandtyp passt nicht zu eingehender Bandposition",
  },
  2096: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Austragsband in clsAustragsband gefunden",
  },
  2097: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Linkslauf ist ungültig",
  },
  2098: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Rechtslauf ist ungültig",
  },
  2099: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Verschieben Band 1 ist ungültig",
  },
  2100: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Verschieben Band 2 ist ungültig",
  },
  2101: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Band 1 Gleichlauf ist ungültig",
  },
  2102: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Band 1 Gegenlauf ist ungültig",
  },
  2103: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Band 2 Gleichlauf ist ungültig",
  },
  2104: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Band 2 Gegenlauf ist ungültig",
  },
  2105: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Position Band 1 ist ungültig",
  },
  2106: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Position Band 2 ist ungültig",
  },
  2107: {
    category: "Fehler",
    text: "Ungultiger Zustand Gleichlauf / Gegenlauf erkannt für Austragsband",
  },
  2108: {
    category: "Fehler",
    text: "Ungültige Laufrichtung für Austragsband erkannt bei Prüfung senden zum Display",
  },
  2109: {
    category: "Fehler",
    text: "Interface Primus-Management ist nicht initialisiert in Klasse clsFraese",
  },
  2110: {
    category: "Fehler",
    text: "Interface Primus-Management ist null in Klasse clsFraese",
  },
  2111: {
    category: "Fehler",
    text: "Betriebsmodus in Klasse clsAustragsband ist ungültig",
  },
  2112: {
    category: "Fehler",
    text: "Analoge Sensor Bandposition Austragsband gibt einen Fehler aus",
  },
  2113: {
    category: "Fehler",
    text: "Austragsband kann nicht eingeschaltet werden, bitte zunächst in Neutralposition schalten",
  },
  2114: { category: "Fehler", text: "Sensorfehler Position Austragsband" },
  2140: {
    category: "Fehler",
    text: "Diagnoseinterface Förderband ist ungültig",
  },
  2141: { category: "Fehler", text: "CAN-Interface Förderband ist ungültig" },
  2142: {
    category: "Fehler",
    text: "Interface Freigaben für Förderband ist ungültig",
  },
  2143: {
    category: "Fehler",
    text: "Laufrichtung des Förderbandes ist undefiniert. Kann Laufrichtung nicht setzen",
  },
  2144: {
    category: "Fehler",
    text: "Zu setzende Geschwindigkeit des Förderbandes ist außerhalb des gültigen Bereiches",
  },
  2145: {
    category: "Fehler",
    text: "Ungültige Soll-Drehrichtung des Förderbands erkannt",
  },
  2146: {
    category: "Fehler",
    text: "Zu setzende vorherige Geschwindigkeit des Förderbandes ist außerhalb des gültigen Bereiches",
  },
  2147: {
    category: "Fehler",
    text: "Undefinierter Bandtyp gefunden für Förderband",
  },
  2148: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Förderband gefunden",
  },
  2149: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Förderband gefunden",
  },
  2150: {
    category: "Fehler",
    text: "Nicht initialisierte Ueberwachung für Förderband gefunden",
  },
  2151: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Förderband in clsFoerderband gefunden",
  },
  2152: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Förderband",
  },
  2153: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Förderband",
  },
  2154: {
    category: "Fehler",
    text: "Interface Primus Management ist nicht initialisiert in Klasse clsFoerderband",
  },
  2155: {
    category: "Fehler",
    text: "Interface Primus Management ist null in Klasse clsFoerderband",
  },
  2156: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  2157: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  2180: {
    category: "Fehler",
    text: "Diagnoseinterface für die Einstreuwalze ist ungültig",
  },
  2181: {
    category: "Fehler",
    text: "Gleichzeitiges Signal für Einstreuwalze hoch- und runterfahren erkannt",
  },
  2182: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Einstreuwalze gefunden",
  },
  2400: { category: "Fehler", text: "Diagnoseinterface Mischer ist ungültig" },
  2401: { category: "Fehler", text: "CAN-Interface Mischer ist ungültig" },
  2402: {
    category: "Fehler",
    text: "Interface Freigaben für Mischer ist ungültig",
  },
  2403: { category: "Fehler", text: "Ungültige Aktion für Mischer gefunden" },
  2404: {
    category: "Fehler",
    text: "Ungültige Geschwindigkeit für den Mischer gefunden",
  },
  2405: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Mischer gefunden",
  },
  2406: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Mischer gefunden",
  },
  2407: {
    category: "Fehler",
    text: "Nicht initialisierte Überwachung für Mischer gefunden",
  },
  2408: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Mischer gefunden",
  },
  2409: {
    category: "Fehler",
    text: "Soll-Geschwindigkeit für Mischer ist nicht zulässig",
  },
  2410: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Mischer in clsMischer gefunden",
  },
  2411: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Mischer",
  },
  2412: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Mischer",
  },
  2413: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Mischer-Pumpe ist ungültig",
  },
  2414: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Mischer-Motor ist ungültig",
  },
  2415: {
    category: "Fehler",
    text: "Interface des Frequenz-Einganges Drehzahl Mischer ist ungültig",
  },
  2416: {
    category: "Fehler",
    text: "Keypad-Beleuchtung konnte nicht gesetzt werden für den Mischer",
  },
  2417: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist null in Klasse clsMischer",
  },
  2418: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist nicht initialisiert in Klasse clsMischer",
  },
  2419: {
    category: "Fehler",
    text: "Interface zum Diesel ist ungültig in Klasse clsMischer",
  },
  2420: {
    category: "Fehler",
    text: "Interface zum Diesel ist nicht initialisiert in Klasse clsMischer",
  },
  2421: {
    category: "Fehler",
    text: "Mischer kann nicht eingeschaltet werden, bitte erneut einschalten",
  },
  2422: {
    category: "Fehler",
    text: "Interface Primus Management ist nicht initialisiert in Klasse clsMischer",
  },
  2423: {
    category: "Fehler",
    text: "Interface Primus Management ist null in Klasse clsMischer",
  },
  2424: {
    category: "Fehler",
    text: "Schwerwiegender Fehler im Mischer erkannt. Bitte Maschine umgehend abstellen!",
  },
  2425: {
    category: "Fehler",
    text: "Ungültiger Fahrzeugtyp in Klasse clsMischer gefunden",
  },
  2426: {
    category: "Fehler",
    text: "Ungültiger Wert für die Geschwindigkeit der Mischerpumpe gefunden",
  },
  2427: {
    category: "Fehler",
    text: "Ungültiger Wert für die Geschwindigkeit des Mischermotors gefunden",
  },
  2428: {
    category: "Fehler",
    text: "Bestromung des Mischermotors kann nicht berechnet werden",
  },
  2429: {
    category: "Fehler",
    text: "Bestromung des Mischermotors kann nicht berechnet werden - Division durch 0 gefunden",
  },
  2430: {
    category: "Fehler",
    text: "Mischer ist blockiert. Bitte Mischergeschwindigkeit herabsetzen",
  },
  2431: {
    category: "Fehler",
    text: "Aktuelle Drehzahl Mischer größer als Maximalwert",
  },
  2432: {
    category: "Fehler",
    text: "Interface Vorgabe Mischer aus für Can ist nicht initialisiert",
  },
  2433: {
    category: "Fehler",
    text: "Interface Vorgabe Mischer aus für Can ist null",
  },
  2434: {
    category: "Fehler",
    text: "Ungültiger Zustand Mischer ausschalten via Display erkannt",
  },
  2435: {
    category: "Fehler",
    text: "Interface Konfigurationswerte Drehzahl Mischer kann nicht gesetzt werden",
  },
  2436: {
    category: "Fehler",
    text: "Konfigurationsfehler: Maximale Frequenz Drehzahl Mischer ist auf 0 gesetzt",
  },
  2437: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  2438: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  2439: { category: "Fehler", text: "Sensorfehler Frequenz Mischer" },
  2440: { category: "Fehler", text: "Automatischer Wiederanlauf des Mischers" },
  2441: {
    category: "Fehler",
    text: "Interface zu Analog-Eingang Mischerdruck ist ungültig",
  },
  2442: {
    category: "Fehler",
    text: "Interface itfDrehzahlManagement_Mischer ist ungültig",
  },
  2443: {
    category: "Fehler",
    text: "Mischer kann nicht gestartet werden. Schieber sind geöffnet, das Band läuft nicht",
  },
  2901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  2902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  2903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  2904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  2905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  2906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  2907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  2908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  2909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  2910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  2911: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  2912: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  2913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  2914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  2915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  2916: { category: "Fehler", text: "PWM-Ausgang hat eine zu hohe Temperatur" },
  2917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  2918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  2919: { category: "Fehler", text: "Bereichsfehler PWM" },
  2920: { category: "Fehler", text: "Safety Fehler PWM" },
  2921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  2922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  2923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  2924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  2925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  2926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  2927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  2928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  2929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  2930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  2931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  2932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  2933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  2934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  2935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  2936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  2937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  2938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  2939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  2941: { category: "Fehler", text: "Digitaler Eingang zur Zeit in Benutzung" },
  2942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  2943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  2944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  2945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  2946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  2947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  2948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  2949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  2950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  2951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  2952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  2953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  2954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  2955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  2956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  2957: { category: "Fehler", text: "Digitaler Eingang Fehler Gruppenausgang" },
  2958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  2959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  2961: { category: "Fehler", text: "Digitaler Ausgang zur Zeit in Benutzung" },
  2962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  2963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  2964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  2965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  2966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  2967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  2968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  2969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  2970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  2971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  2972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  2973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  2974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  2975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  2976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  2977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  2978: { category: "Fehler", text: "Digitaler Ausgang Fehler Gruppenausgang" },
  2979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  2980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  2981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  2982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  2983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  2984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  2985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  2986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  2987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  2988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  2989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  2990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  2991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  2992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  2993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  2994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  2995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  2996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  2997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  2998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  2999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  3001: { category: "Fehler", text: "Interface Vorwahlhydraulik ungültig" },
  3002: { category: "Fehler", text: "Diagnoseinterface CanBus ungültig" },
  3003: {
    category: "Fehler",
    text: "Parameter-Interface für j1939 ist ungültig",
  },
  3004: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Can-Bus gefunden",
  },
  3005: {
    category: "Fehler",
    text: "Nicht initialisierte Vorwahlhydraulik für J1939 Can Bus gefunden",
  },
  3006: {
    category: "Fehler",
    text: "Nicht initialisierter Parameter-Handler für J1939 Can Bus gefunden",
  },
  3007: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse in J1939 CAN Bus gefunden",
  },
  3008: {
    category: "Fehler",
    text: "Interface für Parameter Maschinentyp hat einen ungültigen Datentyp",
  },
  3009: {
    category: "Fehler",
    text: "Ungültiges CAN-Gerät fragt Daten an Can Schnittstelle an",
  },
  3010: {
    category: "Fehler",
    text: "Gelesenes CAN-Gerät in CAN J1939 ist null",
  },
  3011: {
    category: "Fehler",
    text: "Gelesener Parameter für CAN-Gerät kann nicht in boolschen Wert konvertiert werden",
  },
  3012: { category: "Fehler", text: "Parameter-Handler ist null in CAN J1939" },
  3013: {
    category: "Fehler",
    text: "Parameter-Handler ist nicht initialisiert in CAN J1939",
  },
  3014: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse in CAN Bus gefunden",
  },
  3015: {
    category: "Fehler",
    text: "Eingehendes CAN-Gerät ist null in Klasse Bus",
  },
  3016: {
    category: "Fehler",
    text: "Eingehendes CAN-Gerät ist null in Klasse J1939",
  },
  3017: {
    category: "Fehler",
    text: "Kann Can-Arbeitsfunktion nicht zur Liste hinzufügen",
  },
  3018: {
    category: "Fehler",
    text: "Kann Can-Arbeitsfunktion nicht aus der Liste löschen",
  },
  3019: {
    category: "Fehler",
    text: "Eingehender Dosierschieber ist nicht initialisiert in CAN J1939",
  },
  3020: {
    category: "Fehler",
    text: "Eingehendes Austragsband ist nicht initialisiert in CAN J1939",
  },
  3021: {
    category: "Fehler",
    text: "Eingehende Fräse ist nicht initialisiert in CAN J1939",
  },
  3022: {
    category: "Fehler",
    text: "Eingehender Fräsarm ist nicht initialisiert in CAN J1939",
  },
  3023: {
    category: "Fehler",
    text: "Eingehender Fräswalzenschutz ist nicht initialisiert in CAN J1939",
  },
  3024: {
    category: "Fehler",
    text: "Eingehender Mischer ist nicht initialisiert in CAN J1939",
  },
  3025: {
    category: "Fehler",
    text: "Eingehende Gegenschneiden sind nicht initialisiert in CAN J1939",
  },
  3026: {
    category: "Fehler",
    text: "Eingehendes Elevatorband ist nicht initialisiert in CAN J1939",
  },
  3027: {
    category: "Fehler",
    text: "Eingehendes CAN-Gerät ist nicht in der Liste verwalteter Geräte in clsJ1939",
  },
  3028: {
    category: "Fehler",
    text: "Fehler bei der Überprüfung des eingehenden CAN-Gerätes in clsJ1939",
  },
  3029: {
    category: "Fehler",
    text: "Mehr als ein aktiver Schieber für Sherpa/Primus400 gefunden",
  },
  3030: { category: "Fehler", text: "Kein Schieber gefunden in J1939" },
  3031: {
    category: "Fehler",
    text: "Zu viele Schieber gefunden für Fahrzeugtyp in clsJ1939",
  },
  3032: {
    category: "Fehler",
    text: "Ungültige Geschwindigkeit für Mischer erkannt in clsJ1939",
  },
  3033: {
    category: "Fehler",
    text: "Undefinierte Vorwahl für Schieber in clsJ1939 gefunden",
  },
  3034: {
    category: "Fehler",
    text: "Undefinierte Vorwahl für Austragsband in clsJ1939 gefunden",
  },
  3035: {
    category: "Fehler",
    text: "Fehlerhafte Laufrichtung für Austragsband in clsJ1939 gefunden",
  },
  3036: {
    category: "Fehler",
    text: "Undefinierte Vorwahl Verstellung Austrageband in clsJ1939 gefunden",
  },
  3037: {
    category: "Fehler",
    text: "Fehlerhafte Drehrichtung für Fräse in clsJ1939 erkannt",
  },
  3038: {
    category: "Fehler",
    text: "Fehlerhafte Geschwindigkeit Fräse in clsJ1939 gefunden",
  },
  3039: {
    category: "Fehler",
    text: "Fehlerhafte Geschwindigkeit Fräsarm heben/senken gefunden in clsJ1939",
  },
  3040: {
    category: "Fehler",
    text: "Ungültige Laufrichtung für Elevatorband in clsJ1939 gefunden",
  },
  3041: {
    category: "Fehler",
    text: "Fehlerhafte Geschwindigkeit für Elevatorband gefunden in clsJ1939",
  },
  3042: {
    category: "Fehler",
    text: "Interface Elevatorband für Fräse in clsJ1939 ist null",
  },
  3043: {
    category: "Fehler",
    text: "Direkter Wechsel Band verfahren von links nach rechts oder umgekehrt erkannt",
  },
  3044: { category: "Fehler", text: "Eingehendes Band ist null in clsJ1939" },
  3045: {
    category: "Fehler",
    text: "Ungültige Austragsband-Geschwindigkeit in clsJ1939 gefunden",
  },
  3046: {
    category: "Fehler",
    text: "Ungültiger Betriebsmodus in CAN J1939 für Fahrantrieb gefunden",
  },
  3047: {
    category: "Fehler",
    text: "Ungültige Soll-Drehzahl für den Diesel gefunden in J1939",
  },
  3048: {
    category: "Fehler",
    text: "Ungültiger Antriebsmodus in J1939 gefunden",
  },
  3049: {
    category: "Fehler",
    text: "Ungültige Fahrtrichtung in J1939 erkannt",
  },
  3050: {
    category: "Fehler",
    text: "Ungültiger Wert für Handgas in J1939 gefunden",
  },
  3051: {
    category: "Fehler",
    text: "Fahrantrieb ist nicht initialisiert in J1939",
  },
  3052: {
    category: "Fehler",
    text: "Ungültiger Schaltzustand für ASW Aufnahme gefunden in Can J1939",
  },
  3053: {
    category: "Fehler",
    text: "Ungültiger Schaltzustand für ASW Austrag gefunden in Can J1939",
  },
  3054: {
    category: "Fehler",
    text: "Ungültiger Schaltzustand für Bremslicht gefunden in Can J1939",
  },
  3055: {
    category: "Fehler",
    text: "Ungültiger Schaltzustand für Betriebsmodus gefunden in Can J1939",
  },
  3056: {
    category: "Fehler",
    text: "Nicht initialisierte Lichtanlage in CAN J1939 gefunden",
  },
  3057: { category: "Fehler", text: "CAN Gerät ist bereits angemeldet" },
  3058: { category: "Fehler", text: "Fehler Joystick CAN" },
  3059: {
    category: "Fehler",
    text: "Ungültige Keypad-Sender Adresse gefunden",
  },
  3060: { category: "Fehler", text: "Fehler Keypad CAN" },
  3061: {
    category: "Fehler",
    text: "Ungültige LED-Indikator Nummer für Keypad gefunden",
  },
  3062: {
    category: "Fehler",
    text: "Diagnose-Interface Abblendlicht kann nicht konvertiert werden in Bool",
  },
  3063: {
    category: "Fehler",
    text: "Bereichsfehler Gessmann Joystick-Achse Fräsen",
  },
  3064: {
    category: "Fehler",
    text: "Bereichsfehler Gessmann Joystick-Achse Fräsarm heben / senken",
  },
  3065: {
    category: "Fehler",
    text: "Bereichsfehler Gessmann Joystick-Achse Drehzahl Mischer",
  },
  3066: {
    category: "Fehler",
    text: "Bereichsfehler Gessmann Joystick-Achse Handgas",
  },
  3067: {
    category: "Fehler",
    text: "Bereichsfehler Gessmann Joystick-Achse Drehzahl Förderband",
  },
  3068: {
    category: "Fehler",
    text: "Eingehendes Interface der Überwachung ist null",
  },
  3069: {
    category: "Fehler",
    text: "Eingehendes Interface konnte in keinen CAN-Typ umgewandelt werden",
  },
  3070: { category: "Fehler", text: "Fehler Joystick fräsen erkannt" },
  3071: {
    category: "Fehler",
    text: "Fehler Joystick Fräsarm heben/senken erkannt",
  },
  3072: {
    category: "Fehler",
    text: "Fehler Joystick Laufrichtung Förderband erkannt",
  },
  3073: {
    category: "Fehler",
    text: "Fehler Joystick Universalwippe AUX erkannt",
  },
  3074: { category: "Fehler", text: "Fehler Joystick FNR erkannt" },
  3075: {
    category: "Fehler",
    text: "Fehler Armlehne Geschwindigkeit Mischer erkannt",
  },
  3076: { category: "Fehler", text: "Fehler Armlehne Handgas erkannt" },
  3077: {
    category: "Fehler",
    text: "Fehler Armlehne Geschwindigkeit Band erkannt",
  },
  3078: {
    category: "Fehler",
    text: "Fehler Joystick Button Fräswalzenschutz erkannt",
  },
  3079: {
    category: "Fehler",
    text: "Fehler Joystick Button Schieber 1 erkannt",
  },
  3080: {
    category: "Fehler",
    text: "Fehler Joystick Button Schieber 2 erkannt",
  },
  3081: {
    category: "Fehler",
    text: "Fehler Joystick Button Band verfahren erkannt",
  },
  3082: { category: "Fehler", text: "Fehler Joystick Button AUX erkannt" },
  3083: { category: "Fehler", text: "Fehler Keypad ASW Aufnahme erkannt" },
  3084: { category: "Fehler", text: "Fehler Keypad Allrad erkannt" },
  3085: {
    category: "Fehler",
    text: "Fehler Keypad Spiegelarm-Verstellung erkannt",
  },
  3086: { category: "Fehler", text: "Fehler Keypad Straßenfahrt erkannt" },
  3087: { category: "Fehler", text: "Fehler Keypad ASW Austrag erkannt" },
  3088: { category: "Fehler", text: "Fehler Keypad Vierrad-Lenkung erkannt" },
  3089: { category: "Fehler", text: "Fehler Keypad Mischerstufe erkannt" },
  3090: { category: "Fehler", text: "Fehler Keypad Arbeitsmodus erkannt" },
  3091: { category: "Fehler", text: "Fehler Keypad Schieber 3 erkannt" },
  3092: { category: "Fehler", text: "Fehler Keypad Gegenschneiden erkannt" },
  3093: {
    category: "Fehler",
    text: "Fehler Keypad Automatik Aufnahme erkannt",
  },
  3094: { category: "Fehler", text: "Fehler Keypad Schieber 4 erkannt" },
  3095: {
    category: "Fehler",
    text: "Fehler Keypad Förderband verschieben umschalten erkannt",
  },
  3096: { category: "Fehler", text: "Fehler Keypad Automatik Austrag erkannt" },
  3097: {
    category: "Fehler",
    text: "Fehler Gegenschneiden: Wippe hat Status aus übersprungen",
  },
  3098: {
    category: "Fehler",
    text: "CAN Schieber-Interface in leseDaten ist null",
  },
  3099: {
    category: "Fehler",
    text: "CAN Band-Interface in leseDaten ist null",
  },
  3100: {
    category: "Fehler",
    text: "CAN Fräse-Interface in leseDaten ist null",
  },
  3101: {
    category: "Fehler",
    text: "CAN Fräsarm-Interface in leseDaten ist null",
  },
  3102: {
    category: "Fehler",
    text: "CAN Fräswalzenschutz-Interface in leseDaten ist null",
  },
  3103: {
    category: "Fehler",
    text: "CAN Mischer-Interface in leseDaten ist null",
  },
  3104: {
    category: "Fehler",
    text: "CAN Gegenschneiden-Interface in leseDaten ist null",
  },
  3105: {
    category: "Fehler",
    text: "CAN Elevator-Interface in leseDaten ist null",
  },
  3106: {
    category: "Fehler",
    text: "CAN Lichtanlage-Interface in leseDaten ist null",
  },
  3107: {
    category: "Fehler",
    text: "CAN Fahrantrieb-Interface in leseDaten ist null",
  },
  3108: {
    category: "Fehler",
    text: "CAN Diesel-Interface in leseDaten ist null",
  },
  3109: {
    category: "Fehler",
    text: "CAN Diesel Drehzahl ist außerhalb des zulässigen Bereiches",
  },
  3110: {
    category: "Fehler",
    text: "Fehlerhafter Zustand Motor-Protection Lamp gefunden",
  },
  3111: {
    category: "Fehler",
    text: "Fehlerhafter Zustand Motor-Amber Warn Lamp",
  },
  3112: {
    category: "Fehler",
    text: "Fehlerhafter Zustand Motor-Red Stop Lamp",
  },
  3113: {
    category: "Fehler",
    text: "Fehlerhafter Zustand Motor-Malfunction Indicator Lamp",
  },
  3114: {
    category: "Fehler",
    text: "Fehlerhafter Zustand Motor-Flash Protection Lamp",
  },
  3115: {
    category: "Fehler",
    text: "Fehlerhafter Zustand Motor-Flash Amber Warning Lamp AWL",
  },
  3116: {
    category: "Fehler",
    text: "Fehlerhafter Zustand Motor-Red Stop Lamp RSL",
  },
  3117: {
    category: "Fehler",
    text: "Fehlerhafter Zustand Motor-Flash Malfunction Indicator Lamp MIL",
  },
  3118: {
    category: "Fehler",
    text: "Fehlerhaften Failure Mode Identifier (FMI) für Diesel gefunden",
  },
  3119: { category: "Fehler", text: "Motorfehler durch SPN gefunden" },
  3120: {
    category: "Fehler",
    text: "Diesel Temperatur Kuehlmittel außerhalb des zulässigen Bereiches",
  },
  3121: { category: "Fehler", text: "Diesel DEF Level ist größer als 100%" },
  3122: {
    category: "Fehler",
    text: "Diesel DEF Warnung - CAN-Wert ist außerhalb des zulässigen Bereiches",
  },
  3123: {
    category: "Fehler",
    text: "Diesel SCR-Level - CAN-Wert ist außerhalb des zulässigen Bereiches",
  },
  3124: {
    category: "Fehler",
    text: "Diesel Motor zu kalt für Start - CAN-Wert ist außerhalb des zulässigen Bereiches",
  },
  3125: {
    category: "Fehler",
    text: "Diesel Abgastemperatur zu hoch Lampe - CAN-Wert ist außerhalb des zulässigen Bereiches",
  },
  3126: {
    category: "Fehler",
    text: "Diesel DPF Lampe - CAN-Wert ist außerhalb des zulässigen Bereiches",
  },
  3127: {
    category: "Fehler",
    text: "Diesel Regeneration abgebrochen durch Switch - CAN-Wert ist außerhalb des zulässigen Bereiches",
  },
  3128: {
    category: "Fehler",
    text: "Diesel DPF Status - CAN-Wert ist außerhalb des zulässigen Bereiches",
  },
  3129: { category: "Fehler", text: "Betriebsmodus ist ungültig in clsJ1939" },
  3130: {
    category: "Fehler",
    text: "CAN-Wert der Kühlmitteltemperatur ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3131: {
    category: "Fehler",
    text: "CAN-Wert für Handgas ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3132: {
    category: "Fehler",
    text: "CAN-Wert für SPN ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3133: {
    category: "Fehler",
    text: "CAN-Wert für FMI ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3134: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe flash amber warning lamp awl ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3135: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe Flash malfunction indicator mil ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3136: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe flash red stop lamp rsl ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3137: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe flash protection lamp ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3138: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe malfunction indicator lamp ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3139: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe Amber Warn lamp ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3140: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe red stop lamp ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3141: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lamp Protect lamp ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3142: {
    category: "Fehler",
    text: "CAN-Wert für DEF-Level Tank ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3143: {
    category: "Fehler",
    text: "CAN-Wert für DEF-Warnung ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3144: {
    category: "Fehler",
    text: "CAN-Wert für SCR Level ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3145: {
    category: "Fehler",
    text: "CAN-Wert für Engine wait to start lamp ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3146: {
    category: "Fehler",
    text: "CAN-Wert für Exhaust system high temperature lamp command ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3147: {
    category: "Fehler",
    text: "CAN-Wert für Diesel particulate filter lamp ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3148: {
    category: "Fehler",
    text: "CAN-Wert für Diesel particulate filter active regeneration inhibited due to inhibit switch ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3149: {
    category: "Fehler",
    text: "CAN-Wert für Diesel particulate filter status ist außerhalb des zuläsigen Bereiches in clsJ1939",
  },
  3150: {
    category: "Fehler",
    text: "CAN Primus Management-Interface in leseDaten ist null",
  },
  3151: {
    category: "Fehler",
    text: "Betriebsmodus ist undefiniert in clsJ1939",
  },
  3152: {
    category: "Fehler",
    text: "Eingehendes Primus Management ist nicht initialisiert in CAN J1939",
  },
  3153: {
    category: "Fehler",
    text: "Interface Primus Management ist nicht initialisiert in clsJ1939",
  },
  3154: {
    category: "Fehler",
    text: "Interface Primus Management ist null in clsJ1939",
  },
  3155: {
    category: "Fehler",
    text: "CAN Diesel Drehmoment ist außerhalb des zulässigen Bereiches",
  },
  3156: {
    category: "Fehler",
    text: "Reduzierung Motorleistung ist ungültig in clsJ1939",
  },
  3157: {
    category: "Fehler",
    text: "Ungültiger Zustand der Fehlerlampe für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3158: {
    category: "Fehler",
    text: "Ungültiger Zustand Parkbremse aktiv für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3159: {
    category: "Fehler",
    text: "Ungültiger Zustand Parkbremse aktivieren Anforderung für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3160: {
    category: "Fehler",
    text: "Ungültiger Zustand Rückfahrwarner ansteuern für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3161: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Rückwärtsfahrt für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3162: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler sicherer Stillstand für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3163: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler sichere Fahrtrichtung für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3164: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler sicheres Beschleunigungslimit für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3165: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler sicheres Verzögerungslimit für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3166: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Motor auf blockiert auf geringem Winkel für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3167: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Motor auf blockiert auf großem Winkel für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3168: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Speicher-Überprüfung für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3169: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Monitor-Aufruf fehlgeschlagen für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3170: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Nothalt für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3171: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Notlauf ohne Geschwindigkeits- und Drucksensoren für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3172: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Notlauf keine Rückwärtsfahrt für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3173: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Notlauf keine Vorwärtsfahrt für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3174: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3175: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen vorne rechts vor Notbetrieb für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3176: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen vorne links vor Notbetrieb für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3177: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen hinten rechts vor Notbetrieb für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3178: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen hinten links vor Notbetrieb für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3179: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Rampe stop via neutraler Gang für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3180: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Rampe stop via neutraler Gang vor Notbetrieb für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3181: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion eingefrorener Fahrmodus für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3182: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Fahrpedal deaktiviert für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3183: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Fortbewegungspedal deaktiviert für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3184: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Handgas deaktiviert für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3185: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Potentiometer Schleichfahrt deaktiviert für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3186: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Schleichfahrt Schalter deaktiviert für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3187: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Sitzkontaktschalter deaktiviert für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3188: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Fahrmodus wechseln deaktiviert für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3189: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Überwachung Sicherheitsmonitoring deaktiviert für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3190: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion neutraler Gang eingelegt für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3191: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Startprozedur blockiert Bewegung für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3192: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Erster Power Up verhindert für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3193: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion keine Reaktion ausgeführt, Fehlerlampe blinkt für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3194: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion keine Reaktion ausgeführt, Fehlerlampe leuchtet für Fahrantrieb in Klasse clsJ1939 gefunden",
  },
  3195: {
    category: "Fehler",
    text: "Ungültiger Sollwert Diesel-Drehzahl vom Fahrantrieb in Klasse clsJ1939",
  },
  3196: {
    category: "Fehler",
    text: "Ungültiger Referenzwert Soll-Diesel-Drehzahl vom Fahrantrieb in Klasse clsJ1939",
  },
  3197: {
    category: "Fehler",
    text: "Ungültiger Sollwert Diesel-Drehzahl Eco-Modus vom Fahrantrieb in Klasse clsJ1939",
  },
  3198: {
    category: "Fehler",
    text: "Ungültige Fahrgeschwindigkeit in Klasse clsJ1939 gefunden",
  },
  3199: {
    category: "Fehler",
    text: "Ungültige Anforderung Parkbremse einlegen gefunden in Klasse clsJ1939",
  },
  3200: {
    category: "Fehler",
    text: "Ungültiger Zustand Parkbremse Lampe blinkt gefunden in Klasse clsJ1939",
  },
  3201: {
    category: "Fehler",
    text: "Ungültiger Zustand Parkbremse Lampe ein gefunden in Klasse clsJ1939",
  },
  3202: {
    category: "Fehler",
    text: "Eingehender Datenbaustein zum Senden von CAN Daten ist null in Klasse clsJ1939",
  },
  3203: {
    category: "Fehler",
    text: "Ungültiger Wert für Anforderung Parkbremse setzen gefunden im CAN Interface",
  },
  3204: {
    category: "Fehler",
    text: "Ungültiger Wert für Betriebsmodus gefunden im CAN Interface",
  },
  3205: {
    category: "Fehler",
    text: "Ungültiger Wert für Fahrtrichtung gefunden im CAN Interface",
  },
  3206: {
    category: "Fehler",
    text: "Ungültiger Wert für Handgas gefunden im CAN Interface",
  },
  3207: {
    category: "Fehler",
    text: "Ungültiger Wert für Lenkwinkel Hinterachse gefunden im CAN Interface",
  },
  3208: {
    category: "Fehler",
    text: "Ungültiger Wert für Lenkwinkel Vorderachse gefunden im CAN Interface",
  },
  3209: {
    category: "Fehler",
    text: "Ungültiger Wert für Parkbremse Feedback gefunden im CAN Interface",
  },
  3210: {
    category: "Fehler",
    text: "Ungültiger Wert für Parkbremse lösen erlaubt gefunden im CAN Interface",
  },
  3211: {
    category: "Fehler",
    text: "Ungültiger Wert für Sitzkontakt gefunden im CAN Interface",
  },
  3212: {
    category: "Fehler",
    text: "CAN-Daten senden wurde mit einem ungültigen Interface (Datenbaustein) aufgerufen",
  },
  3213: {
    category: "Fehler",
    text: "Ungültiger Wert für Modus Diesel Drehzahlverstellung gefunden im CAN Interface",
  },
  3214: {
    category: "Fehler",
    text: "Ungültiger Wert für Charakteristik Diesel Drehzahlverstellung gefunden im CAN Interface",
  },
  3215: {
    category: "Fehler",
    text: "Ungültiger Wert für Priorität Diesel Drehzahlverstellung gefunden im CAN Interface",
  },
  3216: {
    category: "Fehler",
    text: "Ungültiger Dieseldrehzahl-Sollwert gefunden im CAN Interface",
  },
  3217: {
    category: "Fehler",
    text: "Ungültiges Interface zum Senden von CAN-Daten in Klasse clsDiesel",
  },
  3218: {
    category: "Fehler",
    text: "Nicht initialisiertes Interface zum Senden von CAN-Daten in Klasse clsDiesel",
  },
  3219: {
    category: "Fehler",
    text: "Ungültiger Radwinkel Vorderachse im CAN Interface gefunden",
  },
  3220: {
    category: "Fehler",
    text: "Ungültiger Zustand Diagnoselampe Lenkung Schutzlampe gefunden",
  },
  3221: {
    category: "Fehler",
    text: "Ungültiger Zustand Diagnoselampe Lenkung gelbe Warnschwelle gefunden",
  },
  3222: {
    category: "Fehler",
    text: "Ungültiger Zustand Diagnoselampe Lenkung rote Stoplampe gefunden",
  },
  3223: {
    category: "Fehler",
    text: "Ungültiger Zustand Status Lenkachse Vorderachse gefunden in CAN Interface",
  },
  3224: {
    category: "Fehler",
    text: "Ungültiger Zustand Liftachse absenken Vorderachse im CAN Interface gefunden",
  },
  3225: {
    category: "Fehler",
    text: "Ungültiger Zustand Lenkungstyp Vorderachse in CAN Interface gefunden",
  },
  3226: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsunterstützung Vorderachse in CAN Interface gefunden",
  },
  3227: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsübertragung Vorderachse in CAN Interface gefunden",
  },
  3228: {
    category: "Fehler",
    text: "Ungültiger Zustand aktueller Lenkmodus SPST in CAN Interface gefunden",
  },
  3229: {
    category: "Fehler",
    text: "Ungültiger Zustand aktuelles Lenkprogramm SPST in CAN Interface gefunden",
  },
  3230: {
    category: "Fehler",
    text: "Ungültiger Zustand aktuelle Synchronisation Achsen SPST in CAN Interface gefunden",
  },
  3231: {
    category: "Fehler",
    text: "Fehlerhaften Failure Mode Identifier (FMI) für Lenkung gefunden",
  },
  3232: { category: "Fehler", text: "Lenkungsfehler durch SPN gefunden" },
  3233: {
    category: "Fehler",
    text: "Datentyp Lenkung ist null in Klasse clsJ1939",
  },
  3234: {
    category: "Fehler",
    text: "Interface Lenkung ist nicht initialisiert in Klasse clsJ1939",
  },
  3235: {
    category: "Fehler",
    text: "Ungültiger Wert Position Kommando Achse gefunden in CAN Interface",
  },
  3236: {
    category: "Fehler",
    text: "Ungültiger Wert für SPN Lenkung im CAN Interface gefunden",
  },
  3237: {
    category: "Fehler",
    text: "Ungültige Anforderung eines Lenkprogramms gefunden in Klasse clsJ1939",
  },
  3238: {
    category: "Fehler",
    text: "Ungültige Anforderung eines Lenkmodus gefunden in Klasse clsJ1939",
  },
  3239: {
    category: "Fehler",
    text: "Parameter Lenkmodi auf Keypad kann nicht gelesen werden in clsJ1939",
  },
  3240: { category: "Fehler", text: "Fehler Keypad Lenkstrategie erkannt" },
  3241: {
    category: "Fehler",
    text: "Ungültige Ist-Drehzahl gefunden in Klasse clsJ1939 senden",
  },
  3242: { category: "Fehler", text: "CAN-Keypad meldet einen Fehler" },
  3243: {
    category: "Fehler",
    text: "Interface Primus Management ist null in Klasse clsJ1939",
  },
  3244: {
    category: "Fehler",
    text: "Gleichzeitige Betätigung von Button Straßenfahrt und Arbeitsmodus wechseln erkannt",
  },
  3245: {
    category: "Fehler",
    text: "Gleichzeitige Betätigung von Button 4-Rad Lenkung ein/aus und Lenkstrategie wechseln erkannt",
  },
  3246: {
    category: "Fehler",
    text: "Maximale Drehzahl für den Diesel ist null in clsJ1939",
  },
  3247: {
    category: "Fehler",
    text: "Minimale Drehzahl für den Diesel ist null in clsJ1939",
  },
  3248: {
    category: "Fehler",
    text: "Ungültiger Zustand Status Lenkachse Hinterachse gefunden in CAN Interface",
  },
  3249: {
    category: "Fehler",
    text: "Ungültiger Zustand Liftachse absenken Hinterachse im CAN Interface gefunden",
  },
  3250: {
    category: "Fehler",
    text: "Ungültiger Zustand Lenkungstyp Hinterachse in CAN Interface gefunden",
  },
  3251: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsunterstützung Hinterachse in CAN Interface gefunden",
  },
  3252: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsübertragung Hinterachse in CAN Interface gefunden",
  },
  3253: {
    category: "Fehler",
    text: "Ungültiger Radwinkel Hinterachse im CAN Interface gefunden",
  },
  3254: {
    category: "Fehler",
    text: "Ungültiger Zustand Status Lenkachse Hinterachse gefunden in CAN Interface",
  },
  3255: {
    category: "Fehler",
    text: "Ungültiger Zustand Liftachse absenken Hinterachse im CAN Interface gefunden",
  },
  3256: {
    category: "Fehler",
    text: "Ungültiger Zustand Lenkungstyp Hinterachse in CAN Interface gefunden",
  },
  3257: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsunterstützung Hinterachse in CAN Interface gefunden",
  },
  3258: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsübertragung Hinterachse in CAN Interface gefunden",
  },
  3259: {
    category: "Fehler",
    text: "Fehler bei der Berechnung der DTC-Checksumme für Diesel festgestellt",
  },
  3260: {
    category: "Fehler",
    text: "Fehler bei der Berechnung der DTC-Checksumme für Lenkung festgestellt",
  },
  3261: {
    category: "Fehler",
    text: "Schieber: Falscher Betriebsmodus (Straßenfahrt) für Arbeitsfunktion",
  },
  3262: {
    category: "Fehler",
    text: "Austragsband verschieben: Falscher Betriebsmodus (Straßenfahrt) für Arbeitsfunktion",
  },
  3263: {
    category: "Fehler",
    text: "Fräse: Falscher Betriebsmodus (Straßenfahrt) für Arbeitsfunktion",
  },
  3264: {
    category: "Fehler",
    text: "Fräse: Falscher Betriebsmodus (Aufnahme) für Arbeitsfunktion",
  },
  3265: {
    category: "Fehler",
    text: "Schieber: Falscher Betriebsmodus (Aufnahme) für Arbeitsfunktion",
  },
  3266: {
    category: "Fehler",
    text: "Austragsband verschieben: Falscher Betriebsmodus (Aufnahme) für Arbeitsfunktion",
  },
  3267: {
    category: "Fehler",
    text: "Austragsband Wippe aktiv: Falscher Betriebsmodus (Straßenfahrt) für Arbeitsfunktion",
  },
  3268: {
    category: "Fehler",
    text: "Austragsband Wippe aktiv: Falscher Betriebsmodus (Aufnahme) für Arbeitsfunktion",
  },
  3269: {
    category: "Fehler",
    text: "Fräse kann nicht aktiviert werden, da der Motor nicht eingeschaltet ist",
  },
  3270: {
    category: "Fehler",
    text: "Fräsarm kann nicht aktiviert werden, da der Motor nicht eingeschaltet ist",
  },
  3271: {
    category: "Fehler",
    text: "Austragsband kann nicht eingeschaltet werden, da der Motor nicht eingeschaltet ist",
  },
  3272: {
    category: "Fehler",
    text: "Mischergeschwindigkeit kann nicht verändert werden, da der Motor nicht eingeschaltet ist",
  },
  3273: {
    category: "Fehler",
    text: "Dieselgeschwindigkeit kann nicht verändert werden, da der Diesel nicht eingeschaltet ist",
  },
  3274: {
    category: "Fehler",
    text: "Bandgeschwindigkeit kann nicht verändert werden, da der Motor nicht eingeschaltet ist",
  },
  3275: {
    category: "Fehler",
    text: "Fräswalzenschutz kann nicht verfahren werden, da der Motor nicht eingeschaltet ist",
  },
  3276: {
    category: "Fehler",
    text: "Dosierschieber 1 kann nicht verfahren werden, da der Motor nicht eingeschaltet ist",
  },
  3277: {
    category: "Fehler",
    text: "Dosierschieber 2 kann nicht verfahren werden, da der Motor nicht eingeschaltet ist",
  },
  3278: {
    category: "Fehler",
    text: "Austragsband kann nicht verfahren werden, da der Motor nicht eingeschaltet ist",
  },
  3279: {
    category: "Fehler",
    text: "Mischerstufe kann nicht verändert werden, da der Motor nicht eingeschaltet ist",
  },
  3280: {
    category: "Fehler",
    text: "Dosierschieber 3 kann nicht verfahren werden, da der Motor nicht eingeschaltet ist",
  },
  3281: {
    category: "Fehler",
    text: "Gegenschneiden nicht verfahren werden, da der Motor nicht eingeschaltet ist",
  },
  3282: {
    category: "Fehler",
    text: "Automatik-Aufnahme kann nicht aktiviert werden, da der Motor nicht eingeschaltet ist",
  },
  3283: {
    category: "Fehler",
    text: "Dosierschieber 4 kann nicht verfahren werden, da der Motor nicht eingeschaltet ist",
  },
  3284: {
    category: "Fehler",
    text: "Band kann nicht umgeschaltet werden, da der Motor nicht eingeschaltet ist",
  },
  3285: {
    category: "Fehler",
    text: "Automatik-Austrag kann nicht aktiviert werden, da der Diesel nicht eingeschaltet ist",
  },
  3286: {
    category: "Fehler",
    text: "Leerlauf-Dieseldrehzahl ist nicht gesetzt in Klasse clsJ1939",
  },
  3287: {
    category: "Fehler",
    text: "Maximale Drehzahl ist nicht gesetzt in Klasse clsJ1939",
  },
  3288: {
    category: "Fehler",
    text: "Leerlauf-Drehzahl ist größer maximaler Drehzahl in Klasse clsJ1939",
  },
  3289: {
    category: "Fehler",
    text: "Fehler Keypad Förderband verschieben umschalten erkannt",
  },
  3290: {
    category: "Fehler",
    text: "Joysticktaster-Belegung konnte nicht gespeichert werden",
  },
  3291: {
    category: "Fehler",
    text: "Ungültige Konfiguration Band verschieben erkannt in Klasse clsJ1939",
  },
  3292: {
    category: "Fehler",
    text: "Daten-Interface Spiegelarm ist nicht initialisiert in Klasse clsJ1939",
  },
  3293: {
    category: "Fehler",
    text: "Interface Spiegelarm ist nicht initialisiert in Klasse clsJ1939",
  },
  3294: {
    category: "Fehler",
    text: "Ungültige Geschwindigkeit Verstellung Spiegelarm in Klasse clsJ1939 gefunden",
  },
  3295: {
    category: "Fehler",
    text: "Ungültiger Empfangswert FNR von dem Fahrantrieb empfangen",
  },
  3296: {
    category: "Fehler",
    text: "Unbekannter Fehler bei dem Empfang des FNR-Schalters durch den Fahrantrieb erkannt",
  },
  3297: {
    category: "Fehler",
    text: "Interface Mischer ist null in Klasse clsJ1939",
  },
  3298: {
    category: "Fehler",
    text: "Parameter für Taste F1 kann nicht gelesen werden in Klasse clsJ1939",
  },
  3299: {
    category: "Fehler",
    text: "Ungültige Belegung für Taste F1 auf CAN Keypad gefunden",
  },
  3300: {
    category: "Fehler",
    text: "Parameter Drehzahlspeicher konnte nicht gelesen werden in Klasse clsJ1939",
  },
  3301: {
    category: "Fehler",
    text: "Mehr als ein Keypad-Button gleichzeitig gedrückt",
  },
  3302: {
    category: "Fehler",
    text: "Sonderlenkprogramm kann im Modus Straßenfahrt nicht verwendet werden",
  },
  3303: {
    category: "Fehler",
    text: "Heckausschwenkunterdrückung kann im Modus Straßenfahrt nicht aktiviert werden",
  },
  3304: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer sollen aktiviert werden, Modus ist Straßenfahrt",
  },
  3305: {
    category: "Fehler",
    text: "Aktuelles Gewicht im Behälter ist größer als maximale Zuladung",
  },
  3306: {
    category: "Fehler",
    text: "Daten-Interface Waage ist nicht initialisiert in Klasse clsJ1939",
  },
  3307: {
    category: "Fehler",
    text: "Interface Waage ist nicht initialisiert in Klasse clsJ1939",
  },
  3308: {
    category: "Fehler",
    text: "Prozentualer Wert für Diesel-Drückung ist außerhalb des zulässigen Bereiches",
  },
  3309: {
    category: "Fehler",
    text: "Diesel-Drückung ist außerhalb des zulässigen Bereiches",
  },
  3310: {
    category: "Fehler",
    text: "Offset IO Fehler kann nicht gelesen werden",
  },
  3311: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht DPFC1 Regeneration aktiv",
  },
  3312: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht DPFC1 autom. Regeneration angefragt",
  },
  3313: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht EBC2BF Öldruck",
  },
  3314: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht OI Wasser im Kraftstoff",
  },
  3315: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht ENG06 Luftfilter verschmutzt",
  },
  3316: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht ENG06 Dieselfilter verschmutzt",
  },
  3317: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht ENG06 DEF Level Warnung",
  },
  3318: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht ENG06 DEF Qualität",
  },
  3319: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht  ENG06 technischer Fehler",
  },
  3320: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht  ENG07 technischer Fehler",
  },
  3321: {
    category: "Fehler",
    text: "Fehlerhafte Daten EBC2BF Temperatur Kühlmittel aus CAN",
  },
  3322: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb Schutzlampe",
  },
  3323: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb gelbe Warnschwelle",
  },
  3324: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb rote Stoplampe",
  },
  3325: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb Lampe Fehlfunktion",
  },
  3326: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb blinkende Schutzlampe",
  },
  3327: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb blinkende gelbe Warnschwelle AWL",
  },
  3328: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb blinkende rote Stoplampe",
  },
  3329: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb blinkende gelbe Warnschwelle MIL",
  },
  3330: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft FMI überschritten",
  },
  3331: {
    category: "Fehler",
    text: "Checksumme DTC Fahrantrieb kann nicht berechnet werden",
  },
  3332: { category: "Fehler", text: "Fehler im Can0 Bus erkannt" },
  3333: { category: "Fehler", text: "Diagnosemeldung für Can0 Bus liegt vor" },
  3334: { category: "Fehler", text: "Buslast Can0 über Schwellwert" },
  3335: { category: "Fehler", text: "Fehler im Can1 Bus erkannt" },
  3336: { category: "Fehler", text: "Diagnosemeldung für Can1 Bus liegt vor" },
  3337: { category: "Fehler", text: "Buslast Can1 über Schwellwert" },
  3338: { category: "Fehler", text: "Fehler im Can2 Bus erkannt" },
  3339: { category: "Fehler", text: "Diagnosemeldung für Can2 Bus liegt vor" },
  3340: { category: "Fehler", text: "Buslast Can2 über Schwellwert" },
  3341: { category: "Fehler", text: "Fehler im Can3 Bus erkannt" },
  3342: { category: "Fehler", text: "Diagnosemeldung für Can3 Bus liegt vor" },
  3343: { category: "Fehler", text: "Buslast Can3 über Schwellwert" },
  3344: { category: "Fehler", text: "OBC Eingangsspannung zu hoch" },
  3345: {
    category: "Fehler",
    text: "OBC Eingangsstrom außerhalb des gültigen Wertebereiches",
  },
  3346: { category: "Fehler", text: "OBC felerhafter zu setzender Stromwert" },
  3347: { category: "Fehler", text: "OBC felerhafter zu setzende Spannung" },
  3348: {
    category: "Fehler",
    text: "OBC interne Temperatur außerhalb des gültigen Wertebereiches",
  },
  3349: {
    category: "Fehler",
    text: "OBC Ausgabestrom außerhalb des gültigen Wertebereiches",
  },
  3350: {
    category: "Fehler",
    text: "E-Motor Hydraulik: Ungültige Drehzahl oder Drehmoment",
  },
  3351: {
    category: "Fehler",
    text: "E-Motor Hydraulik: Ungültiges Drehmoment",
  },
  3352: {
    category: "Fehler",
    text: "E-Motor Hydraulik: Ungültige Geschwindigkeit",
  },
  3353: {
    category: "Fehler",
    text: "E-Motor Hydraulik: Ungültiger Status Motor aktiv",
  },
  3354: {
    category: "Fehler",
    text: "E-Motor Hydraulik: Ungültige Drehrichtung",
  },
  3355: { category: "Fehler", text: "E-Motor Hydraulik: Ungültiger Status" },
  3356: {
    category: "Fehler",
    text: "E-Motor Hydraulik: Ungültiger Betriebsmodus",
  },
  3357: { category: "Fehler", text: "E-Motor Hydraulik: Ungültige Drehzahl" },
  3358: { category: "Fehler", text: "E-Motor Hydraulik: Ungültiger Status" },
  3359: {
    category: "Fehler",
    text: "E-Motor Hydraulik: Ungültige IGBT-Temperatur",
  },
  3360: {
    category: "Fehler",
    text: "E-Motor Hydraulik: Ungültige Temperatur Motor",
  },
  3361: {
    category: "Fehler",
    text: "E-Motor fahren: Ungültige Drehzahl oder Drehmoment",
  },
  3362: { category: "Fehler", text: "E-Motor fahren: Ungültiges Drehmoment" },
  3363: {
    category: "Fehler",
    text: "E-Motor fahren: Ungültige Geschwindigkeit",
  },
  3364: {
    category: "Fehler",
    text: "E-Motor fahren: Ungültiger Status Motor aktiv",
  },
  3365: { category: "Fehler", text: "E-Motor fahren: Ungültige Drehrichtung" },
  3366: { category: "Fehler", text: "E-Motor fahren: Ungültiger Status" },
  3367: {
    category: "Fehler",
    text: "E-Motor fahren: Ungültiger Betriebsmodus",
  },
  3368: { category: "Fehler", text: "E-Motor fahren: Ungültige Drehzahl" },
  3369: { category: "Fehler", text: "E-Motor fahren: Ungültiger Status" },
  3370: {
    category: "Fehler",
    text: "E-Motor fahren: Ungültige IGBT-Temperatur",
  },
  3371: {
    category: "Fehler",
    text: "E-Motor fahren: Ungültige Temperatur Motor",
  },
  3372: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültige Drehzahl oder Drehmoment",
  },
  3373: { category: "Fehler", text: "E-Motor Fräse: Ungültiges Drehmoment" },
  3374: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültige Geschwindigkeit",
  },
  3375: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültiger Status Motor aktiv",
  },
  3376: { category: "Fehler", text: "E-Motor Fräse: Ungültige Drehrichtung" },
  3377: { category: "Fehler", text: "E-Motor Fräse: Ungültiger Status" },
  3378: { category: "Fehler", text: "E-Motor Fräse: Ungültiger Betriebsmodus" },
  3379: { category: "Fehler", text: "E-Motor Fräse: Ungültige Drehzahl" },
  3380: { category: "Fehler", text: "E-Motor Fräse: Ungültiger Status" },
  3381: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültige IGBT-Temperatur",
  },
  3382: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültige Temperatur Motor",
  },
  3383: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige Drehzahl oder Drehmoment",
  },
  3384: { category: "Fehler", text: "E-Motor Mischer: Ungültiges Drehmoment" },
  3385: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige Geschwindigkeit",
  },
  3386: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültiger Status Motor aktiv",
  },
  3387: { category: "Fehler", text: "E-Motor Mischer: Ungültige Drehrichtung" },
  3388: { category: "Fehler", text: "E-Motor Mischer: Ungültiger Status" },
  3389: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültiger Betriebsmodus",
  },
  3390: { category: "Fehler", text: "E-Motor Mischer: Ungültige Drehzahl" },
  3391: { category: "Fehler", text: "E-Motor Mischer: Ungültiger Status" },
  3392: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige IGBT-Temperatur",
  },
  3393: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige Temperatur Motor",
  },
  3394: {
    category: "Fehler",
    text: "E-Motoren: Batteriespannung außerhalb des gültigen Bereiches",
  },
  3395: {
    category: "Fehler",
    text: "BMS: Ausgabestrom außerhalb des zulässigen Bereiches",
  },
  3396: {
    category: "Fehler",
    text: "BMS: Batteriespannung außerhalb des zulässigen Bereiches",
  },
  3397: {
    category: "Fehler",
    text: "BMS: Ladezustand außerhalb des zulässigen Bereiches",
  },
  3398: {
    category: "Fehler",
    text: "BMS: maximaler Ladestrom außerhalb des zulässigen Bereiches",
  },
  3399: {
    category: "Fehler",
    text: "BMS: AC-Spannung außerhalb des zulässigen Bereiches",
  },
  3400: {
    category: "Fehler",
    text: "BMS: Charger Status außerhalb des zulässigen Bereiches",
  },
  3401: {
    category: "Fehler",
    text: "BMS: J1772 Ladestecker Status außerhalb des zulässigen Bereiches",
  },
  3402: {
    category: "Fehler",
    text: "BMS: höchste Zelltemperatur außerhalb des zulässigen Bereiches",
  },
  3403: {
    category: "Fehler",
    text: "BMS: niedrigste Zelltemperatur außerhalb des zulässigen Bereiches",
  },
  3404: {
    category: "Fehler",
    text: "Interface für das BMS ist null in Klasse clsJ1939",
  },
  3405: {
    category: "Fehler",
    text: "Interface für das BMS ist nicht initialisiert in Klasse clsJ1939",
  },
  3406: {
    category: "Fehler",
    text: "Universalwippe betätigt mit aktiver Vorwahl, Motor läuft nicht",
  },
  3407: {
    category: "Fehler",
    text: "Interface für den OBC ist null in Klasse clsJ1939",
  },
  3408: {
    category: "Fehler",
    text: "Interface für den OBC ist nicht initialisiert in Klasse clsJ1939",
  },
  3409: {
    category: "Fehler",
    text: "Interface für den e-Fräsmotor ist nicht initialisiert in Klasse clsJ1939",
  },
  3410: {
    category: "Fehler",
    text: "Interface für den e-Motor Mischer ist nicht initialisiert in Klasse clsJ1939",
  },
  3411: {
    category: "Fehler",
    text: "Interface für den e-Motor Hydro ist nicht initialisiert in Klasse clsJ1939",
  },
  3412: {
    category: "Fehler",
    text: "Interface für den e-Motor Fahren ist nicht initialisiert in Klasse clsJ1939",
  },
  3413: {
    category: "Fehler",
    text: "Interface Ladestecker ist nicht initialisiert in Klasse J1939",
  },
  3414: {
    category: "Fehler",
    text: "Interface Ladestecker ist null in Klasse J1939",
  },
  3415: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Schieber 3. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3416: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Schieber 4. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3417: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Schieber 3 und 4. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3418: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Gegenschneiden. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3419: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Bandverschiebung. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3420: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Automatik Aufnahme. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3421: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Automatik Austrag. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3422: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Bandrotation. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3423: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Arbeitsscheinwerfer. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3424: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Allrad. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3425: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Straßenfahrt. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3426: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Arbeitsmodi wechseln. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3427: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Mischerstufe. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3428: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Spiegelarm. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3429: {
    category: "Fehler",
    text: "Frei belegbaren Button geklickt. Aktuelle Vorwahl ist Sonderfunktion F1. Zum Setzen Button auf Keypad drücken und anschließend Taster für 4s halten.",
  },
  3430: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Schieber 3",
  },
  3431: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Schieber 4",
  },
  3432: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Schieber 3 und 4",
  },
  3433: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Gegenschneiden",
  },
  3434: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Bandverschiebung",
  },
  3435: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Automatik Aufnahme",
  },
  3436: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Automatik Austrag",
  },
  3437: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Bandrotation",
  },
  3438: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Arbeitsscheinwerfer",
  },
  3439: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Allrad",
  },
  3440: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Straßenfahrt",
  },
  3441: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Arbeitsmodi wechseln",
  },
  3442: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Mischerstufe",
  },
  3443: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Spiegelarm",
  },
  3444: {
    category: "Fehler",
    text: "Frei belegbarer Taster neu gesetzt. Vorwahl ist jetzt Sonderfunktion F1",
  },
  3445: { category: "Fehler", text: "Interface Fahrantrieb ist null" },
  3446: {
    category: "Fehler",
    text: "Interface Fahrantrieb ist nicht initialisiert",
  },
  3447: {
    category: "Fehler",
    text: "Fahrgeschwindigkeit für einen Wechsel in den Arbeitsmodus via Auswahl Fräswalzenschutz zu groß",
  },
  3448: {
    category: "Fehler",
    text: "Fahrgeschwindigkeit für einen Wechsel in den Arbeitsmodus via Auswahl Dosierschieber zu groß",
  },
  3449: {
    category: "Fehler",
    text: "Fahrgeschwindigkeit für einen Wechsel in den Arbeitsmodus via Auswahl Bandverschiebung zu groß",
  },
  3450: { category: "Fehler", text: "Fehlerhaftes Signal Fahrpedalstellung" },
  3451: {
    category: "Fehler",
    text: "Parameter BMS Typ konnte nicht gelesen werden in Klasse clsJ1939",
  },
  3452: {
    category: "Fehler",
    text: "BMS: maximaler Ladestrom der Ladestation außerhalb des zulässigen Bereichs",
  },
  3453: {
    category: "Fehler",
    text: "BMS: höchste Zellspannung außerhalb des zulässigen Bereichs",
  },
  3454: {
    category: "Fehler",
    text: "BMS: niedrigste Zellspannung außerhalb des zulässigen Bereichs",
  },
  3455: { category: "Fehler", text: "Ungültiger Wert Fahrantrieb drosseln" },
  3456: { category: "Fehler", text: "E-Motor Fräse: Ungültiges Drehmoment" },
  3457: {
    category: "Fehler",
    text: "IMD: Isolationstate außerhalb des zulässigen Bereichs",
  },
  3458: {
    category: "Fehler",
    text: "IMD: Isolationswiderstand außerhalb des zulässigen Bereichs",
  },
  3459: {
    category: "Fehler",
    text: "IMD: Isolationskapazitaet außerhalb des zulässigen Bereichs",
  },
  3460: {
    category: "Fehler",
    text: "Interface für das IMD ist null in Klasse clsJ1939",
  },
  3461: {
    category: "Fehler",
    text: "Interface für das IMD ist nicht initialisiert in Klasse clsJ1939",
  },
  3462: {
    category: "Fehler",
    text: "BMS: Zustand außerhalb des zulässigen Bereichs",
  },
  3463: {
    category: "Fehler",
    text: "Fehler Button red. Elevatorgeschw. erkannt",
  },
  3464: {
    category: "Fehler",
    text: "Fahrgeschwindigkeit zu hoch für das Setzen des Drehzahlspeichers",
  },
  3465: { category: "Fehler", text: "E-Motor fahren: Ungültige Drehzahl" },
  3466: { category: "Fehler", text: "Fehlerhaftes Signal Fahrdruck A" },
  3467: { category: "Fehler", text: "Fehlerhaftes Signal Fahrdruck B" },
  3500: {
    category: "Fehler",
    text: "Zu viele Lenkmodi gesetzt in CanOpen senden der Daten",
  },
  3501: {
    category: "Fehler",
    text: "Gleichzeitige Bedienung von Taste + und - für Lenkung gefunden",
  },
  3502: {
    category: "Fehler",
    text: "Eingehendes Interface hat validen Typ, allerdings keine Implementierung in clsCanOpen senden",
  },
  3503: {
    category: "Fehler",
    text: "Kein gültiges Interface in CANopen senden gefunden",
  },
  3504: { category: "Fehler", text: "Klasse CANopen ist nicht initialisiert" },
  3505: { category: "Fehler", text: "CANopen Bus Fehler" },
  3600: { category: "Fehler", text: "CAN-IO nicht initialisiert" },
  3901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  3902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  3903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  3904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  3905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  3906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  3907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  3908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  3909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  3910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  3911: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  3912: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  3913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  3914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  3915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  3916: { category: "Fehler", text: "PWM-Ausgang hat eine zu hohe Temperatur" },
  3917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  3918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  3919: { category: "Fehler", text: "Bereichsfehler PWM" },
  3920: { category: "Fehler", text: "Safety Fehler PWM" },
  3921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  3922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  3923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  3924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  3925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  3926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  3927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  3928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  3929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  3930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  3931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  3932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  3933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  3934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  3935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  3936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  3937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  3938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  3939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  3941: { category: "Fehler", text: "Digitaler Eingang zur Zeit in Benutzung" },
  3942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  3943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  3944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  3945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  3946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  3947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  3948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  3949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  3950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  3951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  3952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  3953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  3954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  3955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  3956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  3957: { category: "Fehler", text: "Digitaler Eingang Fehler Gruppenausgang" },
  3958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  3959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  3961: { category: "Fehler", text: "Digitaler Ausgang zur Zeit in Benutzung" },
  3962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  3963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  3964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  3965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  3966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  3967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  3968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  3969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  3970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  3971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  3972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  3973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  3974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  3975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  3976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  3977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  3978: { category: "Fehler", text: "Digitaler Ausgang Fehler Gruppenausgang" },
  3979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  3980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  3981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  3982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  3983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  3984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  3985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  3986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  3987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  3988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  3989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  3990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  3991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  3992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  3993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  3994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  3995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  3996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  3997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  3998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  3999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  4901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  4902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  4903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  4904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  4905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  4906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  4907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  4908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  4909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  4910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  4911: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  4912: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  4913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  4914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  4915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  4916: { category: "Fehler", text: "PWM-Ausgang hat eine zu hohe Temperatur" },
  4917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  4918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  4919: { category: "Fehler", text: "Bereichsfehler PWM" },
  4920: { category: "Fehler", text: "Safety Fehler PWM" },
  4921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  4922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  4923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  4924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  4925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  4926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  4927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  4928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  4929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  4930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  4931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  4932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  4933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  4934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  4935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  4936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  4937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  4938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  4939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  4941: { category: "Fehler", text: "Digitaler Eingang zur Zeit in Benutzung" },
  4942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  4943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  4944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  4945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  4946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  4947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  4948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  4949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  4950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  4951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  4952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  4953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  4954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  4955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  4956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  4957: { category: "Fehler", text: "Digitaler Eingang Fehler Gruppenausgang" },
  4958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  4959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  4961: { category: "Fehler", text: "Digitaler Ausgang zur Zeit in Benutzung" },
  4962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  4963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  4964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  4965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  4966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  4967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  4968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  4969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  4970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  4971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  4972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  4973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  4974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  4975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  4976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  4977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  4978: { category: "Fehler", text: "Digitaler Ausgang Fehler Gruppenausgang" },
  4979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  4980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  4981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  4982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  4983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  4984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  4985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  4986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  4987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  4988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  4989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  4990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  4991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  4992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  4993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  4994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  4995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  4996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  4997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  4998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  4999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  5001: {
    category: "Fehler",
    text: "Aktuelle Geschwindigkeit kann nicht berechnet werden. Ungültige Impulszahl pro Radumdrehung",
  },
  5002: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose in Fahrantrieb gefunden",
  },
  5003: {
    category: "Fehler",
    text: "Diagnoseinterface für Fahrantrieb ist ungültig",
  },
  5004: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Fahrantrieb gefunden",
  },
  5005: { category: "Fehler", text: "CAN-Bus für Fahrantrieb ist ungültig" },
  5006: {
    category: "Fehler",
    text: "Ungültiger Reifendurchmesser im Fahrantrieb gefunden",
  },
  5007: {
    category: "Fehler",
    text: "Ungültiger Maschinentyp für Fahrantrieb gefunden",
  },
  5008: {
    category: "Fehler",
    text: "Nicht initialisierte Überwachung für Fahrantrieb gefunden",
  },
  5009: {
    category: "Fehler",
    text: "Interface Überwachung für Fahrantrieb ist ungültig",
  },
  5010: {
    category: "Fehler",
    text: "Nicht initialisiertes Management für Fahrantrieb gefunden",
  },
  5011: {
    category: "Fehler",
    text: "Interface Management für Fahrantrieb ist ungültig",
  },
  5012: {
    category: "Fehler",
    text: "Can-Interface für neue Daten ist ungültig für Fahrantrieb",
  },
  5013: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Fahrantrieb in clsFahrantrieb gefunden",
  },
  5014: {
    category: "Fehler",
    text: "Handgas-Geschwindigkeit ist ungültig in Fahrantrieb",
  },
  5015: {
    category: "Fehler",
    text: "Betriebsmodus ist ungültig in Fahrantrieb",
  },
  5016: {
    category: "Fehler",
    text: "Ungültige aktuelle Geschwindigkeit des Fahrantriebes empfangen",
  },
  5017: {
    category: "Fehler",
    text: "Keine Geschwindigkeit des Fahrantriebes über mehrere Zyklen empfangen",
  },
  5018: {
    category: "Fehler",
    text: "Ungültige Soll-Drehzahl des Fahrantriebes für den Diesel gefunden",
  },
  5019: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Fahrantrieb",
  },
  5020: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Fahrantrieb",
  },
  5021: {
    category: "Fehler",
    text: "Interface des Frequenz-Einganges Drehzahl Fahrmotor 1 ist ungültig",
  },
  5022: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Ansteuerung Rückfahrscheinwerfer ist ungültig",
  },
  5023: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Freigabe Fahrpumpe ist ungültig",
  },
  5024: {
    category: "Fehler",
    text: "Ungültiger Zustand der Fehlerlampe für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5025: {
    category: "Fehler",
    text: "Ungültiger Zustand Parkbremse aktiv für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5026: {
    category: "Fehler",
    text: "Ungültiger Zustand Parkbremse aktivieren Anforderung für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5027: {
    category: "Fehler",
    text: "Ungültiger Zustand Rückfahrwarner ansteuern für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5028: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Rückwärtsfahrt für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5029: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler sicherer Stillstand für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5030: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler sichere Fahrtrichtung für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5031: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler sicheres Beschleunigungslimit für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5032: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler sicheres Verzögerungslimit für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5033: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Motor auf blockiert auf geringem Winkel für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5034: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Motor auf blockiert auf großem Winkel für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5035: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Speicher-Überprüfung für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5036: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehler Monitor-Aufruf fehlgeschlagen für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5037: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Nothalt für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5038: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Notlauf ohne Geschwindigkeits- und Drucksensoren für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5039: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Notlauf keine Rückwärtsfahrt für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5040: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Notlauf keine Vorwärtsfahrt für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5041: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5042: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen vorne rechts vor Notbetrieb für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5043: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen vorne links vor Notbetrieb für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5044: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen hinten rechts vor Notbetrieb für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5045: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Ausrollen hinten links vor Notbetrieb für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5046: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Rampe stop via neutraler Gang für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5047: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Rampe stop via neutraler Gang vor Notbetrieb für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5048: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion eingefrorener Fahrmodus für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5049: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Fahrpedal deaktiviert für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5050: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Fortbewegungspedal deaktiviert für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5051: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Handgas deaktiviert für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5052: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Potentiometer Schleichfahrt deaktiviert für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5053: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Schleichfahrt Schalter deaktiviert für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5054: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Sitzkontaktschalter deaktiviert für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5055: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Fahrmodus wechseln deaktiviert für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5056: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Überwachung Sicherheitsmonitoring deaktiviert für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5057: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion neutraler Gang eingelegt für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5058: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Startprozedur blockiert Bewegung für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5059: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion Erster Power Up verhindert für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5060: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion keine Reaktion ausgeführt, Fehlerlampe blinkt für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5061: {
    category: "Fehler",
    text: "Ungültiger Zustand Fehlerreaktion keine Reaktion ausgeführt, Fehlerlampe leuchtet für Fahrantrieb in Klasse clsFahrantrieb gefunden",
  },
  5062: {
    category: "Fehler",
    text: "Ungültiger Sollwert Diesel-Drehzahl vom Fahrantrieb in Klasse clsFahrantrieb",
  },
  5063: {
    category: "Fehler",
    text: "Ungültiger Referenzwert Soll-Diesel-Drehzahl vom Fahrantrieb in Klasse clsFahrantrieb",
  },
  5064: {
    category: "Fehler",
    text: "Ungültiger Sollwert Diesel-Drehzahl Eco-Modus vom Fahrantrieb in Klasse clsFahrantrieb",
  },
  5065: {
    category: "Fehler",
    text: "Fahrmodus in Klasse clsFahrantrieb ungültig",
  },
  5066: {
    category: "Fehler",
    text: "Fahrtrichtung in Klasse clsFahrantrieb ungültig",
  },
  5067: {
    category: "Fehler",
    text: "Fehler Rückwärtsfahrt für Fahrantrieb. Bitte Maschine neu starten",
  },
  5068: {
    category: "Fehler",
    text: "Fehler sicherer Stillstand für Fahrantrieb",
  },
  5069: {
    category: "Fehler",
    text: "Fehler sichere Fahrtrichtung für Fahrantrieb",
  },
  5070: {
    category: "Fehler",
    text: "Fehler sicheres Beschleunigungslimit für Fahrantrieb",
  },
  5071: {
    category: "Fehler",
    text: "Fehler sicheres Verzögerungslimit für Fahrantrieb",
  },
  5072: {
    category: "Fehler",
    text: "Fehler Motor auf blockiert auf geringem Winkel für Fahrantrieb",
  },
  5073: {
    category: "Fehler",
    text: "Fehler Motor auf blockiert auf großem Winkel für Fahrantrieb",
  },
  5074: {
    category: "Fehler",
    text: "Fehler Speicher-Überprüfung für Fahrantrieb",
  },
  5075: {
    category: "Fehler",
    text: "Fehler Monitor-Aufruf fehlgeschlagen für Fahrantrieb",
  },
  5076: { category: "Fehler", text: "Fehlerreaktion Nothalt für Fahrantrieb" },
  5077: {
    category: "Fehler",
    text: "Fehlerreaktion Notlauf ohne Geschwindigkeits- und Drucksensoren für Fahrantrieb",
  },
  5078: {
    category: "Fehler",
    text: "Fehlerreaktion Notlauf keine Rückwärtsfahrt für Fahrantrieb",
  },
  5079: {
    category: "Fehler",
    text: "Fehlerreaktion Notlauf keine Vorwärtsfahrt für Fahrantrieb",
  },
  5080: {
    category: "Fehler",
    text: "Fehlerreaktion Ausrollen für Fahrantrieb",
  },
  5081: {
    category: "Fehler",
    text: "Fehlerreaktion Ausrollen vorne rechts vor Notbetrieb für Fahrantrieb",
  },
  5082: {
    category: "Fehler",
    text: "Fehlerreaktion Ausrollen vorne links vor Notbetrieb für Fahrantrieb",
  },
  5083: {
    category: "Fehler",
    text: "Fehlerreaktion Ausrollen hinten rechts vor Notbetrieb für Fahrantrieb",
  },
  5084: {
    category: "Fehler",
    text: "Fehlerreaktion Ausrollen hinten links vor Notbetrieb für Fahrantrieb",
  },
  5085: {
    category: "Fehler",
    text: "Fehlerreaktion Rampe stop via neutraler Gang für Fahrantrieb",
  },
  5086: {
    category: "Fehler",
    text: "Fehlerreaktion Rampe stop via neutraler Gang vor Notbetrieb für Fahrantrieb",
  },
  5087: {
    category: "Fehler",
    text: "Fehlerreaktion eingefrorener Fahrmodus für Fahrantrieb",
  },
  5088: {
    category: "Fehler",
    text: "Fehlerreaktion Fahrpedal deaktiviert für Fahrantrieb",
  },
  5089: {
    category: "Fehler",
    text: "Fehlerreaktion Fortbewegungspedal deaktiviert für Fahrantrieb",
  },
  5090: {
    category: "Fehler",
    text: "Fehlerreaktion Handgas deaktiviert für Fahrantrieb",
  },
  5091: {
    category: "Fehler",
    text: "Fehlerreaktion Potentiometer Schleichfahrt deaktiviert für Fahrantrieb",
  },
  5092: {
    category: "Fehler",
    text: "Fehlerreaktion Schleichfahrt Schalter deaktiviert für Fahrantrieb",
  },
  5093: {
    category: "Fehler",
    text: "Fehlerreaktion Sitzkontaktschalter deaktiviert für Fahrantrieb",
  },
  5094: {
    category: "Fehler",
    text: "Fehlerreaktion Fahrmodus wechseln deaktiviert für Fahrantrieb",
  },
  5095: {
    category: "Fehler",
    text: "Fehlerreaktion Überwachung Sicherheitsmonitoring deaktiviert für Fahrantrieb",
  },
  5096: {
    category: "Fehler",
    text: "Fehlerreaktion neutraler Gang eingelegt für Fahrantrieb",
  },
  5097: {
    category: "Fehler",
    text: "Fehlerreaktion Startprozedur blockiert Bewegung für Fahrantrieb",
  },
  5098: {
    category: "Fehler",
    text: "Fehlerreaktion Erster Power Up verhindert für Fahrantrieb",
  },
  5099: {
    category: "Fehler",
    text: "Fehlerreaktion keine Reaktion ausgeführt, Fehlerlampe blinkt für Fahrantrieb",
  },
  5100: {
    category: "Fehler",
    text: "Fehlerreaktion keine Reaktion ausgeführt, Fehlerlampe leuchtet für Fahrantrieb",
  },
  5101: {
    category: "Fehler",
    text: "Allgemeiner Fehler Fahrantrieb festgestellt",
  },
  5102: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Anforderung Parkbremse ist ungültig",
  },
  5103: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Druckschalter Status Parkbremse ist ungültig",
  },
  5104: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Ansteuerung Ventil Parkbremse ist ungültig",
  },
  5105: {
    category: "Fehler",
    text: "Anforderung für Parkbremse einschalten empfangen, aktuelle Fahrgeschwindigkeit ist zu groß",
  },
  5106: {
    category: "Fehler",
    text: "Speicherladedruck reicht nicht aus, um die Parkbremse sicher zu lösen. Parkbremse lösen nicht möglich",
  },
  5107: {
    category: "Fehler",
    text: "Ungültiger Schaltzustand für Anforderung Parkbremse setzen in Klasse clsFahrantrieb",
  },
  5108: {
    category: "Fehler",
    text: "Ungültiger Schaltzustand für Feedback Parkbremse eingelegt in Klasse clsFahrantrieb",
  },
  5109: {
    category: "Fehler",
    text: "Ungültige Anforderung Parkbremse einlegen gefunden in Klasse clsFahrantrieb",
  },
  5110: {
    category: "Fehler",
    text: "Ungültiger Zustand Parkbremse Lampe blinkt gefunden in Klasse clsFahrantrieb",
  },
  5111: {
    category: "Fehler",
    text: "Ungültiger Zustand Parkbremse Lampe ein gefunden in Klasse clsFahrantrieb",
  },
  5112: {
    category: "Fehler",
    text: "Ungültige Bereifung in Klasse Fahrantrieb gefunden",
  },
  5113: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Richtungssignal Fahrantrieb ist ungültig",
  },
  5114: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Rückfahrsignal ist ungültig",
  },
  5115: {
    category: "Fehler",
    text: "Ungültiger Wert Handgas gefunden in Klase clsFahrantrieb",
  },
  5116: {
    category: "Fehler",
    text: "Nicht initialisiertes Interface Lenkung in Klasse Fahrantrieb gefunden",
  },
  5117: {
    category: "Fehler",
    text: "Interface für Lenkung ist null in Klasse clsFahrantrieb",
  },
  5118: {
    category: "Fehler",
    text: "Ungültiger Lenkwinkel Vorderachse gefunden in Fahrantrieb",
  },
  5119: {
    category: "Fehler",
    text: "Interface Diesel in Klasse Fahrantrieb ist null",
  },
  5120: {
    category: "Fehler",
    text: "Interface Diesel in Klasse Fahrantrieb ist nicht initialisiert",
  },
  5121: {
    category: "Fehler",
    text: "Solldrehzahl Diesel ist außerhalb des gültigen Bereiches in Klasse clsFahrantrieb",
  },
  5122: {
    category: "Fehler",
    text: "Referenz-Drehzahl Diesel ist außerhalb des gültigen Bereiches in Klasse clsFahrantrieb",
  },
  5123: {
    category: "Fehler",
    text: "Solldrehzahl Eco Diesel ist außerhalb des gültigen Bereiches in Klasse clsFahrantrieb",
  },
  5124: {
    category: "Fehler",
    text: "Ungültiger Lenkwinkel Hinterachse gefunden in Fahrantrieb",
  },
  5125: {
    category: "Fehler",
    text: "Keypad-Beleuchtung konnte nicht gesetzt werden für den Fahrantrieb",
  },
  5126: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist null in Klasse clsFahrantrieb",
  },
  5127: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist nicht initialisiert in Klasse clsFahrantrieb",
  },
  5128: {
    category: "Fehler",
    text: "Die aktuelle Fahrgeschwindigkeit für den Modus Aufnahme ist zu groß",
  },
  5129: {
    category: "Fehler",
    text: "Die aktuelle Fahrgeschwindigkeit für den Modus Austrag ist zu groß",
  },
  5130: {
    category: "Fehler",
    text: "Schwerwiegender Fehler im Fahrantrieb erkannt. Bitte Maschine umgehend abstellen!",
  },
  5131: { category: "Fehler", text: "Interface FNR vor ist null" },
  5132: {
    category: "Fehler",
    text: "Interface FNR vor kann nicht in digitalen Eingang konvertiert werden",
  },
  5133: { category: "Fehler", text: "Interface FNR rückwärts ist null" },
  5134: {
    category: "Fehler",
    text: "Interface FNR rückwärts kann nicht in digitalen Eingang konvertiert werden",
  },
  5135: {
    category: "Fehler",
    text: "Gleichzeitige Anfrage für vor und zurück liegt vor",
  },
  5136: {
    category: "Fehler",
    text: "Interface Can Daten senden im Fahrantrieb ist null",
  },
  5137: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  5138: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  5139: {
    category: "Fehler",
    text: "Interface Fahrantrieb kann nicht aus CAN gewandelt werden",
  },
  5140: {
    category: "Fehler",
    text: "DTC kann in Klasse Fahrantrieb nicht gelesen werden",
  },
  5141: { category: "Fehler", text: "FMI in Klasse Fahrantrieb ungültig" },
  5142: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb Schutzlampe in Klasse Fahrantrieb",
  },
  5143: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb gelbe Warnschwelle in Klasse Fahrantrieb",
  },
  5144: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb rote Stoplampe in Klasse Fahrantrieb",
  },
  5145: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb Lampe Fehlfunktion in Klasse Fahrantrieb",
  },
  5146: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb blinkende Schutzlampe in Klasse Fahrantrieb",
  },
  5147: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb blinkende gelbe Warnschwelle AWL in Klasse Fahrantrieb",
  },
  5148: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb blinkende rote Stoplampe in Klasse Fahrantrieb",
  },
  5149: {
    category: "Fehler",
    text: "Fehlerhafte CAN Botschaft Fahrantrieb blinkende gelbe Warnschwelle MIL in Klasse Fahrantrieb",
  },
  5150: { category: "Fehler", text: "Fahrantrieb Schutzlampe aktiv" },
  5151: { category: "Fehler", text: "Fahrantrieb gelbe Warnschwelle aktiv" },
  5152: { category: "Fehler", text: "Fahrantrieb rote Stoplampe aktiv" },
  5153: { category: "Fehler", text: "Fahrantrieb Lampe Fehlfunktion aktiv" },
  5154: { category: "Fehler", text: "Fahrantrieb blinkende Schutzlampe aktiv" },
  5155: {
    category: "Fehler",
    text: "Fahrantrieb blinkende gelbe Warnschwelle AWL aktiv",
  },
  5156: {
    category: "Fehler",
    text: "Fahrantrieb blinkende rote Stoplampe aktiv",
  },
  5157: {
    category: "Fehler",
    text: "Fahrantrieb blinkende gelbe Warnschwelle MIL aktiv",
  },
  5158: {
    category: "Fehler",
    text: "Fahrantrieb: SPN gibt einen Fehler aus, FMI undefiniert",
  },
  5159: {
    category: "Fehler",
    text: "Fahrantrieb: FMI gibt einen Fehler aus, SPN undefiniert",
  },
  5160: { category: "Fehler", text: "Fahrantrieb Diagnosenachricht liegt vor" },
  5161: {
    category: "Fehler",
    text: "Speicherladedruck zu gering. Bremsen nur eingeschränkt möglich. Bitte Fahrzeug zum Stillstand bringen.",
  },
  5162: { category: "Fehler", text: "Interface Fahrdepal Signal 1 ist null" },
  5163: {
    category: "Fehler",
    text: "Interface Fahrpedal 1 kann nicht in einen analogen Eingang gewandelt werden",
  },
  5164: { category: "Fehler", text: "Interface Fahrdepal Signal 2 ist null" },
  5165: {
    category: "Fehler",
    text: "Interface Fahrpedal 2 kann nicht in einen analogen Eingang gewandelt werden",
  },
  5166: {
    category: "Fehler",
    text: "Signal Fahrpedal 1 konnte nicht gelesen werden",
  },
  5167: {
    category: "Fehler",
    text: "Signal Fahrpedal 2 konnte nicht gelesen werden",
  },
  5168: {
    category: "Fehler",
    text: "Die Signale des Fahrpedals weichen zu stark voneinander ab",
  },
  5169: {
    category: "Fehler",
    text: "Geschwindigkeit zu hoch. Bitte abbremsen",
  },
  5170: {
    category: "Fehler",
    text: "Die aktuelle Fahrgeschwindigkeit liegt über der zulässigen Höchstgeschwindigkeit. Bitte umgehend abbremsen.",
  },
  5171: {
    category: "Fehler",
    text: "Die aktuelle Fahrgeschwindigkeit liegt über der zulässigen Höchstgeschwindigkeit. Bitte sofort abbremsen.",
  },
  5172: { category: "Fehler", text: "Fehlerhaftes Signal Fahrpedalstellung" },
  5173: {
    category: "Fehler",
    text: "Bitte in Neutralgang schalten und Fahrtrichtung erneut anfordern",
  },
  5174: { category: "Fehler", text: "Interface Fräsarm ist null" },
  5175: {
    category: "Fehler",
    text: "Interface Fräsarm ist nicht initialisiert",
  },
  5176: {
    category: "Fehler",
    text: "Ungültiger Wert Betriebsmodus Fahrantrieb",
  },
  5177: {
    category: "Fehler",
    text: "Keine Fahrfreigabe erhalten. Parkbremse bleibt aktiv.",
  },
  5400: {
    category: "Fehler",
    text: "Can-Interface für neue Daten ist ungültig für Verstellung Spiegelarm",
  },
  5401: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Fräswalzenschutz in clsSpiegelarmVerstellung gefunden",
  },
  5402: {
    category: "Fehler",
    text: "Interface Ansteuerung Spiegelarm-Verstellung ist ungültig in Klasse clsSpiegelarmVerstellung",
  },
  5403: {
    category: "Fehler",
    text: "Interface Diagnose ist nicht initialisiert in Klasse clsSpiegelarmVerstellung",
  },
  5404: {
    category: "Fehler",
    text: "Interface Diagnose ist null in Klasse clsSpiegelarmVerstellung",
  },
  5405: {
    category: "Fehler",
    text: "Interface Can Bus ist nicht initialisiert in Klasse clsSpiegelarmVerstellung",
  },
  5406: {
    category: "Fehler",
    text: "Interface Can Bus ist null in Klasse clsSpiegelarmVerstellung",
  },
  5407: {
    category: "Fehler",
    text: "Interface Parameter ist nicht initialisiert in Klasse clsSpiegelarmVerstellung",
  },
  5408: {
    category: "Fehler",
    text: "Interface Parameter ist null in Klasse clsSpiegelarmVerstellung",
  },
  5409: {
    category: "Fehler",
    text: "Ungültige Aktion Spiegelarm verschieben gefunden in Klasse clsSpiegelarmVerschiebung",
  },
  5410: {
    category: "Fehler",
    text: "Ungültige Geschwindigkeit Verstellung Spiegelarm in Klasse clsSpiegelarmVerstellung gefunden",
  },
  5411: {
    category: "Fehler",
    text: "Zu schneller Wechsel der Richtung für Spiegelarmverstellung erkannt.",
  },
  5901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  5902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  5903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  5904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  5905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  5906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  5907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  5908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  5909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  5910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  5911: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  5912: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  5913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  5914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  5915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  5916: { category: "Fehler", text: "PWM-Ausgang hat eine zu hohe Temperatur" },
  5917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  5918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  5919: { category: "Fehler", text: "Bereichsfehler PWM" },
  5920: { category: "Fehler", text: "Safety Fehler PWM" },
  5921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  5922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  5923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  5924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  5925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  5926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  5927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  5928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  5929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  5930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  5931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  5932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  5933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  5934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  5935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  5936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  5937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  5938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  5939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  5941: { category: "Fehler", text: "Digitaler Eingang zur Zeit in Benutzung" },
  5942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  5943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  5944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  5945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  5946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  5947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  5948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  5949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  5950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  5951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  5952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  5953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  5954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  5955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  5956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  5957: { category: "Fehler", text: "Digitaler Eingang Fehler Gruppenausgang" },
  5958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  5959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  5961: { category: "Fehler", text: "Digitaler Ausgang zur Zeit in Benutzung" },
  5962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  5963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  5964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  5965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  5966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  5967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  5968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  5969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  5970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  5971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  5972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  5973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  5974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  5975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  5976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  5977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  5978: { category: "Fehler", text: "Digitaler Ausgang Fehler Gruppenausgang" },
  5979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  5980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  5981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  5982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  5983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  5984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  5985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  5986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  5987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  5988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  5989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  5990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  5991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  5992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  5993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  5994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  5995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  5996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  5997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  5998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  5999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  6001: {
    category: "Fehler",
    text: "Diagnoseinterface Analogeingang ist ungültig",
  },
  6002: {
    category: "Fehler",
    text: "Diagnoseinterface Digitaleingang ist ungültig",
  },
  6003: {
    category: "Fehler",
    text: "Diagnoseinterface Digitalausgang ist ungültig",
  },
  6004: {
    category: "Fehler",
    text: "Diagnoseinterface Frequenzeingang ist ungültig",
  },
  6005: {
    category: "Fehler",
    text: "Diagnoseinterface PWM-Ausgang ist ungültig",
  },
  6006: { category: "Fehler", text: "PWM-Ausgang Bereichsüberschreitung" },
  6007: {
    category: "Fehler",
    text: "A/D Wandler gibt Wert außerhalb der Bereichsgrenzen",
  },
  6008: {
    category: "Fehler",
    text: "Fehler bei AD-Wandlung eines analogen Einganges",
  },
  6009: {
    category: "Fehler",
    text: "Undefinierter Schaltzustand für digitalen Eingang",
  },
  6010: {
    category: "Fehler",
    text: "Nicht initialisierten analogen Eingang gefunden",
  },
  6011: {
    category: "Fehler",
    text: "Nicht initialisierten digitalen Eingang gefunden",
  },
  6012: {
    category: "Fehler",
    text: "Nicht initialisierten digitalen Ausgang gefunden",
  },
  6013: {
    category: "Fehler",
    text: "Undefinierter Schaltzustand für digitalen Ausgang gefunden",
  },
  6014: {
    category: "Fehler",
    text: "Nicht initialisierter Frequenzeingang gefunden",
  },
  6015: {
    category: "Fehler",
    text: "Nicht initialisierter PWM-Ausgang gefunden",
  },
  6016: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für analogen Eingang gefunden",
  },
  6017: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für digitalen Eingang gefunden",
  },
  6018: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für digitalen Ausgang gefunden",
  },
  6019: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Frequenzeingang gefunden",
  },
  6020: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für PWM Ausgang gefunden",
  },
  6021: { category: "Fehler", text: "Bereichsfehler analoger Eingang erkannt" },
  6022: {
    category: "Fehler",
    text: "Kein gültiger Betriebsbereich des analogen Einganges definiert",
  },
  6023: {
    category: "Fehler",
    text: "Kein gültiger Arbeitsbereich des analogen Einganges definiert",
  },
  6024: {
    category: "Fehler",
    text: "Kein gültiger Transformationsbereich des analogen Einganges definiert",
  },
  6080: { category: "Fehler", text: "Diagnoseinterface Can IO ist ungültig" },
  6081: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Can-E/A gefunden",
  },
  6082: {
    category: "Fehler",
    text: "Fehlerhaftes zu setzendes PWM-Signal erkannt",
  },
  6083: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse PWM-Ausgang",
  },
  6084: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse PWM-Ausgang",
  },
  6085: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Analog-Eingang",
  },
  6086: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Analog-Eingang",
  },
  6087: {
    category: "Fehler",
    text: "Digitaler Eingang kein Schaltertyp (Öffner / Schließer) gesetzt",
  },
  6088: {
    category: "Fehler",
    text: "PWM Rampe Endwert ist außerhalb des zulässigen Bereiches",
  },
  6089: { category: "Fehler", text: "PWM Rampe Steigung ist ungültig" },
  6090: { category: "Fehler", text: "PWM Rampe Zeitwert für Änderung ist 0" },
  6091: { category: "Fehler", text: "PWM Rampe Prozentwert ist ungültig" },
  6092: {
    category: "Fehler",
    text: "Fehler Konfiguration min/max.-Wert Frequenzeingang",
  },
  6093: {
    category: "Fehler",
    text: "Aktuelle Frequenz ist kleiner als die minimale Frequenz",
  },
  6094: {
    category: "Fehler",
    text: "Aktuelle Frequenz ist größer als die maximale Frequenz",
  },
  6095: {
    category: "Fehler",
    text: "Fehlerhafte Konfiguration Frequenzeingang: Maximalwert ist null",
  },
  6150: {
    category: "Fehler",
    text: "Widerstand ist außerhalb des zulässigen Bereiches",
  },
  6151: {
    category: "Fehler",
    text: "Widerstand kann nicht transformiert werden",
  },
  6152: {
    category: "Fehler",
    text: "Interface Diagnose ist nicht initialisiert in Klasse clsWiderstandIn",
  },
  6153: {
    category: "Fehler",
    text: "Interface Diagnose ist null in Klasse clsWiderstandIn",
  },
  6154: {
    category: "Fehler",
    text: "Interface Parameter ist nicht initialisiert in Klasse clsWiderstandIn",
  },
  6155: {
    category: "Fehler",
    text: "Interface Parameter ist null in Klasse clsWiderstandIn",
  },
  6156: {
    category: "Fehler",
    text: "Ungültiger Wertebereich für Widerstand in clsWiderstandIn",
  },
  6157: {
    category: "Fehler",
    text: "Ungültiger Arbeitsbereich für Widerstand in clsWiderstandIn",
  },
  6158: {
    category: "Fehler",
    text: "Ungültiger Transformationsbereich für Widerstand in clsWiderstandIn",
  },
  6159: {
    category: "Fehler",
    text: "Klasse clsWiderstandIn nicht initialisiert",
  },
  6160: {
    category: "Fehler",
    text: "DiagnoseCode gibt Fehler bei Widerstandseingang an",
  },
  6901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  6902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  6903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  6904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  6905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  6906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  6907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  6908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  6909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  6910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  6911: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  6912: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  6913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  6914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  6915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  6916: { category: "Fehler", text: "PWM-Ausgang hat eine zu hohe Temperatur" },
  6917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  6918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  6919: { category: "Fehler", text: "Bereichsfehler PWM" },
  6920: { category: "Fehler", text: "Safety Fehler PWM" },
  6921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  6922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  6923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  6924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  6925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  6926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  6927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  6928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  6929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  6930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  6931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  6932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  6933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  6934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  6935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  6936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  6937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  6938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  6939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  6941: { category: "Fehler", text: "Digitaler Eingang zur Zeit in Benutzung" },
  6942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  6943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  6944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  6945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  6946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  6947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  6948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  6949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  6950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  6951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  6952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  6953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  6954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  6955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  6956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  6957: { category: "Fehler", text: "Digitaler Eingang Fehler Gruppenausgang" },
  6958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  6959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  6961: { category: "Fehler", text: "Digitaler Ausgang zur Zeit in Benutzung" },
  6962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  6963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  6964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  6965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  6966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  6967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  6968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  6969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  6970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  6971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  6972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  6973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  6974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  6975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  6976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  6977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  6978: { category: "Fehler", text: "Digitaler Ausgang Fehler Gruppenausgang" },
  6979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  6980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  6981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  6982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  6983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  6984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  6985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  6986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  6987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  6988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  6989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  6990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  6991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  6992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  6993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  6994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  6995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  6996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  6997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  6998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  6999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  7001: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer Gruppe Aufnahme lässt sich nicht einschalten",
  },
  7002: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer Gruppe Aufnahme lässt sich nicht ausschalten",
  },
  7003: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer Gruppe Austrag lässt sich nicht einschalten",
  },
  7004: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer Gruppe Austrag lässt sich nicht ausschalten",
  },
  7005: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer Gruppe Fahren lässt sich nicht einschalten",
  },
  7006: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer Gruppe Fahren lässt sich nicht ausschalten",
  },
  7007: {
    category: "Fehler",
    text: "Rückfahrleuchte lässt sich nicht einschalten",
  },
  7008: {
    category: "Fehler",
    text: "Rückfahrleuchte lässt sich nicht ausschalten",
  },
  7009: {
    category: "Fehler",
    text: "Rundumleuchte lässt sich nicht einschalten",
  },
  7010: {
    category: "Fehler",
    text: "Rundumleuchte lässt sich nicht ausschalten",
  },
  7011: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Lichtanlage gefunden",
  },
  7012: {
    category: "Fehler",
    text: "Diagnoseinterface für Lichtanlage ist ungültig",
  },
  7013: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Lichtanlage gefunden",
  },
  7014: { category: "Fehler", text: "CAN-Bus für Lichtanlage ist ungültig" },
  7015: {
    category: "Fehler",
    text: "Nicht initialisierte Lichtanlage gefunden",
  },
  7016: {
    category: "Fehler",
    text: "Interner Fehler Arbeitsscheinwerfer Aufnahme: Nicht alle Scheinwerfer eingeschaltet",
  },
  7017: {
    category: "Fehler",
    text: "Interner Fehler Arbeitsscheinwerfer Austrag: Nicht alle Scheinwerfer eingeschaltet",
  },
  7018: { category: "Fehler", text: "Bremslicht lässt sich nicht einschalten" },
  7019: {
    category: "Fehler",
    text: "Bremslicht lässt sich nicht aussschalten",
  },
  7020: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Lichtanlage gefunden",
  },
  7021: {
    category: "Fehler",
    text: "CAN-Datum ASW Aufnahme ist ungültig in clsLichtAnlage",
  },
  7022: {
    category: "Fehler",
    text: "CAN-Datum ASW Austrag ist ungültig in clsLichtAnlage",
  },
  7023: {
    category: "Fehler",
    text: "CAN-Datum Bremslicht ist ungültig in clsLichtAnlage",
  },
  7024: {
    category: "Fehler",
    text: "CAN-Datum Betriebsmodus ist ungültig in clsLichtAnlage",
  },
  7025: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse in clsLichtAnlage gefunden",
  },
  7026: {
    category: "Fehler",
    text: "Interface Primus Management ist nicht initialisiert in clsLichtanlage",
  },
  7027: {
    category: "Fehler",
    text: "Interface Primus Management ist null in clsLichtanlage",
  },
  7028: {
    category: "Fehler",
    text: "Interface Parameter ist nicht initialisiert in clsLichtanlage",
  },
  7029: {
    category: "Fehler",
    text: "InterfaceParameter ist null in clsLichtanlage",
  },
  7030: {
    category: "Fehler",
    text: "Interface des digitalen Eingangs Fernlicht-Kontrolle ist ungültig",
  },
  7031: {
    category: "Fehler",
    text: "Interface des Frequenz-Eingangs Blinker-Kontrolle ist ungültig",
  },
  7032: { category: "Fehler", text: "Eine Blinkerlampe ist defekt" },
  7033: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer Aufnahme soll aktiviert werden, Modus ist Straßenfahrt",
  },
  7034: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer Austrag soll aktiviert werden, Modus ist Straßenfahrt",
  },
  7035: {
    category: "Fehler",
    text: "Keypad-Beleuchtung konnte nicht gesetzt werden für die Arbeitsscheinwerfer",
  },
  7036: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist null in Klasse clsLichtAnlage",
  },
  7037: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist nicht initialisiert in Klasse clsLichtAnlage",
  },
  7038: {
    category: "Fehler",
    text: "Interface zum Fahrantrieb nicht initialisiert in Klasse clsLichtanlage",
  },
  7039: {
    category: "Fehler",
    text: "Interface zum Fahrantrieb ist null in Klasse clsLichtanlage",
  },
  7040: {
    category: "Fehler",
    text: "Bitte die Arbeitsscheinwerfer im Straßenmodus deaktivieren",
  },
  7041: {
    category: "Fehler",
    text: "Interface Abblendlicht ist null in Klasse clsLichtanlage",
  },
  7042: {
    category: "Fehler",
    text: "Interface Abblendlicht kann nicht in digitalen Eingang konvertiert werden",
  },
  7043: {
    category: "Fehler",
    text: "Interface Blinker links ist null in Klasse clsLichtanlage",
  },
  7044: {
    category: "Fehler",
    text: "Interface Blinker links kann nicht in digitalen Eingang konvertiert werden",
  },
  7045: {
    category: "Fehler",
    text: "Interface Blinker rechts ist null in Klasse clsLichtanlage",
  },
  7046: {
    category: "Fehler",
    text: "Interface Blinker rechts kann nicht in digitalen Eingang konvertiert werden",
  },
  7047: {
    category: "Fehler",
    text: "Fehler im Bereich des Abblendlichtes erkannt. Bitte Verkabelung Lenkstockschalter prüfen",
  },
  7048: {
    category: "Fehler",
    text: "Fehler im Bereich des Blinkers links erkannt. Bitte Verkabelung Lenkstockschalter prüfen",
  },
  7049: {
    category: "Fehler",
    text: "Fehler im Bereich des Blinkers rechts erkannt. Bitte Verkabelung Lenkstockschalter prüfen",
  },
  7050: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer können nicht aktiviert werden, da das Abblendlicht nicht eingeschaltet ist",
  },
  7051: {
    category: "Fehler",
    text: "Fehler beim Lesen Status Arbeitsscheinwerfer vorne",
  },
  7052: {
    category: "Fehler",
    text: "Fehler beim Lesen Status Arbeitsscheinwerfer mitte",
  },
  7053: {
    category: "Fehler",
    text: "Fehler beim Lesen Status Arbeitsscheinwerfer hinten",
  },
  7054: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer durch Ausschalten des Abblendlichts deaktiviert",
  },
  7055: {
    category: "Fehler",
    text: "Arbeitsscheinwerfer durch Umschalten in Straßenfahrt deaktiviert",
  },
  7080: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Licht gefunden",
  },
  7081: {
    category: "Fehler",
    text: "Diagnoseinterface für Licht ist ungültig",
  },
  7082: {
    category: "Fehler",
    text: "Ungültiger Schaltzustand für Licht gefunden",
  },
  7083: { category: "Fehler", text: "Nicht initialisiertes Licht gefunden" },
  7084: {
    category: "Fehler",
    text: "Fehlerhaftes Interface. Licht kann nicht ausgeschaltet werden",
  },
  7085: { category: "Fehler", text: "Interface digitaler IO ist ungültig" },
  7901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  7902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  7903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  7904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  7905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  7906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  7907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  7908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  7909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  7910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  7911: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  7912: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  7913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  7914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  7915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  7916: { category: "Fehler", text: "PWM-Ausgang hat eine zu hohe Temperatur" },
  7917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  7918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  7919: { category: "Fehler", text: "Bereichsfehler PWM" },
  7920: { category: "Fehler", text: "Safety Fehler PWM" },
  7921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  7922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  7923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  7924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  7925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  7926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  7927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  7928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  7929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  7930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  7931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  7932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  7933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  7934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  7935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  7936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  7937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  7938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  7939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  7941: { category: "Fehler", text: "Digitaler Eingang zur Zeit in Benutzung" },
  7942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  7943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  7944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  7945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  7946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  7947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  7948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  7949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  7950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  7951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  7952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  7953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  7954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  7955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  7956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  7957: { category: "Fehler", text: "Digitaler Eingang Fehler Gruppenausgang" },
  7958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  7959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  7961: { category: "Fehler", text: "Digitaler Ausgang zur Zeit in Benutzung" },
  7962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  7963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  7964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  7965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  7966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  7967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  7968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  7969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  7970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  7971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  7972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  7973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  7974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  7975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  7976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  7977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  7978: { category: "Fehler", text: "Digitaler Ausgang Fehler Gruppenausgang" },
  7979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  7980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  7981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  7982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  7983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  7984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  7985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  7986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  7987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  7988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  7989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  7990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  7991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  7992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  7993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  7994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  7995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  7996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  7997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  7998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  7999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  8901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  8902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  8903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  8904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  8905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  8906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  8907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  8908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  8909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  8910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  8911: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  8912: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  8913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  8914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  8915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  8916: { category: "Fehler", text: "PWM-Ausgang hat eine zu hohe Temperatur" },
  8917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  8918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  8919: { category: "Fehler", text: "Bereichsfehler PWM" },
  8920: { category: "Fehler", text: "Safety Fehler PWM" },
  8921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  8922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  8923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  8924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  8925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  8926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  8927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  8928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  8929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  8930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  8931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  8932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  8933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  8934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  8935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  8936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  8937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  8938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  8939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  8941: { category: "Fehler", text: "Digitaler Eingang zur Zeit in Benutzung" },
  8942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  8943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  8944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  8945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  8946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  8947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  8948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  8949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  8950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  8951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  8952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  8953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  8954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  8955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  8956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  8957: { category: "Fehler", text: "Digitaler Eingang Fehler Gruppenausgang" },
  8958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  8959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  8961: { category: "Fehler", text: "Digitaler Ausgang zur Zeit in Benutzung" },
  8962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  8963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  8964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  8965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  8966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  8967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  8968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  8969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  8970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  8971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  8972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  8973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  8974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  8975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  8976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  8977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  8978: { category: "Fehler", text: "Digitaler Ausgang Fehler Gruppenausgang" },
  8979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  8980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  8981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  8982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  8983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  8984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  8985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  8986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  8987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  8988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  8989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  8990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  8991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  8992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  8993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  8994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  8995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  8996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  8997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  8998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  8999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  9001: {
    category: "Fehler",
    text: "Gleichzeitige Bestromung Vorwahl A und B erkannt",
  },
  9002: {
    category: "Fehler",
    text: "Fehlerhafter Zustand Arbeitsfunktion schalten in Vorwahlhydraulik gefunden",
  },
  9003: {
    category: "Fehler",
    text: "PWM-Wert ist außerhalb des gueltigen Bereiches in Vorwahlhydraulik",
  },
  9004: {
    category: "Fehler",
    text: "Diagnoseinterface Vorwahl Arbeitsfunktion ungültig",
  },
  9005: {
    category: "Fehler",
    text: "Interface Freigaben für Vorwahl Arbeitshydraulik ist ungültig",
  },
  9006: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Vorwahlhydraulik gefunden",
  },
  9007: {
    category: "Fehler",
    text: "Negative Anzahl an Elementen gefunden in Vorwahlhydraulik",
  },
  9008: {
    category: "Fehler",
    text: "Interface Überwachung ist null in Vorwahl Arbeitshydraulik",
  },
  9009: {
    category: "Fehler",
    text: "Interface Überwachung ist nicht initialisiert in Vorwahl Arbeitshydraulik",
  },
  9010: {
    category: "Fehler",
    text: "Keine Hydraulikfreigabe vom Setzen des PWM-Vorwahlsignals vorhanden",
  },
  9011: {
    category: "Fehler",
    text: "Eingehendes Interface Arbeitsfunktion ist null in clsVorwahlArbeitsfunktion",
  },
  9012: {
    category: "Fehler",
    text: "Eingehendes Interface Arbeitsfunktion ist nicht initialisiert in clsVorwahlArbeitsfunktion",
  },
  9013: {
    category: "Fehler",
    text: "Vorwahl Arbeitsfunktion nicht initialisiert in clsVorwahlArbeitsfunktion",
  },
  9014: {
    category: "Fehler",
    text: "Sherpa/P400 erkannt und mehrere Schieber auf Vorwahl",
  },
  9015: {
    category: "Fehler",
    text: "Nicht verschiebbares Band erkannt in Vorwahlhydraulik",
  },
  9016: {
    category: "Fehler",
    text: "Zu viele Elemente in Liste Vorwahlhydraulik enthalten",
  },
  9017: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Vorwahl Arbeitsfunktion",
  },
  9018: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Vorwahl Arbeitsfunktion",
  },
  9019: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Vorwahl A ist ungültig",
  },
  9020: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Vorwahl B ist ungültig",
  },
  9021: {
    category: "Fehler",
    text: "Vorwahl ist bestromt, es gibt aber keine zugehörige Arbeitsfunktion",
  },
  9100: {
    category: "Fehler",
    text: "Ungültiger Anzeigebereich in Fehlerklasse gefunden",
  },
  9101: {
    category: "Fehler",
    text: "Kann Attribut aus Fehlerliste nicht lesen - eingehender Wert ist ungültig",
  },
  9102: {
    category: "Fehler",
    text: "Kann Attribut aus Fehlerliste nicht lesen - Attribut nicht gefunden",
  },
  9103: { category: "Fehler", text: "Ungültiger Fehlerbereich angefragt" },
  9104: {
    category: "Fehler",
    text: "Bereichsueberschreitung erkannt in Fehler-Handler",
  },
  9105: { category: "Fehler", text: "Index im Fehlerspeicher ist ungültig" },
  9106: {
    category: "Fehler",
    text: "Zu löschender Fehlerindex ist außerhalb des gültigen Bereiches",
  },
  9107: {
    category: "Fehler",
    text: "Diagnose-ID für IO-Fehler ist kleiner gleich 0 in Fehler-Handler",
  },
  9108: { category: "Fehler", text: "Fehlerinterface ist nicht initialisiert" },
  9109: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des EEPROM (persistenter Speicher)",
  },
  9110: {
    category: "Fehler",
    text: "Fehler bei dem Lesen des EEPROM-Speichers in Klasse Fehler",
  },
  9111: {
    category: "Fehler",
    text: "Fehler bei dem Schreiben des EEPROM-Speichers in Klasse Fehler",
  },
  9112: {
    category: "Fehler",
    text: "Zu löschender Fehler wurde nicht in Fehlerliste gefunden",
  },
  9113: {
    category: "Fehler",
    text: "Fehler bei der Sortierung des Fehlerspeichers nach dem Löschen eines Wertes: Der letzte Wert im Array ist nicht default",
  },
  9114: {
    category: "Fehler",
    text: "Keine Daten von der Echtzeituhr im Display empfangen",
  },
  9115: {
    category: "Fehler",
    text: "Fehler bei dem Sortieren des Fehlerspeichers in Methode zum Löschen aller Fehler für aktuellen User",
  },
  9116: {
    category: "Fehler",
    text: "Zu löschender Fehler des Displays: ID ist zu klein",
  },
  9117: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  9118: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  9250: { category: "Fehler", text: "Parameter-Interface für PRIMUS ist null" },
  9251: {
    category: "Fehler",
    text: "Parameter-Interface für Primus ist nicht initialisiert",
  },
  9252: {
    category: "Fehler",
    text: "Maschinentyp kann nicht gelesen werden in Klasse clsPrimus",
  },
  9253: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Diagnose in clsPrimus",
  },
  9254: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Benutzerverwaltung in clsPrimus",
  },
  9255: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Parameter-Handlers in clsPrimus",
  },
  9256: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Vorwahlhydraulik in clsPrimus",
  },
  9257: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des CAN-J1939 Busses in clsPrimus",
  },
  9258: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des canOpen Busses in clsPrimus",
  },
  9259: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Primus-Managements in clsPrimus",
  },
  9260: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Überwachung in clsPrimus",
  },
  9261: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Diesel-Motors in clsPrimus",
  },
  9262: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Fahrantriebes in clsPrimus",
  },
  9263: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Lichtanlage in clsPrimus",
  },
  9264: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Fräse in clsPrimus",
  },
  9265: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Fräsarmes in clsPrimus",
  },
  9266: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Fräswalzenschutzes in clsPrimus",
  },
  9267: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Elevatorbandes in clsPrimus",
  },
  9268: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Waage in clsPrimus",
  },
  9269: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Mischers in clsPrimus",
  },
  9270: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Schiebers vorne mitte in clsPrimus",
  },
  9271: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Schiebers vorne rechts in clsPrimus",
  },
  9272: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Schiebers hinten rechts in clsPrimus",
  },
  9273: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Schiebers hinten mitte in clsPrimus",
  },
  9274: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Schiebers hinten links in clsPrimus",
  },
  9275: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Austragsbandes 1 in clsPrimus",
  },
  9276: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Austragsbandes 2 in clsPrimus",
  },
  9277: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Displays in clsPrimus",
  },
  9278: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Fernwartung in clsPrimus",
  },
  9279: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Strohhäckslers in clsPrimus",
  },
  9280: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Einstreuwalze in clsPrimus",
  },
  9281: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Gegenschneiden in clsPrimus",
  },
  9282: {
    category: "Fehler",
    text: "Fehlerhafte Initialisierung der Software festgestellt",
  },
  9283: {
    category: "Fehler",
    text: "Interface Maschinentyp ist null in clsPrimus",
  },
  9284: {
    category: "Fehler",
    text: "Kein Dosierschieber bei der Initialisierung gefunden in Klasse clsPrimus",
  },
  9285: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Klasse clsLenkung in Klasse clsPrimus",
  },
  9286: {
    category: "Fehler",
    text: "Parameter externe lenkung vorhanden konnte nicht geladen werden in Klasse clsPrimus",
  },
  9287: { category: "Fehler", text: "Kein Display gefunden" },
  9288: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Gegenschneiden in clsPrimus",
  },
  9289: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Dosiertrichters in clsPrimus",
  },
  9290: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung der Futterklappe in Klasse clsPrimus",
  },
  9291: {
    category: "Fehler",
    text: "Fehlerhafte Initialisierung der Klasse DemoModus festgestellt",
  },
  9292: {
    category: "Fehler",
    text: "Klasse BMS konnte nicht initialisiert werden",
  },
  9293: {
    category: "Fehler",
    text: "Klasse OBC konnte nicht initialisiert werden",
  },
  9294: {
    category: "Fehler",
    text: "Klasse e-Motor Hydro konnte nicht initialisiert werden",
  },
  9295: {
    category: "Fehler",
    text: "Klasse Ladestecker konnte nicht initialisiert werden",
  },
  9296: {
    category: "Fehler",
    text: "Klasse Heizung konnte nicht initialisiert werden",
  },
  9297: {
    category: "Fehler",
    text: "Interface itfInDrehzahlmanagement kann nicht initialisiert werden",
  },
  9298: {
    category: "Fehler",
    text: "Klasse IMD konnte nicht richtig initialisiert werden in clsPrimus",
  },
  9299: {
    category: "Fehler",
    text: "Klasse ZaehlerBetrStunden konnte nicht richtig initialisiert werden in clsPrimus",
  },
  9300: {
    category: "Fehler",
    text: "Klasse ZaehlerLadeZyklus konnte nicht richtig initialisiert werden in clsPrimus",
  },
  9301: {
    category: "Fehler",
    text: "Initialisierungsfehler Klasse Spiegelheizung",
  },
  9302: {
    category: "Fehler",
    text: "Klasse Wartungsplan konnte nicht initialisiert werden",
  },
  9501: { category: "Fehler", text: "Falsche Bereifung Sherpa" },
  9502: { category: "Fehler", text: "Falsche Bereifung Primus400" },
  9503: { category: "Fehler", text: "Falsche Anzahl Dosierschieber Sherpa" },
  9504: { category: "Fehler", text: "Falsche Anzahl Dosierschieber Primus400" },
  9505: { category: "Fehler", text: "Sherpa hat keine externe Lenkung" },
  9506: { category: "Fehler", text: "Primus400 hat keine externe Lenkung" },
  9507: { category: "Fehler", text: "Sherpa hat keinen externen Fahrantrieb" },
  9508: {
    category: "Fehler",
    text: "Primus400 hat keinen externen Fahrantrieb",
  },
  9509: {
    category: "Fehler",
    text: "Anzahl konfigurierter Dosierschieber übersteigt Maximalkonfiguration",
  },
  9510: {
    category: "Fehler",
    text: "Anzahl konfigurierter Austragsbänder übersteigt Maximalkonfiguration",
  },
  9511: { category: "Fehler", text: "Minimale Anzahl an Dosierschieber ist 1" },
  9512: {
    category: "Fehler",
    text: "Änderung des Parameters nicht möglich. Bitte Werksreset durchführen.",
  },
  9513: {
    category: "Fehler",
    text: "Band vorne rechts vorhanden, aber kein Dosierschieber",
  },
  9514: {
    category: "Fehler",
    text: "Band hinten rechts vorhanden, aber kein Dosierschieber",
  },
  9515: {
    category: "Fehler",
    text: "Band hinten mitte vorhanden, aber kein Dosierschieber",
  },
  9516: {
    category: "Fehler",
    text: "Band hinten links vorhanden, aber kein Dosierschieber",
  },
  9517: {
    category: "Fehler",
    text: "Falsche Dosierschieberposition konfiguriert für Sherpa",
  },
  9518: {
    category: "Fehler",
    text: "Falsche Bandposition konfiguriert für Sherpa",
  },
  9519: { category: "Fehler", text: "Sherpa hat keine Einstreuwalze" },
  9520: { category: "Fehler", text: "Sherpa hat keinen Strohhäcksler" },
  9521: {
    category: "Fehler",
    text: "Sherpa hat keinen freischaltbaren Hundegang",
  },
  9522: {
    category: "Fehler",
    text: "Primus400 hat keinen Schieber vorne rechts",
  },
  9523: { category: "Fehler", text: "Primus400 hat kein Band vorne rechts" },
  9524: { category: "Fehler", text: "Primus400 hat maximal ein Band" },
  9525: { category: "Fehler", text: "Primus400 hat keine Einstreuwalze" },
  9526: { category: "Fehler", text: "Primus400 hat keinen Strohhäcksler" },
  9527: {
    category: "Fehler",
    text: "Primus400 hat keinen freischaltbaren Hundegang",
  },
  9528: {
    category: "Fehler",
    text: "Primus400 hat keinen Schieber hinten li oder re und Band hinten mitte",
  },
  9529: {
    category: "Fehler",
    text: "Primus600 hat keinen Schieber vorne rechts",
  },
  9530: {
    category: "Fehler",
    text: "Primus900 hat keinen Schieber vorne rechts",
  },
  9531: { category: "Fehler", text: "Primus600 hat kein Band vorne rechts" },
  9532: { category: "Fehler", text: "Primus900 hat kein Band vorne rechts" },
  9533: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Sherpa vorne rechts",
  },
  9534: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Sherpa hinten links",
  },
  9535: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus400 hinten links",
  },
  9536: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus400 vorne mitte",
  },
  9537: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus400 hinten mitte",
  },
  9538: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus600 vorne mitte",
  },
  9539: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus600 hinten mitte",
  },
  9540: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus600 hinten rechts",
  },
  9541: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus600 hinten links",
  },
  9542: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus900 vorne mitte",
  },
  9543: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus900 hinten mitte",
  },
  9544: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus900 hinten rechts",
  },
  9545: {
    category: "Fehler",
    text: "Falsche Bandkonfiguration für Primus900 hinten links",
  },
  9546: {
    category: "Fehler",
    text: "Warnung Fräsdruck außerhalb des zulässigen Bereiches",
  },
  9547: {
    category: "Fehler",
    text: "Absenkstrom Fräsarm ist außerhalb des gültigen Bereiches",
  },
  9548: {
    category: "Fehler",
    text: "Verlängerungsband hinten rechts vorhanden, aber kein Schieber hinten mitte",
  },
  9549: {
    category: "Fehler",
    text: "Verlängerungsband hinten links vorhanden, aber kein Schieber hinten mitte",
  },
  9550: {
    category: "Fehler",
    text: "Kein Schieber hinten links möglich wegen Querband hinten",
  },
  9551: {
    category: "Fehler",
    text: "Kein Schieber hinten rechts möglich wegen Querband hinten",
  },
  9552: {
    category: "Fehler",
    text: "Kein Querband hinten möglich wegen Schieber hinten links",
  },
  9553: {
    category: "Fehler",
    text: "Kein Querband hinten möglich wegen Schieber hinten rechts",
  },
  9554: {
    category: "Fehler",
    text: "Querband hinten und Schieber hinten links gleichzeitig nicht möglich",
  },
  9555: {
    category: "Fehler",
    text: "Querband hinten und Schieber hinten rechts gleichzeitig nicht möglich",
  },
  9556: {
    category: "Fehler",
    text: "Maximale Zuladung ist außerhalb des zul. Bereiches",
  },
  9557: {
    category: "Fehler",
    text: "Nicht initialisierter Parameter-Handler gefunden",
  },
  9558: {
    category: "Fehler",
    text: "Element in Parameterliste anfügen nicht möglich - Element ungültig",
  },
  9559: {
    category: "Fehler",
    text: "Element in Parameterliste anfügen nicht möglich - interner Fehler in der Liste",
  },
  9560: {
    category: "Fehler",
    text: "Nicht initialisiertes Interface Benutzerverwaltung für Parameter gefunden",
  },
  9561: {
    category: "Fehler",
    text: "Ungültiges Interface Benutzerverwaltung für Parameter gefunden",
  },
  9562: {
    category: "Fehler",
    text: "Ungültiger Parameter in Parameter-Handler gefunden",
  },
  9563: {
    category: "Fehler",
    text: "Geladener Parameter stimmt nicht mit erwartetem Typ überein",
  },
  9564: {
    category: "Fehler",
    text: "Ungültiger Wert für boolean Parameter gefunden",
  },
  9565: {
    category: "Fehler",
    text: "Ungültiger Wert für integer Parameter gefunden",
  },
  9566: {
    category: "Fehler",
    text: "Aktueller Benutzer hat keine Berechtigung zum Setzen des Parameters",
  },
  9567: {
    category: "Fehler",
    text: "Ungültiger Maschinentyp  in Parameter-Handlergefunden",
  },
  9568: {
    category: "Fehler",
    text: "Ungültiger Wert für PID-Parameter in Parameter-Handler gefunden",
  },
  9569: {
    category: "Fehler",
    text: "Bandtyp passt nicht zur Bandposition vorne mitte",
  },
  9570: {
    category: "Fehler",
    text: "Bandtyp passt nicht zur Bandposition vorne rechts",
  },
  9571: {
    category: "Fehler",
    text: "Bandtyp passt nicht zur Bandposition hinten mitte",
  },
  9572: {
    category: "Fehler",
    text: "Bandtyp passt nicht zur Bandposition hinten links",
  },
  9573: {
    category: "Fehler",
    text: "Fehler bei dem Schreiben des EEPROM-Speichers in Klasse Parameter",
  },
  9574: {
    category: "Fehler",
    text: "Fehler bei dem Lesen des EEPROM-Speichers in Klasse Parameter",
  },
  9575: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung eines Integer-Parameters",
  },
  9576: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung eines Bool-Parameters",
  },
  9577: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung eines PID-Parameters",
  },
  9578: {
    category: "Fehler",
    text: "Leerer eingehender Parameter in Klasse Parameter",
  },
  9579: { category: "Fehler", text: "Anzahl Austragsbänder ist zu groß" },
  9580: { category: "Fehler", text: "Anzahl Dosierschieber ist zu groß" },
  9581: {
    category: "Fehler",
    text: "Ungültiger Parameter-Typ vom Display angefragt",
  },
  9582: {
    category: "Fehler",
    text: "Parameteränderung in Steuerung durch Display war nicht erfolgreich",
  },
  9583: {
    category: "Fehler",
    text: "Anfrage vom Display für alleParameter ändern eingegangen",
  },
  9584: {
    category: "Fehler",
    text: "Interface Fahrantrieb ist null in Klasse clsParameter",
  },
  9585: {
    category: "Fehler",
    text: "Interface Fahrantrieb ist nicht initialisiert in Klasse clsParameter",
  },
  9586: {
    category: "Fehler",
    text: "Parameter soll gesetzt werden aber die Parkbremse ist nicht eingelegt",
  },
  9587: {
    category: "Fehler",
    text: "Aktueller Benutzer kann nicht gelesen werden, um einen Parameter zu setzen",
  },
  9588: {
    category: "Fehler",
    text: "Interface des Parameters zum Setzen ist null",
  },
  9589: {
    category: "Fehler",
    text: "Bool-Parameter kann im Array nicht gefunden werden",
  },
  9590: {
    category: "Fehler",
    text: "Int-Parameter kann im Array nicht gefunden werden",
  },
  9591: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  9592: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  9600: {
    category: "Fehler",
    text: "Berechnete Checksumme stimmt nicht mit empfangener Checksumme Fahrantrieb überein",
  },
  9601: {
    category: "Fehler",
    text: "Aktueller Nachrichtenzähler für Fahrantrieb stimmt nicht mit empfangenem Wert überein",
  },
  9602: {
    category: "Fehler",
    text: "Berechnete Checksumme stimmt nicht mit empfangener Checksumme Armlehne überein",
  },
  9603: {
    category: "Fehler",
    text: "Aktueller Nachrichtenzähler für Armlehne stimmt nicht mit empfangenem Wert überein",
  },
  9604: {
    category: "Fehler",
    text: "Berechnete Checksumme stimmt nicht mit empfangener Checksumme Lenkung überein",
  },
  9605: {
    category: "Fehler",
    text: "Aktueller Nachrichtenzähler für Lenkung stimmt nicht mit empfangenem Wert überein",
  },
  9606: { category: "Fehler", text: "Fehlerhafte CAN Daten Gewicht empfangen" },
  9607: {
    category: "Fehler",
    text: "Can Gewichtsdaten haben einen Über-/ oder Unterlauf",
  },
  9608: { category: "Fehler", text: "Ungültiger Zustand CAN Gewichtsdaten" },
  9609: {
    category: "Fehler",
    text: "Fehler in Ausgangsgruppe 0. Bitte Service kontaktieren",
  },
  9610: {
    category: "Fehler",
    text: "Fehler in Ausgangsgruppe 1. Bitte Service kontaktieren",
  },
  9611: {
    category: "Fehler",
    text: "Fehler in Ausgangsgruppe 2. Bitte Service kontaktieren",
  },
  9612: {
    category: "Fehler",
    text: "Can-Bus 0 ist ausgeschaltet. Versuche Neustart",
  },
  9613: {
    category: "Fehler",
    text: "Can-Bus 1 ist ausgeschaltet. Versuche Neustart",
  },
  9614: {
    category: "Fehler",
    text: "Can-Bus 2 ist ausgeschaltet. Versuche Neustart",
  },
  9615: {
    category: "Fehler",
    text: "Can-Bus 3 ist ausgeschaltet. Versuche Neustart",
  },
  9616: { category: "Fehler", text: "Interner Systemfehler Output Group" },
  9617: { category: "Fehler", text: "Unbekannter Fehler Output Group" },
  9618: {
    category: "Fehler",
    text: "Interner Kommunikationsfehler Output Group",
  },
  9619: {
    category: "Fehler",
    text: "Überschreitung Spannung Ausgangsgruppen-Versorgung Output Group",
  },
  9620: {
    category: "Fehler",
    text: "Überschreitung des maximalen Stromes Output Group",
  },
  9621: {
    category: "Fehler",
    text: "Startup-Test des Gruppenschalters fehlgeschlagen Output Group",
  },
  9622: {
    category: "Fehler",
    text: "Mindestens ein Ausgang ist im Fehlerzustand Output Group",
  },
  9623: {
    category: "Fehler",
    text: "Signal eingefroren - Zustand high Output Group",
  },
  9624: {
    category: "Fehler",
    text: "Signal eingefroren - Zustand low Output Group",
  },
  9625: {
    category: "Fehler",
    text: "Unterschreitung Spannung Ausgangsgruppen-Versorgung Output Group",
  },
  9626: {
    category: "Fehler",
    text: "Eingangsparameter ist ungültig bzw. überschreitet bereich Output Group",
  },
  9627: { category: "Fehler", text: "Keine gültige Kalibrierung Output Group" },
  9628: { category: "Fehler", text: "Kein Zugriff auf Ressource Output Group" },
  9629: {
    category: "Fehler",
    text: "Überschreitung des maximalen Stromes Output Group",
  },
  9630: {
    category: "Fehler",
    text: "Mindestens ein Ausgang ist im Fehlerzustand Output Group",
  },
  9631: {
    category: "Fehler",
    text: "Ungültige Filtereinstellung Output Group",
  },
  9632: {
    category: "Fehler",
    text: "Signal eingefroren - Zustand high Output Group",
  },
  9633: {
    category: "Fehler",
    text: "Signal eingefroren - Zustand low Output Group",
  },
  9634: { category: "Fehler", text: "Unbekannter Fehler Output Group" },
  9635: {
    category: "Fehler",
    text: "CAN Timeout Lenkung erkannt. Bitte Maschine stoppen! Lenkrechner eingeschaltet?",
  },
  9636: {
    category: "Fehler",
    text: "Timeout Arbeiten 2 Steuerung. Bitte Sicherung und CAN-Verbindung prüfen",
  },
  9637: {
    category: "Fehler",
    text: "Timeout Arbeiten 3 Steuerung. Bitte Sicherung und CAN-Verbindung prüfen",
  },
  9638: {
    category: "Fehler",
    text: "Timeout Arbeiten 3 Steuerung. Bitte Sicherung und CAN-Verbindung prüfen",
  },
  9700: {
    category: "Fehler",
    text: "Parameter-Interface ist null in Klasse clsDemoModus",
  },
  9701: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse clsDemoModus",
  },
  9702: {
    category: "Fehler",
    text: "Demo Modus konnte die Test-Konfig nicht setzen",
  },
  9703: {
    category: "Fehler",
    text: "Sie fahren noch keine Strautmann-Maschine?",
  },
  9850: { category: "Fehler", text: "Ausnahmefehler" },
  9901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  9902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  9903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  9904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  9905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  9906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  9907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  9908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  9909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  9910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  9911: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  9912: { category: "Fehler", text: "PWM-Ausgang Drahtbruch oder Kurzschluss" },
  9913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  9914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  9915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  9916: { category: "Fehler", text: "PWM-Ausgang hat eine zu hohe Temperatur" },
  9917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  9918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  9919: { category: "Fehler", text: "Bereichsfehler PWM" },
  9920: { category: "Fehler", text: "Safety Fehler PWM" },
  9921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  9922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  9923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  9924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  9925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  9926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  9927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  9928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  9929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  9930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  9931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  9932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  9933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  9934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  9935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  9936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  9937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  9938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  9939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  9941: { category: "Fehler", text: "Digitaler Eingang zur Zeit in Benutzung" },
  9942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  9943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  9944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  9945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  9946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  9947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  9948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  9949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  9950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  9951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  9952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  9953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  9954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  9955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  9956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  9957: { category: "Fehler", text: "Digitaler Eingang Fehler Gruppenausgang" },
  9958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  9959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  9961: { category: "Fehler", text: "Digitaler Ausgang zur Zeit in Benutzung" },
  9962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  9963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  9964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  9965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  9966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  9967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  9968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  9969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  9970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  9971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  9972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  9973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  9974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  9975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  9976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  9977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  9978: { category: "Fehler", text: "Digitaler Ausgang Fehler Gruppenausgang" },
  9979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  9980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  9981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  9982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  9983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  9984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  9985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  9986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  9987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  9988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  9989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  9990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  9991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  9992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  9993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  9994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  9995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  9996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  9997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  9998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  9999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  10001: { category: "Fehler", text: "Überlauf Speicher für die Diagnose" },
  10002: {
    category: "Fehler",
    text: "Diagnoseinterface für Überwachung ist ungültig",
  },
  10003: {
    category: "Fehler",
    text: "Managementinterface für Überwachung ist ungültig",
  },
  10004: {
    category: "Fehler",
    text: "J1939-Interface für Überwachung ist ungültig",
  },
  10005: {
    category: "Fehler",
    text: "CANopen-Interface für Überwachung ist ungültig",
  },
  10006: {
    category: "Fehler",
    text: "Warnung: Luftfilter muss gewartet werden",
  },
  10007: { category: "Fehler", text: "Hydrauliköl-Füllstand zu gering" },
  10008: {
    category: "Fehler",
    text: "Betriebsmodus ist Straßenfahrt, Band 1 ist nicht auf Position",
  },
  10009: {
    category: "Fehler",
    text: "Betriebsmodus ist Straßenfahrt, Band 2 ist nicht auf Position",
  },
  10010: {
    category: "Fehler",
    text: "Diesel-Füllstand Sensorfehler: Unterhalb min. Wert",
  },
  10011: {
    category: "Fehler",
    text: "Fehlerhafte Berechung des Diesel-Füllstandes",
  },
  10012: { category: "Fehler", text: "Diesel-Füllstand ist unterhalb von 10%" },
  10013: { category: "Fehler", text: "Diesel-Füllstand ist unterhalb von 20%" },
  10014: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Überwachung gefunden",
  },
  10015: { category: "Fehler", text: "Ungültiger Freigabetyp angefragt" },
  10016: {
    category: "Fehler",
    text: "Diagnoseinterface für Überwachung ist null",
  },
  10017: {
    category: "Fehler",
    text: "Diagnoseinterface für Überwachung ist nicht initialisiert",
  },
  10018: {
    category: "Fehler",
    text: "Management-Interface für Überwachung ist nicht initialisiert",
  },
  10019: {
    category: "Fehler",
    text: "CAN-Interface canOpen für Überwachung ist nicht initialisiert",
  },
  10020: {
    category: "Fehler",
    text: "CAN-Interface J1939 für Überwachung ist nicht initialisiert",
  },
  10021: {
    category: "Fehler",
    text: "Ungültige Kühlernummer gefunden in Überwachung",
  },
  10022: {
    category: "Fehler",
    text: "Gelesener Diagnosewert ist null in Überwachung",
  },
  10023: {
    category: "Fehler",
    text: "Gelesener Diagnosewert kann nicht in boolschen Wert konvertiert werden",
  },
  10024: {
    category: "Fehler",
    text: "Gelesener Diagnosewert kann nicht in Integer-Wert konvertiert werden",
  },
  10025: {
    category: "Fehler",
    text: "Gelesener Diagnosewert kann nicht in Real-Wert konvertiert werden",
  },
  10026: {
    category: "Fehler",
    text: "Parameter-Interface ist nicht initialisiert in Klasse Überwachung",
  },
  10027: {
    category: "Fehler",
    text: "Parameter-Interface ist ungültig in Klasse Überwachung",
  },
  10028: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Ölkühler 1 ist ungültig",
  },
  10029: {
    category: "Fehler",
    text: "Interface zu PWM-Ausgang Ansteuerung Ölkühler 2 ist ungültig",
  },
  10030: {
    category: "Fehler",
    text: "Interface des analogen EingangesSensor Druck Schrägförderer ist ungültig",
  },
  10031: {
    category: "Fehler",
    text: "Interface des analogen Einganges Temperatur Hydraulik-Öl ist ungültig",
  },
  10032: {
    category: "Fehler",
    text: "Interface des analogen Einganges Dieselstand ist ungültig",
  },
  10033: {
    category: "Fehler",
    text: "Interface des analogen Einganges Schwimmschalter Speisedruck 1 ist ungültig",
  },
  10034: {
    category: "Fehler",
    text: "Interface des analogen Einganges Schwimmschalter Speisedruck 2 ist ungültig",
  },
  10038: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Sicherheitstaster 1 ist ungültig",
  },
  10039: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Sicherheitstaster 2 ist ungültig",
  },
  10040: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Rückfahrsignal ist ungültig",
  },
  10041: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Not-Halt (Öffner 1) ist ungültig",
  },
  10042: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Speicherladedruck 110bar ist ungültig",
  },
  10043: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Speisedruck 13bar ist ungültig",
  },
  10044: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Filter Speiseöl 5bar ist ungültig",
  },
  10045: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Luftfilterwartung ist ungültig",
  },
  10046: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Druckschalter Klimaanage ist ungültig",
  },
  10047: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Druck Ölfilter 1,2bar ist ungültig",
  },
  10048: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Füllstand Hydrauliköl ist ungültig",
  },
  10049: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Sitzkontakt 1 ist ungültig",
  },
  10050: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Sitzkontakt 2 ist ungültig",
  },
  10051: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Ansteuerung Klimakompressor ist ungültig",
  },
  10052: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Diagnose Hydraulikkühler 1 ist ungültig",
  },
  10053: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Diagnose Hydraulikkühler 2 ist ungültig",
  },
  10054: {
    category: "Fehler",
    text: "Interface des Frequenz-Einganges Drehzahl Fahrmotor 1 ist ungültig",
  },
  10055: {
    category: "Fehler",
    text: "Interface des Frequenz-Einganges Drehzahl Mischer ist ungültig",
  },
  10056: {
    category: "Fehler",
    text: "Interface des Frequenz-Einganges Blinker-Kontrolle ist ungültig",
  },
  10057: {
    category: "Fehler",
    text: "Interface des Frequenz-Einganges Fernlicht-Kontrolle ist ungültig",
  },
  10058: {
    category: "Fehler",
    text: "Interface des digitalen Ausganges Freigabe Arbeitsfunktionen ist ungültig",
  },
  10059: {
    category: "Fehler",
    text: "Bereichsfehler bei dem Entzug einer Freigabe",
  },
  10060: {
    category: "Fehler",
    text: "Ungültige eingehende Freigabe für den Entzug der Freigabe",
  },
  10061: {
    category: "Fehler",
    text: "Anfrage zum Entziehen der Freigabe kann nicht in die Liste eingetragen werden",
  },
  10062: {
    category: "Fehler",
    text: "Interface Liste entzogener Freigaben kann nicht in clsFreigabeEntziehen umgewandelt werden",
  },
  10063: {
    category: "Fehler",
    text: "Datum zum Entzug der Freigabe kann nicht in der Liste gespeichert werden",
  },
  10064: {
    category: "Fehler",
    text: "Datum zum Geben der Freigabe kann nicht von der Liste gelöscht werden",
  },
  10065: {
    category: "Fehler",
    text: "Ungültiges Interface zu einer Freigabe gefunden",
  },
  10066: {
    category: "Fehler",
    text: "Diesel-Füllstand kann nicht bestimmt werden",
  },
  10067: {
    category: "Fehler",
    text: "Fehler bei der Zeitmessung für niedrige Batteriespannung in Klasse clsUeberwachung gefunden",
  },
  10068: { category: "Fehler", text: "Die Batteriespannung ist zu niedrig" },
  10069: {
    category: "Fehler",
    text: "Mindestens ein Interface konnte nicht erfolgreich gesetzt werden in Klasse clsUeberwachung",
  },
  10070: {
    category: "Fehler",
    text: "Interface des digitalen Einganges Not-Halt (Öffner 2) ist ungültig",
  },
  10071: {
    category: "Fehler",
    text: "Interface Diesel ist null in clsUeberwachung",
  },
  10072: {
    category: "Fehler",
    text: "Interface Diesel ist nicht initialisiert in clsUeberwachung",
  },
  10073: {
    category: "Fehler",
    text: "Fahrantrieb-Interface ist null in Klasse clsUeberwachung",
  },
  10074: {
    category: "Fehler",
    text: "Fahrantrieb-Interface ist nicht initialisiert in Klasse clsUeberwachung",
  },
  10075: {
    category: "Fehler",
    text: "Mischer ist eingeschaltet und Schieber ist geöffnet, das Band läuft aber nicht",
  },
  10076: {
    category: "Fehler",
    text: "Mindestens ein Schieber ist geöffnet, Betriebsmodus ist nicht Austrag",
  },
  10077: {
    category: "Fehler",
    text: "Interface Position Austrageband 1 ist gleich null",
  },
  10078: {
    category: "Fehler",
    text: "Interface Position Austrageband 1 kann nicht in einen digitalen Ausgang umgewandelt werden",
  },
  10079: {
    category: "Fehler",
    text: "Interface Position Austrageband 2 ist gleich null",
  },
  10080: {
    category: "Fehler",
    text: "Interface Position Austrageband 2 kann nicht in einen digitalen Ausgang umgewandelt werden",
  },
  10081: {
    category: "Fehler",
    text: "Ölkühler soll gesetzt werden, die Maschine ist aber kein Primus 600 / Primus 900",
  },
  10082: {
    category: "Fehler",
    text: "Ölkühler soll gesetzt werden, mindestens ein Interface ist aber null",
  },
  10083: {
    category: "Fehler",
    text: "Diagnoseeingang Hy-Kühler 1 zeigt einen Fehler an",
  },
  10084: {
    category: "Fehler",
    text: "Diagnoseeingang Hy-Kühler 2 zeigt einen Fehler an",
  },
  10085: {
    category: "Fehler",
    text: "Unbekannter Fehler Diagnoseeingang in clsueberwachung gefunden",
  },
  10086: {
    category: "Fehler",
    text: "Mischer ist nicht eingeschaltet, obwohl die Fräse läuft",
  },
  10087: {
    category: "Fehler",
    text: "Cleanfix-Intervall kann nicht zurückgesetzt werden",
  },
  10088: { category: "Fehler", text: "Interface Austragsband ist null" },
  10089: {
    category: "Fehler",
    text: "Interface Austragsband ist nicht initialisiert",
  },
  10090: { category: "Fehler", text: "Interface Austragsband 2 ist null" },
  10150: {
    category: "Fehler",
    text: "Simulierter Wert kann nicht zurueckgesetzt werden, da kein Interface-Datentyp valide ist",
  },
  10151: {
    category: "Fehler",
    text: "Zu simulierender Wert kann nicht gesetzt werden. Anfragende Klasse nicht berechtigt",
  },
  10152: {
    category: "Fehler",
    text: "Diagnosewert kann nicht gesetzt werden. Anfragende Klasse nicht berechtigt",
  },
  10153: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose in Diagnose gefunden",
  },
  10154: {
    category: "Fehler",
    text: "Abzumeldender Diagnosewert ist null in Diagnose",
  },
  10155: {
    category: "Fehler",
    text: "Eingehender Diagnosewert kann nicht gelöscht werden - nicht unterstützt",
  },
  10156: {
    category: "Fehler",
    text: "Interner Fehler bei dem Abmelden eines Diagnosewertes",
  },
  10157: {
    category: "Fehler",
    text: "Anzumeldender Diagnosewert ist null in Diagnose",
  },
  10158: {
    category: "Fehler",
    text: "Eingehender Diagnosewert kann nicht hinzugefügt werden - nicht unterstützt",
  },
  10159: {
    category: "Fehler",
    text: "Eingehender Wert kann nicht in Diagnosewert konvertiert werden",
  },
  10160: {
    category: "Fehler",
    text: "Interner Fehler bei dem Anmelden eines Diagnosewertes",
  },
  10161: {
    category: "Fehler",
    text: "Zu lesendes Attribut aus Diagnoseliste ist leer",
  },
  10162: {
    category: "Fehler",
    text: "Zu lesendes Attribut aus Diagnoseliste ist nicht vorhanden",
  },
  10163: {
    category: "Fehler",
    text: "Zu lesender Diagnosewert ist nicht vorhanden",
  },
  10164: { category: "Fehler", text: "Eingehender Diagnosewert ist null" },
  10165: {
    category: "Fehler",
    text: "Zu lesendes Attribut aus Verbindungsliste ist nicht vorhanden",
  },
  10166: {
    category: "Fehler",
    text: "Zu lesendes Attribut aus Verbindungsliste ist leer",
  },
  10167: {
    category: "Fehler",
    text: "Diagnoseliste soll mit Index gelesen werden, ist aber leer",
  },
  10168: {
    category: "Fehler",
    text: "Diagnosewert konnte nicht aus der Diagnoseliste geladen werden. Index nicht vorhanden",
  },
  10169: {
    category: "Fehler",
    text: "Zu setzender boolscher Simulationswert ist null",
  },
  10170: {
    category: "Fehler",
    text: "Zu setzender boolscher Simulationswert hat einen falschen Datentyp",
  },
  10171: {
    category: "Fehler",
    text: "Eingehender Diagnosewert für persistente Speicherung ist null",
  },
  10172: {
    category: "Fehler",
    text: "Gelesener Wert aus Diagnoseliste ist null",
  },
  10173: {
    category: "Fehler",
    text: "Diagnose kann simulierte Zahl nicht setzen - kein unterstützter Datentyp",
  },
  10174: {
    category: "Fehler",
    text: "Diagnosewert Int ist nicht initialisiert",
  },
  10175: {
    category: "Fehler",
    text: "Diagnosewert Bool ist nicht initialisiert",
  },
  10176: {
    category: "Fehler",
    text: "Diagnosewert Real ist nicht initialisiert",
  },
  10177: {
    category: "Fehler",
    text: "Diagnosewert kann der Diagnoseliste nicht hinzugefügt werden",
  },
  10178: {
    category: "Fehler",
    text: "Ungültiger Datentyp für Diagnosewert gefunden",
  },
  10179: {
    category: "Fehler",
    text: "Gelesener Diagnosewert ist null in clsDiagnose",
  },
  10180: {
    category: "Fehler",
    text: "Display möchte Diagnosewert setzen, dieser ist aber nicht vorhanden",
  },
  10181: {
    category: "Fehler",
    text: "Display möchte einen Diagnosewert setzen, der Typ ist allerdings ungültig",
  },
  10182: {
    category: "Fehler",
    text: "Diesel-Interface ist null in Klasse clsDiagnose",
  },
  10183: {
    category: "Fehler",
    text: "Diesel-Interface ist nicht initialisiert in Klasse clsDiagnose",
  },
  10184: {
    category: "Fehler",
    text: "Eingehende Simulation bis Betriebsstunde: Zahlenwert ist größer als 0 aber kleiner aktueller Betriebsstunde",
  },
  10185: {
    category: "Fehler",
    text: "Betriebsstunden sollen überschrieben werden. Dies ist nicht erlaubt.",
  },
  10186: {
    category: "Fehler",
    text: "Unbekannter interface-Typ für Diagnosewert gefunden",
  },
  10187: {
    category: "Fehler",
    text: "Diagnose konnte nicht feststellen, wie viele Werte nach Neustart gesetzt sein sollen",
  },
  10188: {
    category: "Fehler",
    text: "Array überschriebener Diagnosewerte konnte nicht gelöscht werden",
  },
  10189: { category: "Fehler", text: "Kalibrierung: Fehlerhafte Diagnose-ID" },
  10190: {
    category: "Fehler",
    text: "Kalibrierung: Wert konnte nicht gesetzt werden",
  },
  10191: {
    category: "Fehler",
    text: "Kalibrierung: Element konnte nicht geladen werden",
  },
  10192: {
    category: "Fehler",
    text: "Kalibrierung: Interface des Elements ist null",
  },
  10193: {
    category: "Fehler",
    text: "Kalibrierung: Interface konnte nicht in korrekten Datentyp konvertiert werden",
  },
  10194: {
    category: "Fehler",
    text: "Kalibrierung konnte nicht gesetzt werden",
  },
  10195: {
    category: "Fehler",
    text: "Wert kalibriert. Die Änderung wird nach Neustart der Maschine wirksam",
  },
  10196: {
    category: "Fehler",
    text: "Diagnosewert wurde nicht in der Liste der Definitionen gefunden",
  },
  10197: {
    category: "Fehler",
    text: "Interface Diagnose-Definition ist null bei der Kalibrierung des Wertes",
  },
  10198: {
    category: "Fehler",
    text: "Kalibrierung: Wert ist außerhalb des zulässigen Bereiches",
  },
  10199: {
    category: "Fehler",
    text: "Fehler bei der Initialisierung des Arrays für die Kalibrierungsdaten",
  },
  10200: { category: "Fehler", text: "Interface Diagnosewert ist null" },
  10250: { category: "Fehler", text: "Nicht initialisierte Freigabe gefunden" },
  10251: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose in Freigabe gefunden",
  },
  10252: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  10253: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  10254: {
    category: "Fehler",
    text: "Interface CleanFix konnte nicht gesetzt werden",
  },
  10255: {
    category: "Fehler",
    text: "Cleanfix konnte nicht eingeschaltet werden",
  },
  10256: {
    category: "Fehler",
    text: "Cleanfix konnte nicht ausgeschaltet werden",
  },
  10257: { category: "Fehler", text: "Interface Zündung E-Feeding ist null" },
  10258: {
    category: "Fehler",
    text: "Interface Zündung E-Feeding kann nicht konvertiert werden",
  },
  10259: {
    category: "Fehler",
    text: "Interface Ladeklappe geschlossen ist null in Klasse Überwachung",
  },
  10260: {
    category: "Fehler",
    text: "Interface Ladeklappe geschlossen kann nicht konvertiert werden in Klasse Überwachung",
  },
  10261: {
    category: "Fehler",
    text: "Interface HVIL ist null in Klasse Überwachung",
  },
  10262: {
    category: "Fehler",
    text: "Interface HVIL kann nicht konvertiert werden in Klasse Überwachung",
  },
  10263: {
    category: "Fehler",
    text: "Hydrauliköl zu kalt, um Diesel-Drehzahl zu verstellen. Tipp: Durch einschalten des Mischers kann das Hydrauliköl aufgeheizt werden.",
  },
  10264: {
    category: "Fehler",
    text: "Diesel-Drehzahl darf nun verstellt werden",
  },
  10265: {
    category: "Fehler",
    text: "Interface BMS ist  null in Klasse Überwachung",
  },
  10267: {
    category: "Fehler",
    text: "Die Maschine ist noch nicht aktiv. Die Motoren können noch nicht gestartet werden.",
  },
  10268: {
    category: "Fehler",
    text: "Die Ladeklappe ist offen. Die Fahrfreigabe kann nicht erteilt werden.",
  },
  10269: {
    category: "Fehler",
    text: "Fahrersitz ist leer mit aktiven Motoren",
  },
  10270: { category: "Fehler", text: "Hydrauliköl-Temperatur zu niedrig" },
  10271: { category: "Fehler", text: "Hydrauliköl-Temperatur zu hoch" },
  10272: { category: "Fehler", text: "Kühlwasser-Temperatur zu niedrig" },
  10273: { category: "Fehler", text: "Kühlwasser-Temperatur zu hoch" },
  10274: {
    category: "Fehler",
    text: "Wartung fällig. Bitte kontaktieren Sie Ihre Service-Werkstatt für einen Wartungstermin.",
  },
  10275: {
    category: "Fehler",
    text: "Index des zu löschenden Elements für Freigabe ist zu groß",
  },
  10276: { category: "Fehler", text: "Nothalt ist aktiv" },
  10277: { category: "Fehler", text: "Interface Fräsmotor ist null" },
  10278: { category: "Fehler", text: "Interface Bremsdruckschalter ist null" },
  10279: {
    category: "Fehler",
    text: "Interface Bremsdruckschalter kann nicht konvertiert werden in Klasse Überwachung",
  },
  10280: {
    category: "Fehler",
    text: "Hydrauliköl-Temperatur zu hoch. Hydraulikpumpe gesperrt.",
  },
  10281: {
    category: "Fehler",
    text: "Hydrauliköl-Temperatur zu hoch. Pumpendrehzahl reduziert",
  },
  10282: { category: "Fehler", text: "Interface Mischer nicht initialisiert" },
  10283: { category: "Fehler", text: "Interface Mischer ist null" },
  10400: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose für Primus Management gefunden",
  },
  10401: {
    category: "Fehler",
    text: "Ungültiges Diagnoseinterface für Primus Management gefunden",
  },
  10402: {
    category: "Fehler",
    text: "Nicht initialisierter Can Bus J1939 für Primus Management gefunden",
  },
  10403: {
    category: "Fehler",
    text: "Ungültiger Can Bus J1939 für Primus Management gefunden",
  },
  10404: {
    category: "Fehler",
    text: "Nicht initialisierter Can Bus canOpen für Primus Management gefunden",
  },
  10405: {
    category: "Fehler",
    text: "Ungültiger Can Bus canOpen für Primus Management gefunden",
  },
  10406: {
    category: "Fehler",
    text: "Nicht initialisiertes Primus Management gefunden",
  },
  10407: {
    category: "Fehler",
    text: "Nicht initialisierter CAN-Bus für Primus-Management gefunden",
  },
  10408: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Primus Management in clsManagement gefunden",
  },
  10409: {
    category: "Fehler",
    text: "Keypad-Beleuchtung konnte nicht gesetzt werden für das Primus-Management",
  },
  10410: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist null in Klasse clsManagement",
  },
  10411: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist nicht initialisiert in Klasse clsManagement",
  },
  10412: {
    category: "Fehler",
    text: "Betriebsmodus konnte nicht über das Display gesetzt werden",
  },
  10413: {
    category: "Fehler",
    text: "Interface Fahrantrieb nicht initialisiert",
  },
  10414: { category: "Fehler", text: "Interface Fahrantrieb ist null" },
  10415: {
    category: "Fehler",
    text: "Geschwindigkeit für einen Wechsel in den Arbeitsmodus zu hoch",
  },
  10500: { category: "Fehler", text: "Not-Aus Taster ist betätigt" },
  10501: { category: "Fehler", text: "HVIL ist unterbrochen" },
  10502: {
    category: "Fehler",
    text: "Isolationsfehler bei letzter Nutzung erkannt. Hochspannungs-Funktionen gesperrt.",
  },
  10600: { category: "Fehler", text: "Luftdruck für Fahrwerk zu gering" },
  10700: { category: "Fehler", text: "Diagnoseinterface ist null" },
  10701: { category: "Fehler", text: "Diagnoseinterface nicht initialisiert" },
  10702: { category: "Fehler", text: "Interface Spiegelheizung ist null" },
  10901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  10902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  10903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  10904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  10905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  10906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  10907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  10908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  10909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  10910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  10911: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  10912: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  10913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  10914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  10915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  10916: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu hohe Temperatur",
  },
  10917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  10918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  10919: { category: "Fehler", text: "Bereichsfehler PWM" },
  10920: { category: "Fehler", text: "Safety Fehler PWM" },
  10921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  10922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  10923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  10924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  10925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  10926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  10927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  10928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  10929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  10930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  10931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  10932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  10933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  10934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  10935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  10936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  10937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  10938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  10939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  10941: {
    category: "Fehler",
    text: "Digitaler Eingang zur Zeit in Benutzung",
  },
  10942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  10943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  10944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  10945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  10946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  10947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  10948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  10949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  10950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  10951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  10952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  10953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  10954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  10955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  10956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  10957: {
    category: "Fehler",
    text: "Digitaler Eingang Fehler Gruppenausgang",
  },
  10958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  10959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  10961: {
    category: "Fehler",
    text: "Digitaler Ausgang zur Zeit in Benutzung",
  },
  10962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  10963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  10964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  10965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  10966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  10967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  10968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  10969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  10970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  10971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  10972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  10973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  10974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  10975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  10976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  10977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  10978: {
    category: "Fehler",
    text: "Digitaler Ausgang Fehler Gruppenausgang",
  },
  10979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  10980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  10981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  10982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  10983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  10984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  10985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  10986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  10987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  10988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  10989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  10990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  10991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  10992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  10993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  10994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  10995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  10996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  10997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  10998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  10999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  11000: {
    category: "Fehler",
    text: "Interface Benutzerverwaltung ist null in Übersetzung",
  },
  11001: {
    category: "Fehler",
    text: "Interface Benutzerverwaltung ist nicht initialisiert in Übersetzung",
  },
  11002: {
    category: "Fehler",
    text: "Klasse Übersetzung ist nicht initialisiert in Übersetzung",
  },
  11003: {
    category: "Fehler",
    text: "Attribut aus Fehlerliste kann nicht übersetzt werden - Attribut nicht gefunden",
  },
  11004: {
    category: "Fehler",
    text: "Eingegebenes Attribut zur Übersetzung aus Visu ist leer",
  },
  11005: {
    category: "Fehler",
    text: "Eingegebenes Attribut zur Übersetzung aus Parameterliste ist leer",
  },
  11300: {
    category: "Fehler",
    text: "Nicht initialisierte Benutzerverwaltung gefunden",
  },
  11301: {
    category: "Fehler",
    text: "Undefinierten Benutzer in Benutzerverwaltung gefunden",
  },
  11302: {
    category: "Fehler",
    text: "Ungültigen eingeloggten Benutzer in Benutzerverwaltung gefunden",
  },
  11303: {
    category: "Fehler",
    text: "Der aktuelle Benutzer ist undefiniert in Benutzerverwaltung",
  },
  11500: {
    category: "Fehler",
    text: "Einzelner Fehler kann nicht gelöscht werden",
  },
  11901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  11902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  11903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  11904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  11905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  11906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  11907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  11908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  11909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  11910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  11911: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  11912: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  11913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  11914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  11915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  11916: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu hohe Temperatur",
  },
  11917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  11918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  11919: { category: "Fehler", text: "Bereichsfehler PWM" },
  11920: { category: "Fehler", text: "Safety Fehler PWM" },
  11921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  11922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  11923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  11924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  11925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  11926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  11927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  11928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  11929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  11930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  11931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  11932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  11933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  11934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  11935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  11936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  11937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  11938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  11939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  11941: {
    category: "Fehler",
    text: "Digitaler Eingang zur Zeit in Benutzung",
  },
  11942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  11943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  11944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  11945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  11946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  11947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  11948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  11949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  11950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  11951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  11952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  11953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  11954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  11955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  11956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  11957: {
    category: "Fehler",
    text: "Digitaler Eingang Fehler Gruppenausgang",
  },
  11958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  11959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  11961: {
    category: "Fehler",
    text: "Digitaler Ausgang zur Zeit in Benutzung",
  },
  11962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  11963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  11964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  11965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  11966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  11967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  11968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  11969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  11970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  11971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  11972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  11973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  11974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  11975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  11976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  11977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  11978: {
    category: "Fehler",
    text: "Digitaler Ausgang Fehler Gruppenausgang",
  },
  11979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  11980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  11981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  11982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  11983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  11984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  11985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  11986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  11987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  11988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  11989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  11990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  11991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  11992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  11993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  11994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  11995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  11996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  11997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  11998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  11999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  12001: {
    category: "Fehler",
    text: "Fehlerhafte Konfiguration: Austragsband 1 ist undefiniert",
  },
  12002: {
    category: "Fehler",
    text: "Fehlerhafte Konfiguration: Austragsband 2 ist undefiniert",
  },
  12901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  12902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  12903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  12904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  12905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  12906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  12907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  12908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  12909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  12910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  12911: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  12912: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  12913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  12914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  12915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  12916: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu hohe Temperatur",
  },
  12917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  12918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  12919: { category: "Fehler", text: "Bereichsfehler PWM" },
  12920: { category: "Fehler", text: "Safety Fehler PWM" },
  12921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  12922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  12923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  12924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  12925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  12926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  12927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  12928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  12929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  12930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  12931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  12932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  12933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  12934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  12935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  12936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  12937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  12938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  12939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  12941: {
    category: "Fehler",
    text: "Digitaler Eingang zur Zeit in Benutzung",
  },
  12942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  12943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  12944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  12945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  12946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  12947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  12948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  12949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  12950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  12951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  12952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  12953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  12954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  12955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  12956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  12957: {
    category: "Fehler",
    text: "Digitaler Eingang Fehler Gruppenausgang",
  },
  12958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  12959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  12961: {
    category: "Fehler",
    text: "Digitaler Ausgang zur Zeit in Benutzung",
  },
  12962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  12963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  12964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  12965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  12966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  12967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  12968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  12969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  12970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  12971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  12972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  12973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  12974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  12975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  12976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  12977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  12978: {
    category: "Fehler",
    text: "Digitaler Ausgang Fehler Gruppenausgang",
  },
  12979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  12980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  12981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  12982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  12983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  12984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  12985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  12986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  12987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  12988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  12989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  12990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  12991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  12992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  12993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  12994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  12995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  12996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  12997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  12998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  12999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  13001: {
    category: "Fehler",
    text: "Nicht initialisierte Diagnose in Klasse clsLenkung gefunden",
  },
  13002: {
    category: "Fehler",
    text: "Diagnoseinterface für Lenkung ist ungültig",
  },
  13003: {
    category: "Fehler",
    text: "Nicht initialisierter CAN Bus in Klasse clsLenkung gefunden",
  },
  13004: { category: "Fehler", text: "CAN-Interface für Lenkung ist ungültig" },
  13005: {
    category: "Fehler",
    text: "Nicht initialisiertes Interface Parameter in Klasse clsLenkung gefunden",
  },
  13006: {
    category: "Fehler",
    text: "Parameter-Interface für Lenkung ist ungültig",
  },
  13007: {
    category: "Fehler",
    text: "Klasse clslenkung ist nicht initialisiert",
  },
  13008: {
    category: "Fehler",
    text: "Eingehender CAN-Bus ist null in clsLenkung",
  },
  13009: {
    category: "Fehler",
    text: "Kommando Achsposition Vorderachse für Lenkung hat einen ungültigen Wert",
  },
  13010: {
    category: "Fehler",
    text: "Lenkwinkel über CAN ist außerhalb des gültigen Bereiches",
  },
  13011: {
    category: "Fehler",
    text: "Diagnose FMI für Lenkung ist außerhalb des gültigen Bereiches",
  },
  13012: {
    category: "Fehler",
    text: "Lenkung Lampe gelbe Warnschwelle hat einen ungültigen Zustand",
  },
  13013: {
    category: "Fehler",
    text: "Lenkung Lampe rote Stoplampe hat einen ungültigen Zustand",
  },
  13014: {
    category: "Fehler",
    text: "Lenkung Lampe Schutzlampe hat einen ungültigen Zustand",
  },
  13015: {
    category: "Fehler",
    text: "Ungültiger Zustand Status Lenkachse gefunden in Lenkung",
  },
  13016: {
    category: "Fehler",
    text: "Ungültiger Zustand Liftachse Vorderachse absenken in Lenkung gefunden",
  },
  13017: {
    category: "Fehler",
    text: "Ungültiger Zustand Lenkungstyp Vorderachse in Lenkung gefunden",
  },
  13018: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsunterstützung Vorderachse in Lenkung gefunden",
  },
  13019: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsübertragung Vorderachse in Lenkung gefunden",
  },
  13020: {
    category: "Fehler",
    text: "Ungültiger Zustand aktueller Lenkmodus SPST in Lenkung gefunden",
  },
  13021: {
    category: "Fehler",
    text: "Ungültiger Zustand aktuelles Lenkprogramm SPST in Lenkung gefunden",
  },
  13022: {
    category: "Fehler",
    text: "Ungültiger Zustand aktuelle Synchronisation Achsen SPST in Lenkung gefunden",
  },
  13023: { category: "Fehler", text: "Ungültige SPN für Lenkung gefunden" },
  13024: {
    category: "Fehler",
    text: "Ungültige Anforderung eines Lenkprogramms gefunden in Klasse clsLenkung",
  },
  13025: {
    category: "Fehler",
    text: "Ungültige Anforderung eines Lenkmodus gefunden in Klasse clsLenkung",
  },
  13026: {
    category: "Fehler",
    text: "Nicht initialisiertes Interface Diesel in Klasse Lenkung gefunden",
  },
  13027: {
    category: "Fehler",
    text: "Interface für Diesel ist null in Klasse clsLenkung",
  },
  13028: {
    category: "Fehler",
    text: "Diagnosemeldung Lenkung fehlerhaft: DM01 gibt SPN aus aber keinen FMI",
  },
  13029: {
    category: "Fehler",
    text: "Diagnosemeldung Lenkung fehlerhaft: DM01 gibt FMI aus aber keine SPN",
  },
  13030: { category: "Fehler", text: "Fehler der Lenkung gefunden" },
  13031: {
    category: "Fehler",
    text: "Lenkwinkel Vorderachse ist außerhalb des gültigen Bereiches",
  },
  13032: {
    category: "Fehler",
    text: "Position der Vorderachse für Lenkung hat einen ungültigen Wert",
  },
  13033: {
    category: "Fehler",
    text: "Status der Lenkachse Vorderachse weist einen Fehler auf",
  },
  13034: { category: "Fehler", text: "Lenkmodus weist einen Fehler auf" },
  13035: { category: "Fehler", text: "Lenkprogramm weist einen Fehler auf" },
  13036: {
    category: "Fehler",
    text: "Synchronisation der Lenkachse weist einen Fehler auf",
  },
  13037: {
    category: "Fehler",
    text: "Schutzlampe der Lenkung gibt einen Fehler aus",
  },
  13038: {
    category: "Fehler",
    text: "Gelbe Warnlampe der Lenkung gibt einen Fehler aus",
  },
  13039: {
    category: "Fehler",
    text: "Rote Stoplampe der Lenkung gibt einen Fehler aus. Bitte stellen Sie das Fahrzeug unverzüglich ab!",
  },
  13040: {
    category: "Fehler",
    text: "Fehler bei dem Zurücksetzen der CAN-Daten (senden)",
  },
  13041: {
    category: "Fehler",
    text: "Gleichzeitige Betätigung von Taster plus und minus im manuellen Modus gefunden",
  },
  13042: {
    category: "Fehler",
    text: "Anforderung Hundegang, aber die Maschine ist dafür nicht konfiguriert",
  },
  13043: {
    category: "Fehler",
    text: "Interface CANopen senden ist nicht initialisiert in Klasse clsLenkung",
  },
  13044: {
    category: "Fehler",
    text: "Interface CANopen senden ist null in Klasse clsLenkung",
  },
  13045: {
    category: "Fehler",
    text: "Fehler bei dem Sendevorgang Lenkung über CANopen gefunden",
  },
  13046: {
    category: "Fehler",
    text: "Fehler bei dem Sendevorgang Lenkung über J1939 gefunden",
  },
  13047: {
    category: "Fehler",
    text: "Lenkwinkel Hinterachse ist außerhalb des gültigen Bereiches",
  },
  13048: {
    category: "Fehler",
    text: "Position der Hinterachse für Lenkung hat einen ungültigen Wert",
  },
  13049: {
    category: "Fehler",
    text: "Status der Lenkachse Hinterachse weist einen Fehler auf",
  },
  13050: {
    category: "Fehler",
    text: "Kommando Achsposition Hinterachse für Lenkung hat einen ungültigen Wert",
  },
  13051: {
    category: "Fehler",
    text: "Ungültiger Zustand Liftachse Hinterachse absenken in Lenkung gefunden",
  },
  13052: {
    category: "Fehler",
    text: "Ungültiger Zustand Lenkungstyp Hinterachse in Lenkung gefunden",
  },
  13053: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsunterstützung Hinterachse in Lenkung gefunden",
  },
  13054: {
    category: "Fehler",
    text: "Ungültiger Zustand Typ Lenkungsübertragung Hinterachse in Lenkung gefunden",
  },
  13055: {
    category: "Fehler",
    text: "Fehler bei dem Lesen eines DTC-Codes in Klasse clsLenkung",
  },
  13056: {
    category: "Fehler",
    text: "Interface Can Bus konnte nicht in Interface zum Abfragen von J1939 Lenkung-Standard Werten gewandelt werden",
  },
  13057: {
    category: "Fehler",
    text: "Keypad-Beleuchtung konnte nicht gesetzt werden für die Lenkung",
  },
  13058: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist null in Klasse clsLenkung",
  },
  13059: {
    category: "Fehler",
    text: "Interface Keypad Beleuchtung ist nicht initialisiert in Klasse clsLenkung",
  },
  13060: { category: "Fehler", text: "Schwerwiegender Fehler Lenkung erkannt" },
  13061: {
    category: "Fehler",
    text: "Lenkmodus konnte nicht über das Display gewechselt werden - Timeout",
  },
  13062: {
    category: "Fehler",
    text: "Ungültiger Zustand für manuelles Verstellen der Hinterachse gefunden",
  },
  13063: {
    category: "Fehler",
    text: "Belegung Keypad-Lenkmodi kann nicht gelesen werden in Klasse clsLenkung",
  },
  13064: {
    category: "Fehler",
    text: "Geschwindigkeitswarnung für Sonderlenkmodus",
  },
  13065: {
    category: "Fehler",
    text: "Hundegang kann im Modus Straßenfahrt nicht aktiviert werden",
  },
  13066: {
    category: "Fehler",
    text: "Heckausschwenkunterdrückung kann im Modus Straßenfahrt nicht aktiviert werden",
  },
  13067: {
    category: "Fehler",
    text: "Interface Primus Management ist nicht initialisiert in Klasse clsLenkung",
  },
  13068: {
    category: "Fehler",
    text: "Interface Primus Management ist null in Klasse clsLenkung",
  },
  13069: {
    category: "Fehler",
    text: "Interface Fahrantrieb ist nicht initialisiert in Klasse clsLenkung",
  },
  13070: {
    category: "Fehler",
    text: "Interface Fahrantrieb ist null in Klasse clsLenkung",
  },
  13071: {
    category: "Fehler",
    text: "Lenkmodus geändert. Neuer Modus ist 4-Rad Lenkung",
  },
  13072: {
    category: "Fehler",
    text: "Lenkmodus geändert. Neuer Modus ist diagonale Lenkung",
  },
  13073: {
    category: "Fehler",
    text: "Lenkmodus geändert. Neuer Modus ist Heckausschwenkunterdrückung",
  },
  13074: {
    category: "Fehler",
    text: "Lenkmodus geändert. Neuer Modus ist 2-Rad Lenkung",
  },
  13075: {
    category: "Fehler",
    text: "Lenkmodus geändert. Neuer Modus ist manuelle Verstellung Hinterachse",
  },
  13076: {
    category: "Fehler",
    text: "Interface Demo-Modus ist nicht initialisiert in Klasse Lenkung",
  },
  13077: {
    category: "Fehler",
    text: "Interface Demo-Modus ist null in Klasse Lenkung",
  },
  13078: {
    category: "Fehler",
    text: "Lenkwinkel der Achsen weichen voneinander ab. Keine Parallelfahrt möglich",
  },
  13901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  13902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  13903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  13904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  13905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  13906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  13907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  13908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  13909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  13910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  13911: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  13912: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  13913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  13914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  13915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  13916: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu hohe Temperatur",
  },
  13917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  13918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  13919: { category: "Fehler", text: "Bereichsfehler PWM" },
  13920: { category: "Fehler", text: "Safety Fehler PWM" },
  13921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  13922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  13923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  13924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  13925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  13926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  13927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  13928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  13929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  13930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  13931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  13932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  13933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  13934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  13935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  13936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  13937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  13938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  13939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  13941: {
    category: "Fehler",
    text: "Digitaler Eingang zur Zeit in Benutzung",
  },
  13942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  13943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  13944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  13945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  13946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  13947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  13948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  13949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  13950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  13951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  13952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  13953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  13954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  13955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  13956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  13957: {
    category: "Fehler",
    text: "Digitaler Eingang Fehler Gruppenausgang",
  },
  13958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  13959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  13961: {
    category: "Fehler",
    text: "Digitaler Ausgang zur Zeit in Benutzung",
  },
  13962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  13963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  13964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  13965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  13966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  13967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  13968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  13969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  13970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  13971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  13972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  13973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  13974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  13975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  13976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  13977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  13978: {
    category: "Fehler",
    text: "Digitaler Ausgang Fehler Gruppenausgang",
  },
  13979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  13980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  13981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  13982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  13983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  13984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  13985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  13986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  13987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  13988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  13989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  13990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  13991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  13992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  13993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  13994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  13995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  13996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  13997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  13998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  13999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  14001: {
    category: "Fehler",
    text: "Diagnose-Interface nicht initialisiert in clsDiesel",
  },
  14002: {
    category: "Fehler",
    text: "Diagnose-Interface ist ungültig in clsDiesel",
  },
  14003: {
    category: "Fehler",
    text: "CAN-Interface ist nicht initialsiert in clsDiesel",
  },
  14004: {
    category: "Fehler",
    text: "Can-Interface ist ungültig in clsDiesel",
  },
  14005: {
    category: "Fehler",
    text: "Nicht initialisierte Klasse Diesel in clsDiesel gefunden",
  },
  14006: {
    category: "Fehler",
    text: "Ungültige Soll-Drehzahl für den Dieselmotor gefunden",
  },
  14007: {
    category: "Fehler",
    text: "Ungültige Ist-Drehzahl für den Dieselmotor gefunden",
  },
  14008: {
    category: "Fehler",
    text: "CAN-Bus ist nicht initialisiert in clsDiesel",
  },
  14009: {
    category: "Fehler",
    text: "Klasse Diesel ist nicht initialisiert in clsDiesel",
  },
  14010: {
    category: "Fehler",
    text: "Interface Can Bus konnte nicht in Interface zum Abfragen von J1939 Diesel-Standard Werten gewandelt werden",
  },
  14011: {
    category: "Fehler",
    text: "Interface zum Abfragen von J1939 Standard-Werten ist null in clsDiesel",
  },
  14012: {
    category: "Fehler",
    text: "CAN-Wert der Kühlmitteltemperatur ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14013: {
    category: "Fehler",
    text: "CAN-Wert für Handgas ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14014: {
    category: "Fehler",
    text: "CAN-Wert für SPN ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14015: {
    category: "Fehler",
    text: "CAN-Wert für FMI ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14016: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe flash amber warning lamp awl ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14017: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe Flash malfunction indicator mil ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14018: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe flash red stop lamp rsl ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14019: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe flash protection lamp ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14020: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe malfunction indicator lamp ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14021: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe Amber Warn lamp ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14022: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lampe red stop lamp ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14023: {
    category: "Fehler",
    text: "CAN-Wert für DM01 Lamp Protect lamp ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14024: {
    category: "Fehler",
    text: "CAN-Wert für DEF-Level Tank ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14025: {
    category: "Fehler",
    text: "CAN-Wert für DEF-Warnung ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14026: {
    category: "Fehler",
    text: "CAN-Wert für SCR Level ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14027: {
    category: "Fehler",
    text: "CAN-Wert für Engine wait to start lamp ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14028: {
    category: "Fehler",
    text: "CAN-Wert für Exhaust system high temperature lamp command ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14029: {
    category: "Fehler",
    text: "CAN-Wert für Diesel particulate filter lamp ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14030: {
    category: "Fehler",
    text: "CAN-Wert für Diesel particulate filter active regeneration inhibited due to inhibit switch ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14031: {
    category: "Fehler",
    text: "CAN-Wert für Diesel particulate filter status ist außerhalb des zuläsigen Bereiches in clsDiesel",
  },
  14032: {
    category: "Fehler",
    text: "Protection Lamp ist eingeschaltet oder berichtet Fehler",
  },
  14033: {
    category: "Fehler",
    text: "Gelbe Warnlampe ist eingeschaltet oder berichtet Fehler",
  },
  14034: {
    category: "Fehler",
    text: "Rote Stoplampe ist eingeschaltet oder berichtet Fehler",
  },
  14035: {
    category: "Fehler",
    text: "Malfunction Indicator Lamp ist eingeschaltet oder berichtet Fehler",
  },
  14036: {
    category: "Fehler",
    text: "Flash Protection Lamp ist eingeschaltet oder berichtet Fehler",
  },
  14037: {
    category: "Fehler",
    text: "Flash Amber Warning Lamp AWL ist eingeschaltet oder berichtet Fehler",
  },
  14038: {
    category: "Fehler",
    text: "Flash Red Stop Lamp RSL ist eingeschaltet oder berichtet Fehler",
  },
  14039: {
    category: "Fehler",
    text: "Flash Malfunction Indicator Lamp MIL ist eingeschaltet oder berichtet Fehler",
  },
  14040: {
    category: "Fehler",
    text: "Betriebsmodus über CAN ist ungültig in clsDiesel",
  },
  14041: {
    category: "Fehler",
    text: "Interface Ueberwachung ist nicht initialisiert in clsDiesel",
  },
  14042: {
    category: "Fehler",
    text: "Interface Ueberwachung ist null in clsDiesel",
  },
  14043: {
    category: "Fehler",
    text: "Interface Fahrantrieb nicht initialisiert in Klasse clsDiesel",
  },
  14044: {
    category: "Fehler",
    text: "Interface Fahrantrieb ist null in clsDiesel",
  },
  14045: {
    category: "Fehler",
    text: "Diesel-Solldrehzahl ist außerhalb des zulässigen Bereiches",
  },
  14046: {
    category: "Fehler",
    text: "Diesel-Istdrehzahl ist zu hoch. Bitte unverzüglich bremsen!",
  },
  14047: {
    category: "Fehler",
    text: "Temperatur Kühlwasser außerhalb des zulässigen Bereiches",
  },
  14048: {
    category: "Fehler",
    text: "Der AdBlue-Stand des Diesel-Motors ist niedrig",
  },
  14049: {
    category: "Fehler",
    text: "Der SCR-Katalysator des Diesel-Motors hat einen Fehler ausgegeben",
  },
  14050: {
    category: "Fehler",
    text: "Der Diesel-Motor kann noch nicht gestartet werden. Bitte die Vorwärmung beachten",
  },
  14051: {
    category: "Fehler",
    text: "Regeneration aktiv. Die Abgastemperatur kann hoch sein.",
  },
  14052: {
    category: "Fehler",
    text: "Regeneration des Diesel-Motors notwendig",
  },
  14053: {
    category: "Fehler",
    text: "Bitte führen Sie unverzüglich eine Regeneration des Diesel-Motors durch",
  },
  14054: {
    category: "Fehler",
    text: "Ungültiger Zustand der DPF-Lampe gefunden",
  },
  14055: {
    category: "Fehler",
    text: "Die Regeneration des Diesel-Motors wurde abgebrochen",
  },
  14056: {
    category: "Fehler",
    text: "Regeneration des Diesel-Motors notwendig",
  },
  14057: {
    category: "Fehler",
    text: "Regeneration des Diesel-Motors dringend notwendig",
  },
  14058: {
    category: "Fehler",
    text: "Interface Primus Management ist nicht initialisiert in clsDiesel",
  },
  14059: {
    category: "Fehler",
    text: "Interface Primus Management ist null in clsDiesel",
  },
  14060: {
    category: "Fehler",
    text: "Reduzierung Motorleistung ist ungültig in clsDiesel",
  },
  14061: {
    category: "Fehler",
    text: "Diagnosemeldung Dieselmotor fehlerhaft: DM01 gibt SPN aus aber keinen FMI",
  },
  14062: {
    category: "Fehler",
    text: "Diagnosemeldung Dieselmotor fehlerhaft: DM01 gibt FMI aus aber keine SPN",
  },
  14063: { category: "Fehler", text: "Motorfehler gefunden" },
  14064: {
    category: "Fehler",
    text: "Fehler bei dem Lesen eines DTC-Codes in Klasse clsDiesel",
  },
  14065: {
    category: "Fehler",
    text: "Abgasnachbehandlung Warnung Stufe 1 erkannt. Fehler in 4 Stunden",
  },
  14066: {
    category: "Fehler",
    text: "Abgasnachbehandlung Warnung Stufe 2 erkannt. Fehler in 3,5 Stunden",
  },
  14067: {
    category: "Fehler",
    text: "Abgasnachbehandlung Warnung Stufe 3 erkannt. Fehler in 3 Stunden",
  },
  14068: {
    category: "Fehler",
    text: "Abgasnachbehandlung Warnung Stufe 4 erkannt. Fehler in 2,5 Stunden",
  },
  14069: {
    category: "Fehler",
    text: "Abgasnachbehandlung Warnung Stufe 5 erkannt. Fehler in 2 Stunden",
  },
  14071: { category: "Fehler", text: "Abgasfehler steht bevor" },
  14072: {
    category: "Fehler",
    text: "SCR-Fehler kann nicht eingelesen werden",
  },
  14073: { category: "Fehler", text: "SCR-Fehler kann nicht gelöscht werden" },
  14074: {
    category: "Fehler",
    text: "Schwerwiegender Fehler im Diesel erkannt. Bitte Maschine umgehend abstellen!",
  },
  14075: {
    category: "Fehler",
    text: "Diesel-Drückung ist außerhalb des zulässigen Bereiches",
  },
  14076: {
    category: "Fehler",
    text: "Interface Demo-Modus nicht initialisiert",
  },
  14077: { category: "Fehler", text: "Interface Demo-Modus ist null" },
  14078: {
    category: "Fehler",
    text: "Interface Parameter ist nicht initialisiert in Klasse clsDiesel",
  },
  14079: {
    category: "Fehler",
    text: "Interface Parameter ist null in Klasse csDiesel",
  },
  14080: {
    category: "Fehler",
    text: "Temperatur Kühlwasser außerhalb des zulässigen Bereiches. Motor umgehend abschalten!",
  },
  14081: {
    category: "Fehler",
    text: "Interface manuelle Regeneration auslösen ist null",
  },
  14082: {
    category: "Fehler",
    text: "Interface manuelle Regeneration kann nicht in digitalen Eingang konvertiert werden",
  },
  14083: {
    category: "Fehler",
    text: "Interface Regeneration abbrechen auslösen ist null",
  },
  14084: {
    category: "Fehler",
    text: "Interface Regeneration abbrechen kann nicht in digitalen Eingang konvertiert werden",
  },
  14085: {
    category: "Fehler",
    text: "Fehlerhafte CAN-Nachricht DPFC1 Regeneration aktiv",
  },
  14086: {
    category: "Fehler",
    text: "Fehlerhafte Daten DPFC1 autom. Regeneration angefragt aus CAN",
  },
  14087: {
    category: "Fehler",
    text: "Fehlerhafte Daten EBC2BF Öldruck aus CAN",
  },
  14088: {
    category: "Fehler",
    text: "Fehlerhafte Daten OI Wasser im Kraftstoff aus CAN",
  },
  14089: {
    category: "Fehler",
    text: "Fehlerhafte Daten ENG06 Luftfilter verschmutzt aus CAN",
  },
  14090: {
    category: "Fehler",
    text: "Fehlerhafte Daten ENG06 Dieselfilter verschmutzt aus CAN",
  },
  14091: {
    category: "Fehler",
    text: "Fehlerhafte Daten ENG06 DEF Level Warnung aus CAN",
  },
  14092: {
    category: "Fehler",
    text: "Fehlerhafte Datent ENG06 DEF Qualität aus CAN",
  },
  14093: {
    category: "Fehler",
    text: "Fehlerhafte Daten ENG06 technischer Fehler aus CAN",
  },
  14094: {
    category: "Fehler",
    text: "Fehlerhafte Daten ENG07 technischer Fehler aus CAN",
  },
  14095: {
    category: "Fehler",
    text: "Passive Regeneration aktiv. Sie müssen nichts weiter unternehmen.",
  },
  14096: { category: "Fehler", text: "Öldruck Diesel zu gering" },
  14097: {
    category: "Fehler",
    text: "Fehler bei der Detektion von Wasser im Kraftstoff",
  },
  14098: { category: "Fehler", text: "Wasser im Kraftstoff vorhanden" },
  14099: {
    category: "Fehler",
    text: "Luftfilter des Diesel-Motors ist verstopft",
  },
  14100: {
    category: "Fehler",
    text: "Kraftstofffilter des Diesel-Motors ist verstopft",
  },
  14101: { category: "Fehler", text: "AdBlue-Füllstand gering" },
  14102: {
    category: "Fehler",
    text: "AdBlue-Füllstand sehr gering. Bitte auffüllen",
  },
  14103: {
    category: "Fehler",
    text: "AdBlue-Füllstand sehr gering. Bitte umgehend auffüllen",
  },
  14104: { category: "Fehler", text: "AdBlue-Qualität prüfen" },
  14105: {
    category: "Fehler",
    text: "AdBlue-Qualität prüfen. Qualität ist schlecht. Bitte tauschen",
  },
  14106: {
    category: "Fehler",
    text: "AdBlue-Qualität prüfen. Qualität ist sehr schlecht. Bitte umgehend tauschen",
  },
  14107: { category: "Fehler", text: "AdBlue technischer Fehler erkannt" },
  14108: {
    category: "Fehler",
    text: "AdBlue technischer Fehler erkannt. Bitte Service kontaktieren",
  },
  14109: {
    category: "Fehler",
    text: "AdBlue technischer Fehler erkannt. Bitte umgehend Service kontaktieren",
  },
  14110: {
    category: "Fehler",
    text: "Geringe Anhebung der Leerlauf-Drehzahl notwendig",
  },
  14111: { category: "Fehler", text: "Temperatur Kühlmittel ist zu hoch" },
  14112: {
    category: "Fehler",
    text: "Temperatur Kühlmittel ist zu hoch. Bitte Maschine umgehend abstellen",
  },
  14113: {
    category: "Fehler",
    text: "Fehlerhafte Daten EBC2BF Temperatur Kühlmittel aus CAN",
  },
  14114: {
    category: "Fehler",
    text: "Regeneration aktiv. Arbeitsfunktionen sind nur eingeschränkt nutzbar",
  },
  14115: {
    category: "Fehler",
    text: "Diesel-Drehzahl durch zu kaltes Kühlmittel limitiert",
  },
  14116: {
    category: "Fehler",
    text: "Diesel-Drehzahl durch Temperatur Hydrauliköl limitiert",
  },
  14117: {
    category: "Fehler",
    text: "Interface itfDrehzahlManagement ist ungültig",
  },
  14118: { category: "Fehler", text: "Fehlerhafter Signalwert Fahrpedal" },
  14119: {
    category: "Fehler",
    text: "AdBlue Level zu gering. Bitte jetzt auffüllen!",
  },
  14120: { category: "Fehler", text: "AdBlue Level gering. Bitte auffüllen!" },
  14121: {
    category: "Fehler",
    text: "Bitte Parkbremse für Regeneration einlegen und erneut starten.",
  },
  14901: { category: "Fehler", text: "PWM-Ausgang zur Zeit in Benutzung" },
  14902: { category: "Fehler", text: "PWM-Ausgang Drahtbruch erkannt" },
  14903: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Masse erkannt",
  },
  14904: {
    category: "Fehler",
    text: "PWM-Ausgang Kurzschluss zu Batterie erkannt",
  },
  14905: {
    category: "Fehler",
    text: "PWM-Ausgang ist derzeit im sicheren Zustand",
  },
  14906: { category: "Fehler", text: "PWM-Ausgang unbekannter Fehler" },
  14907: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  14908: { category: "Fehler", text: "PWM-Ausgang im Zustand warten" },
  14909: { category: "Fehler", text: "PWM-Ausgang im Zustand Reset" },
  14910: { category: "Fehler", text: "PWM-Ausgang Überstrom" },
  14911: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  14912: {
    category: "Fehler",
    text: "PWM-Ausgang Drahtbruch oder Kurzschluss",
  },
  14913: { category: "Fehler", text: "PWM-Ausgang Überspannung" },
  14914: { category: "Fehler", text: "PWM-Ausgang hängt auf high" },
  14915: { category: "Fehler", text: "PWM-Ausgang hängt aus low" },
  14916: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu hohe Temperatur",
  },
  14917: {
    category: "Fehler",
    text: "PWM-Ausgang hat eine zu geringe Temperatur",
  },
  14918: { category: "Fehler", text: "PWM-Ausgang Fehler Gruppenausgang" },
  14919: { category: "Fehler", text: "Bereichsfehler PWM" },
  14920: { category: "Fehler", text: "Safety Fehler PWM" },
  14921: { category: "Fehler", text: "Analoger Eingang zur Zeit in Benutzung" },
  14922: { category: "Fehler", text: "Analoger Eingang Drahtbruch erkannt" },
  14923: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Masse erkannt",
  },
  14924: {
    category: "Fehler",
    text: "Analoger Eingang Kurzschluss zu Batterie erkannt",
  },
  14925: {
    category: "Fehler",
    text: "Analoger Eingang ist derzeit im sicheren Zustand",
  },
  14926: { category: "Fehler", text: "Analoger Eingang unbekannter Fehler" },
  14927: { category: "Fehler", text: "Analoger Eingang im Zustand warten" },
  14928: { category: "Fehler", text: "Analoger Eingang im Zustand Reset" },
  14929: { category: "Fehler", text: "Analoger Eingang Überstrom" },
  14930: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  14931: {
    category: "Fehler",
    text: "Analoger Eingang Drahtbruch oder Kurzschluss",
  },
  14932: { category: "Fehler", text: "Analoger Eingang Überspannung" },
  14933: { category: "Fehler", text: "Analoger Eingang hängt auf high" },
  14934: { category: "Fehler", text: "Analoger Eingang hängt aus low" },
  14935: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu hohe Temperatur",
  },
  14936: {
    category: "Fehler",
    text: "Analoger Eingang hat eine zu geringe Temperatur",
  },
  14937: { category: "Fehler", text: "Analoger Eingang Fehler Gruppenausgang" },
  14938: { category: "Fehler", text: "Bereichsfehler analoger Eingang" },
  14939: { category: "Fehler", text: "Safety Fehler analoger Eingang" },
  14941: {
    category: "Fehler",
    text: "Digitaler Eingang zur Zeit in Benutzung",
  },
  14942: { category: "Fehler", text: "Digitaler Eingang Drahtbruch erkannt" },
  14943: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Masse erkannt",
  },
  14944: {
    category: "Fehler",
    text: "Digitaler Eingang Kurzschluss zu Batterie erkannt",
  },
  14945: {
    category: "Fehler",
    text: "Digitaler Eingang ist derzeit im sicheren Zustand",
  },
  14946: { category: "Fehler", text: "Digitaler Eingang unbekannter Fehler" },
  14947: { category: "Fehler", text: "Digitaler Eingang im Zustand warten" },
  14948: { category: "Fehler", text: "Digitaler Eingang im Zustand Reset" },
  14949: { category: "Fehler", text: "Digitaler Eingang Überstrom" },
  14950: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  14951: {
    category: "Fehler",
    text: "Digitaler Eingang Drahtbruch oder Kurzschluss",
  },
  14952: { category: "Fehler", text: "Digitaler Eingang Überspannung" },
  14953: { category: "Fehler", text: "Digitaler Eingang hängt auf high" },
  14954: { category: "Fehler", text: "Digitaler Eingang hängt aus low" },
  14955: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu hohe Temperatur",
  },
  14956: {
    category: "Fehler",
    text: "Digitaler Eingang hat eine zu geringe Temperatur",
  },
  14957: {
    category: "Fehler",
    text: "Digitaler Eingang Fehler Gruppenausgang",
  },
  14958: { category: "Fehler", text: "Bereichsfehler digitaler Eingang" },
  14959: { category: "Fehler", text: "Safety Fehler digitaler Eingang" },
  14961: {
    category: "Fehler",
    text: "Digitaler Ausgang zur Zeit in Benutzung",
  },
  14962: { category: "Fehler", text: "Digitaler Ausgang Drahtbruch erkannt" },
  14963: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Masse erkannt",
  },
  14964: {
    category: "Fehler",
    text: "Digitaler Ausgang Kurzschluss zu Batterie erkannt",
  },
  14965: {
    category: "Fehler",
    text: "Digitaler Ausgang ist derzeit im sicheren Zustand",
  },
  14966: { category: "Fehler", text: "Digitaler Ausgang unbekannter Fehler" },
  14967: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss Batterie",
  },
  14968: { category: "Fehler", text: "Digitaler Ausgang im Zustand warten" },
  14969: { category: "Fehler", text: "Digitaler Ausgang im Zustand Reset" },
  14970: { category: "Fehler", text: "Digitaler Ausgang Überstrom" },
  14971: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  14972: {
    category: "Fehler",
    text: "Digitaler Ausgang Drahtbruch oder Kurzschluss",
  },
  14973: { category: "Fehler", text: "Digitaler Ausgang Überspannung" },
  14974: { category: "Fehler", text: "Digitaler Ausgang hängt auf high" },
  14975: { category: "Fehler", text: "Digitaler Ausgang hängt aus low" },
  14976: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu hohe Temperatur",
  },
  14977: {
    category: "Fehler",
    text: "Digitaler Ausgang hat eine zu geringe Temperatur",
  },
  14978: {
    category: "Fehler",
    text: "Digitaler Ausgang Fehler Gruppenausgang",
  },
  14979: { category: "Fehler", text: "Bereichsfehler digitaler Ausgang" },
  14980: { category: "Fehler", text: "Safety Fehler digitaler Ausgang" },
  14981: { category: "Fehler", text: "Frequenz-Eingang zur Zeit in Benutzung" },
  14982: { category: "Fehler", text: "Frequenz-Eingang Drahtbruch erkannt" },
  14983: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Masse erkannt",
  },
  14984: {
    category: "Fehler",
    text: "Frequenz-Eingang Kurzschluss zu Batterie erkannt",
  },
  14985: {
    category: "Fehler",
    text: "Frequenz-Eingang ist derzeit im sicheren Zustand",
  },
  14986: { category: "Fehler", text: "Frequenz-Eingang unbekannter Fehler" },
  14987: { category: "Fehler", text: "Frequenz-Eingang im Zustand warten" },
  14988: { category: "Fehler", text: "Frequenz-Eingang im Zustand Reset" },
  14989: { category: "Fehler", text: "Frequenz-Eingang Überstrom" },
  14990: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  14991: {
    category: "Fehler",
    text: "Frequenz-Eingang Drahtbruch oder Kurzschluss",
  },
  14992: { category: "Fehler", text: "Frequenz-Eingang Überspannung" },
  14993: { category: "Fehler", text: "Frequenz-Eingang hängt auf high" },
  14994: { category: "Fehler", text: "Frequenz-Eingang hängt aus low" },
  14995: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu hohe Temperatur",
  },
  14996: {
    category: "Fehler",
    text: "Frequenz-Eingang hat eine zu geringe Temperatur",
  },
  14997: { category: "Fehler", text: "Frequenz-Eingang Fehler Gruppenausgang" },
  14998: { category: "Fehler", text: "Bereichsfehler Frequenzeingang" },
  14999: { category: "Fehler", text: "Safety Fehler Frequenzeingang" },
  17000: { category: "Fehler", text: "Interface itfInFraesarm ist ungültig" },
  17001: {
    category: "Fehler",
    text: "Interface itfInArbeitsfunktionen ist ungültig",
  },
  17002: {
    category: "Fehler",
    text: "Interface itfInSchraegfoerderer ist ungültig",
  },
  17003: { category: "Fehler", text: "Interface itfInQuerband ist ungültig" },
  18101: {
    category: "Fehler",
    text: "Ein Neustart direkt nach Maschinenstart erkannt",
  },
  18102: {
    category: "Fehler",
    text: "Zwei Neustarts direkt nach Maschinenstart erkannt",
  },
  18103: {
    category: "Fehler",
    text: "Drei Neustarts direkt nach Maschinenstart erkannt",
  },
  18104: {
    category: "Fehler",
    text: "Vier Neustarts direkt nach Maschinenstart erkannt",
  },
  18105: {
    category: "Fehler",
    text: "Fünf Neustarts direkt nach Maschinenstart erkannt",
  },
  18106: {
    category: "Fehler",
    text: "Sechs Neustarts direkt nach Maschinenstart erkannt",
  },
  18107: {
    category: "Fehler",
    text: "Sieben Neustarts direkt nach Maschinenstart erkannt",
  },
  18108: {
    category: "Fehler",
    text: "Acht Neustarts direkt nach Maschinenstart erkannt",
  },
  18109: {
    category: "Fehler",
    text: "Neun Neustarts direkt nach Maschinenstart erkannt",
  },
  18110: {
    category: "Fehler",
    text: "Keine Verbindung zur Steuerung bei vorherigem Start erkannt",
  },
  18111: {
    category: "Fehler",
    text: "Fehler Ausgangsgruppe 0 nach Systemstart erkannt",
  },
  18112: {
    category: "Fehler",
    text: "Fehler Ausgangsgruppe 1 nach Systemstart erkannt",
  },
  18113: {
    category: "Fehler",
    text: "Fehler Ausgangsgruppe 2 nach Systemstart erkannt",
  },
  18114: {
    category: "Fehler",
    text: "Mehr als neun Neustarts direkt nach Maschinenstart erkannt",
  },
  18200: { category: "Fehler", text: "Update Fehlerhafte Dateien" },
  18201: { category: "Fehler", text: "Update Fehler bei Verbindungsaufbau" },
  18202: { category: "Fehler", text: "Update keine Firmware Backup-Datei" },
  18203: {
    category: "Fehler",
    text: "Update Fehler beim Auslesen der Software",
  },
  18204: {
    category: "Fehler",
    text: "Update Fehler beim Speichern der Software",
  },
  18205: { category: "Fehler", text: "Update Fehler beim Laden der Firmware" },
  18206: { category: "Fehler", text: "Update Fehler beim Laden der Software" },
  18207: {
    category: "Fehler",
    text: "Update Fehler beim Beenden der Verbindung",
  },
  18208: {
    category: "Fehler",
    text: "Update Fehler beim Laden der Backup-Software",
  },
  18209: {
    category: "Fehler",
    text: "Update Fehler beim Laden der Backup-Firmware",
  },
  18210: {
    category: "Fehler",
    text: "Update Fehler beim Speichern der Perisistenten Daten",
  },
  18211: {
    category: "Fehler",
    text: "Update Fehler beim Kopieren des Display-Updates",
  },
  18212: {
    category: "Fehler",
    text: "Update Fehler beim Speichern der Update-Dateien",
  },
  18213: {
    category: "Fehler",
    text: "Update Fehler beim Löschen der Update-Dateien",
  },
  20000: {
    category: "Fehler",
    text: "Can Keypad Timeout. Bitte Maschine neu starten",
  },
  20001: { category: "Fehler", text: "Ungültiger Betriebsmodus" },
  20002: {
    category: "Fehler",
    text: "Betriebsmodus ist Straßenfahrt, Anforderung Sonderlenkprogramm festgestellt",
  },
  20003: {
    category: "Fehler",
    text: "Sonderlenkmodus in Straßenfahrt festgestellt",
  },
  20050: {
    category: "Fehler",
    text: "Nachrichtenzähler CAN für Achse Fräsarm senken fehlerhaft",
  },
  20051: {
    category: "Fehler",
    text: "Checksumme CAN für Achse Fräsarm senken fehlerhaft",
  },
  20052: { category: "Fehler", text: "CAN Joystick Timeout Fräsarm" },
  20053: {
    category: "Fehler",
    text: "Signal CAN für Achse Fräsarm fehlerhaft",
  },
  20054: {
    category: "Fehler",
    text: "Vorgabewert Fräsarm senken Signal Ausgang fehlerhaft",
  },
  20055: {
    category: "Fehler",
    text: "Nachricht Joystick Fräsarm senken fehlerhaft",
  },
  20100: {
    category: "Fehler",
    text: "Checksumme CAN für Bandverschiebung fehlerhaft",
  },
  20101: { category: "Fehler", text: "CAN Joystick Timeout Bandverschiebung" },
  20102: {
    category: "Fehler",
    text: "Signal CAN für Bandverschiebung fehlerhaft",
  },
  20103: {
    category: "Fehler",
    text: "Vorgabewert Bandverschiebung Signal Ausgang fehlerhaft",
  },
  20104: {
    category: "Fehler",
    text: "Maschine nicht im Betriebsmodus Austrag, Band soll ausgefahren werden",
  },
  20105: {
    category: "Fehler",
    text: "Nachrichtenzähler CAN für Bandverschiebung fehlerhaft",
  },
  20106: {
    category: "Fehler",
    text: "Nachricht Joystick Bandverschiebung fehlerhaft",
  },
  20107: {
    category: "Fehler",
    text: "Sicherheitsfunktion der Fräse blockiert die Ausführung",
  },
  20108: {
    category: "Fehler",
    text: "Sicherheitsfunktion der Bandverschiebung 1 blockiert die Ausführung",
  },
  20109: {
    category: "Fehler",
    text: "Sicherheitsfunktion der Bandverschiebung 2 blockiert die Ausführung",
  },
  20150: { category: "Fehler", text: "Redundantes Signal Nothalt unplausibel" },
  20200: {
    category: "Fehler",
    text: "Redundantes Signal Sitzkontakt unplausibel",
  },
  20250: {
    category: "Fehler",
    text: "Redundantes Signal Sicherheitstaster unplausibel",
  },
  20251: {
    category: "Fehler",
    text: "Nachrichtenzähler CAN für Achse fräsen fehlerhaft",
  },
  20252: {
    category: "Fehler",
    text: "Checksumme CAN für Achse fräsen fehlerhaft",
  },
  20253: { category: "Fehler", text: "Signal CAN fräsen fehlerhaft" },
  20254: {
    category: "Fehler",
    text: "Vorgabewert fräsen Signal Ausgang fehlerhaft",
  },
  20255: {
    category: "Fehler",
    text: "Can Signal fräsen, zuvor kein Sicherheitstaster betätigt",
  },
  20256: {
    category: "Fehler",
    text: "Ungültiger Betriebsmodus für Fräsen festgestellt",
  },
  20300: { category: "Fehler", text: "CAN Diesel Timeout" },
  20500: {
    category: "Fehler",
    text: "Nachrichtenzähler CAN für Fahrantrieb Sitzkontakt und Parkbremse fehlerhaft",
  },
  20501: {
    category: "Fehler",
    text: "Checksumme CAN für Fahrantrieb Sitzkontakt und Parkbremse fehlerhaft",
  },
  20502: { category: "Fehler", text: "CAN Fahrantrieb Timeout" },
  20504: {
    category: "Fehler",
    text: "Fehler Fahrantrieb CAN PGN 0xFF49. Bitte Maschine neu starten",
  },
  20900: {
    category: "Fehler",
    text: "Kurzschluss Nothalt Öffner festgestellt. Bitte Maschine neu starten",
  },
  20901: {
    category: "Fehler",
    text: "Kurzschluss Nothalt Schließer festgestellt. Bitte Maschine neu starten",
  },
  20902: {
    category: "Fehler",
    text: "Sonstiger IO Fehler Nothalt Öffner. Bitte Maschine neu starten",
  },
  20903: {
    category: "Fehler",
    text: "Sonstiger IO Fehler Nothalt Schließer. Bitte Maschine neu starten",
  },
  20904: {
    category: "Fehler",
    text: "Kabelbruch Nothalt Öffner festgestellt. Bitte Maschine neu starten",
  },
  20905: {
    category: "Fehler",
    text: "Kabelbruch Nothalt Schließer festgestellt. Bitte Maschine neu starten",
  },
  20906: {
    category: "Fehler",
    text: "Freigabeventil kann nicht geschaltet werden",
  },
  20907: {
    category: "Fehler",
    text: "Kurzschluss Sitzkontakt Öffner festgestellt. Bitte Maschine neu starten",
  },
  20908: {
    category: "Fehler",
    text: "Kurzschluss Sitzkontakt Schließer festgestellt. Bitte Maschine neu starten",
  },
  20909: {
    category: "Fehler",
    text: "Sonstiger IO Fehler Sitzkontakt Öffner. Bitte Maschine neu starten",
  },
  20910: {
    category: "Fehler",
    text: "Sonstiger IO Fehler Sitzkontakt Schließer. Bitte Maschine neu starten",
  },
  20911: {
    category: "Fehler",
    text: "Kabelbruch Nothalt Sitzkontakt festgestellt. Bitte Maschine neu starten",
  },
  20912: {
    category: "Fehler",
    text: "Kabelbruch Nothalt Sitzkontakt festgestellt. Bitte Maschine neu starten",
  },
  20913: { category: "Fehler", text: "Kurzschluss Druckschalter festgestellt" },
  20914: {
    category: "Fehler",
    text: "Sonstiger IO Fehler Druckschalter Parkbremse festgestellt",
  },
  20915: {
    category: "Fehler",
    text: "Kabelbruch Druckschalter Parkbremse festgestellt",
  },
  20916: {
    category: "Fehler",
    text: "Sonstiger IO Fehler Sicherheitstaster Fräse Öffner",
  },
  20917: {
    category: "Fehler",
    text: "Sonstiger IO Fehler Sicherheitstaster Fräse Schließer",
  },
  20918: {
    category: "Fehler",
    text: "Kabelbruch Nothalt Sicherheitstaster Fräse Öffner festgestellt",
  },
  20919: {
    category: "Fehler",
    text: "Kabelbruch Nothalt Sicherheitstaster Fräse Schließer festgestellt",
  },
  20920: {
    category: "Fehler",
    text: "Fehler IO Fräspumpe reversieren Ausgangssteuerung",
  },
  20921: { category: "Fehler", text: "Fehler IO Fräspumpe reversieren" },
  20922: {
    category: "Fehler",
    text: "Fehler IO Mischerpumpe Ausgangssteuerung",
  },
  20923: { category: "Fehler", text: "Fehler IO Mischerpumpe" },
  20924: {
    category: "Fehler",
    text: "Fehler IO Austragsband 1 verschieben Ausgangssteuerung",
  },
  20925: { category: "Fehler", text: "Fehler IO Austragsband 1 verschieben" },
  20926: {
    category: "Fehler",
    text: "Fehler IO Austragsband 2 verschieben Ausgangssteuerung",
  },
  20927: { category: "Fehler", text: "Fehler IO Austragsband 2 verschieben" },
  20928: {
    category: "Fehler",
    text: "Fehler IO Fräsarm senken Ausgangssteuerung",
  },
  20929: { category: "Fehler", text: "Fehler IO Fräsarm senken" },
  20930: {
    category: "Fehler",
    text: "Fehler IO Fräspumpe vorwärts Ausgangssteuerung",
  },
  20931: { category: "Fehler", text: "Fehler IO Fräspumpe vorwärts" },
  20932: {
    category: "Fehler",
    text: "Fehler IO Mischermotor Ausgangssteuerung",
  },
  20933: { category: "Fehler", text: "Fehler IO Mischermotor" },
  20934: {
    category: "Fehler",
    text: "Fehler Ausgangsgruppe VBB1. Bitte Maschine neu starten",
  },
  20935: {
    category: "Fehler",
    text: "Fehler Ausgangsgruppe VBB2. Bitte Maschine neu starten",
  },
  21000: {
    category: "Fehler",
    text: "Eingehender CAN-Bus ist nicht initialisiert in Klasse clsBMS",
  },
  21001: { category: "Fehler", text: "Klasse BMS nicht initialisiert" },
  21002: {
    category: "Fehler",
    text: "Fehlerhafte AC-Spannung in Klasse clsBMS",
  },
  21003: { category: "Fehler", text: "Fehlerhafter AC-Strom in Klasse clsBMS" },
  21004: {
    category: "Fehler",
    text: "Fehlerhafter Charger-Status in Klasse clsBMS",
  },
  21005: {
    category: "Fehler",
    text: "Diagnoseinterface nicht initialisiert in Klasse clsBMS",
  },
  21006: {
    category: "Fehler",
    text: "Diagnoseinterface ist null in Klasse clsBMS",
  },
  21007: {
    category: "Fehler",
    text: "CAN-Interface nicht initialisiert in Klasse clsBMS",
  },
  21008: {
    category: "Fehler",
    text: "CAN-Interface ist null in Klasse clsBMS",
  },
  21009: {
    category: "Fehler",
    text: "Interface Überwachung ist nicht initialisiert in Klasse clsBMS",
  },
  21010: {
    category: "Fehler",
    text: "Interface Überwachung ist null in Klasse clsBMS",
  },
  21011: { category: "Fehler", text: "Interface BMS CAN ist null" },
  21012: { category: "Fehler", text: "Ungültige Angabe aktueller Strom BMS" },
  21013: { category: "Fehler", text: "Ungültige Angabe aktuelle Spannung BMS" },
  21014: {
    category: "Fehler",
    text: "Ungültige Angabe aktueller State of Charge BMS",
  },
  21015: {
    category: "Fehler",
    text: "Niedrigen Ladezustand der HV-Batterie festgestellt. Bitte Maschine laden",
  },
  21016: {
    category: "Fehler",
    text: "Sehr niedrigen Ladezustand der Batterie festgestellt. Bitte Maschine umgehend laden",
  },
  21017: { category: "Fehler", text: "Ungültiger Ladestrom BMS gefunden" },
  21018: {
    category: "Fehler",
    text: "Fehlerhafte höchste Zelltemperatur festgestellt",
  },
  21019: {
    category: "Fehler",
    text: "Fehlerhafte niedrigste Zelltemperatur festgestellt",
  },
  21020: {
    category: "Fehler",
    text: "Interface Parameter ist nicht initialisiert in clsBMS",
  },
  21021: {
    category: "Fehler",
    text: "Interface Parameter ist null in Klasse clsBMS",
  },
  21022: {
    category: "Fehler",
    text: "Fehlerhafter Ladestrom der Ladestation festgestellt",
  },
  21023: {
    category: "Fehler",
    text: "Fehlerhafte höchste Zellspannung festgestellt",
  },
  21024: {
    category: "Fehler",
    text: "Fehlerhafte niedrigste Zellspannung festgestellt",
  },
  21025: { category: "Fehler", text: "Interface IMD CAN ist null" },
  21026: {
    category: "Fehler",
    text: "Eingehender CAN-Bus ist nicht initialisiert in Klasse clsIMD",
  },
  21027: {
    category: "Fehler",
    text: "Fehlerhafter Isolationsstatus in Klasse IMD",
  },
  21028: {
    category: "Fehler",
    text: "Fehlerhafte Ungenauigkeit des Isolationswiderstandes in der Klasse IMD",
  },
  21029: {
    category: "Fehler",
    text: "Fehlerhafte Ungenauigkeit der Isolationskapazitaet in der Klasse IMD",
  },
  21030: {
    category: "Fehler",
    text: "IMD Isolationswiderstand unter 500 Ohm/V",
  },
  21031: {
    category: "Fehler",
    text: "IMD Isolationswiderstand unter 100 Ohm/V",
  },
  21032: { category: "Fehler", text: "IMD Hardware fehlerhaft" },
  21033: {
    category: "Fehler",
    text: "CAN-Interface ist null in Klasse clsIMD",
  },
  21034: {
    category: "Fehler",
    text: "CAN-Interface nicht initialisiert in Klasse clsIMD",
  },
  21035: {
    category: "Fehler",
    text: "Fehlerhafter BMS Zustand in der Klasse BMS",
  },
  21036: {
    category: "Fehler",
    text: "Ueberwachung-Interface ist nicht initialisiert in clsOBC",
  },
  21037: {
    category: "Fehler",
    text: "Ueberwachung-Interface ist null in Klasse clsOBC",
  },
  21038: {
    category: "Fehler",
    text: "Ein Sensor für Zelltemperatur ist nicht angeschlossen",
  },
  21039: {
    category: "Fehler",
    text: "Ein Sensor für Zelltemperatur hat einen Kurzschluss",
  },
  21040: {
    category: "Fehler",
    text: "Temperatur einer Batteriezelle ist zu hoch",
  },
  21041: {
    category: "Fehler",
    text: "Temperatur einer Batteriezelle ist zu niedrig",
  },
  21042: {
    category: "Fehler",
    text: "Spannung einer Batteriezelle ist zu hoch",
  },
  21043: {
    category: "Fehler",
    text: "Spannung einer Batteriezelle ist zu niedrig",
  },
  21044: { category: "Fehler", text: "Ladestrom ist über Maximalwert" },
  21045: {
    category: "Fehler",
    text: "Kommunikationsfehler zwischen MCU und CMU des BMS",
  },
  21046: {
    category: "Fehler",
    text: "Ein Sensor für CMU-Temperatur ist nicht angeschlossen",
  },
  21047: {
    category: "Fehler",
    text: "Ein Sensor für CMU-Temperatur hat einen Kurzschluss",
  },
  21048: {
    category: "Fehler",
    text: "Der Precharge-Vorgang wurde abgebrochen",
  },
  21049: {
    category: "Fehler",
    text: "Kein Feedback-Signal von dem HV-Negativ Relais erhalten",
  },
  21050: {
    category: "Fehler",
    text: "Feedback-Schalter des HV-Negativ Relais ist verschweißt",
  },
  21051: {
    category: "Fehler",
    text: "Kein Feedback-Signal von dem HV-Positiv Relais erhalten",
  },
  21052: {
    category: "Fehler",
    text: "Feedback-Schalter des HV-Positiv Relais ist verschweißt",
  },
  21053: {
    category: "Fehler",
    text: "Zelltemperatur liegt außerhalb des gültigen Wertebereichs",
  },
  21054: {
    category: "Fehler",
    text: "Zellspannung liegt außerhalb des gültigen Wertebereichs",
  },
  21055: {
    category: "Fehler",
    text: "Temperatur einer CMU liegt außerhalb des gültigen Wertebereichs",
  },
  21056: { category: "Fehler", text: "BMS Resource Access Failure" },
  21057: { category: "Fehler", text: "DCDC-Wandler Kommunikations-Fehler" },
  21058: {
    category: "Fehler",
    text: "DCDC-Wandler Eingangsspannung ist zu hoch",
  },
  21059: {
    category: "Fehler",
    text: "DCDC-Wandler Eingangsspannung ist zu niedrig",
  },
  21060: { category: "Fehler", text: "DCDC-Wandler Internal Protection Alarm" },
  21061: { category: "Fehler", text: "DCDC-Wandler Ausgangsstrom ist zu hoch" },
  21062: {
    category: "Fehler",
    text: "DCDC-Wandler Ausgangsspannung ist zu hoch",
  },
  21063: { category: "Fehler", text: "DCDC-Wandler Kurzschluss am Ausgang" },
  21064: {
    category: "Fehler",
    text: "DCDC-Wandler Ausgangsspannung ist zu niedrig",
  },
  21065: { category: "Fehler", text: "DCDC-Wandler Temperatur ist zu hoch" },
  21066: {
    category: "Fehler",
    text: "Ladesteckerverriegelung-Interface ist null in clsBMS",
  },
  21067: { category: "Fehler", text: "OBC Hardware Fehler" },
  21068: { category: "Fehler", text: "OBC Temperatur zu hoch" },
  21069: { category: "Fehler", text: "OBC Eingangsspannung Fehler" },
  21070: { category: "Fehler", text: "OBC Anschluss der Batterie vertauscht" },
  21071: { category: "Fehler", text: "OBC Kommunikation Time-Out" },
  21072: {
    category: "Fehler",
    text: "OBC Temperatur am Ladeanschluss zu hoch",
  },
  21073: { category: "Fehler", text: "OBC Fehler an CC-Anschluss" },
  21074: { category: "Fehler", text: "OBC Fehler an CP-Anschluss" },
  21075: {
    category: "Fehler",
    text: "Orion BMS Discharge Limit Enforcement Fault",
  },
  21076: { category: "Fehler", text: "Orion BMS Charger Safety Relay Fault" },
  21077: { category: "Fehler", text: "Orion BMS Internal Hardware Fault" },
  21078: {
    category: "Fehler",
    text: "Orion BMS Internal Heatsink Thermistor Fault",
  },
  21079: { category: "Fehler", text: "Orion BMS Internal Software Fault" },
  21080: {
    category: "Fehler",
    text: "Orion BMS Highest Cell Voltage Too High Fault",
  },
  21081: {
    category: "Fehler",
    text: "Orion BMS Lowest Cell Voltage Too Low Fault",
  },
  21082: { category: "Fehler", text: "Orion BMS Pack Too Hot Fault" },
  21083: { category: "Fehler", text: "Orion BMS Internal Communication Fault" },
  21084: {
    category: "Fehler",
    text: "Orion BMS Cell Balancing Stuck Off Fault",
  },
  21085: { category: "Fehler", text: "Orion BMS Weak Cell Fault" },
  21086: { category: "Fehler", text: "Orion BMS Low Cell Voltage Fault" },
  21087: { category: "Fehler", text: "Orion BMS Open Wiring Fault" },
  21088: { category: "Fehler", text: "Orion BMS Current Sensor Fault" },
  21089: {
    category: "Fehler",
    text: "Orion BMS Highest Cell Voltage Over 5V Fault",
  },
  21090: { category: "Fehler", text: "Orion BMS Cell ASIC Fault" },
  21091: { category: "Fehler", text: "Orion BMS Weak Pack Fault" },
  21092: { category: "Fehler", text: "Orion BMS Fan Monitor Fault" },
  21093: { category: "Fehler", text: "Orion BMS Thermistor Fault" },
  21094: { category: "Fehler", text: "Orion BMS External Communication Fault" },
  21095: { category: "Fehler", text: "Orion BMS Redundant Power Supply Fault" },
  21096: { category: "Fehler", text: "Orion BMS High Voltage Isolation Fault" },
  21097: { category: "Fehler", text: "Orion BMS Input Power Supply Fault" },
  21098: {
    category: "Fehler",
    text: "Orion BMS Charge Limit Enforcement Fault",
  },
  21099: { category: "Fehler", text: "DCDC-Wandler ist deaktiviert" },
  21100: {
    category: "Fehler",
    text: "Interface Ueberwachung ist nicht initialisiert in clsZaehlerBetrStunden",
  },
  21101: {
    category: "Fehler",
    text: "Interface Ueberwachung ist gleich Null in clsZaehlerBetrStunden",
  },
  21102: {
    category: "Fehler",
    text: "Interface BMS ist nicht initialisiert in clsZaehlerLadeZyklus",
  },
  21103: {
    category: "Fehler",
    text: "Interface BMS ist gleich Null in clsZaehlerLadeZyklus",
  },
  21104: { category: "Fehler", text: "Entladestrom ist über Maximalwert" },
  21105: {
    category: "Fehler",
    text: "Strombegrenzung aktiv. Mischer wird mit reduzierter Drehzahl betrieben.",
  },
  21106: {
    category: "Fehler",
    text: "Motor steht. Mit aktuell zur Verfügung stehender Leistung kann nicht weiter gederht werden.",
  },
  21107: {
    category: "Fehler",
    text: "Orion BMS Precharge Circuit Malfunction",
  },
  21200: {
    category: "Fehler",
    text: "Eingehender CAN-Bus ist nicht initialisiert in Klasse clsOBC",
  },
  21201: { category: "Fehler", text: "Klasse OBC nicht initialisiert" },
  21202: {
    category: "Fehler",
    text: "Diagnoseinterface nicht initialisiert in Klasse clsOBC",
  },
  21203: {
    category: "Fehler",
    text: "Diagnoseinterface ist null in Klasse clsOBC",
  },
  21204: {
    category: "Fehler",
    text: "CAN-Interface nicht initialisiert in Klasse clsOBC",
  },
  21205: {
    category: "Fehler",
    text: "CAN-Interface ist null in Klasse clsOBC",
  },
  21206: { category: "Fehler", text: "Ungültige interne Temperatur OBC" },
  21207: { category: "Fehler", text: "Interface OBC CAN ist null" },
  21208: {
    category: "Fehler",
    text: "Klasse OBC aus E-Feeding Library kann nicht initialisiert werden",
  },
  21300: {
    category: "Fehler",
    text: "Diagnose-Interface ist nicht initialisiert in der Klasse Wartungsplan",
  },
  21301: {
    category: "Fehler",
    text: "Diagnose-Interface ist Null in der Klasse Wartungsplan",
  },
  21302: { category: "Fehler", text: "Wartung ist fällig" },
  21303: {
    category: "Fehler",
    text: "Wartungsplan wurde erfolgreich aktualisiert.",
  },
  21400: { category: "Fehler", text: "Baterriesystem interner Fehler" },
  21401: { category: "Fehler", text: "Batteriesystem IO Fehler" },
  21402: { category: "Fehler", text: "Batteriesystem allgemeiner CAN Fehler" },
  21403: { category: "Fehler", text: "Batteriesystem HVIL unterbrochen" },
  21404: { category: "Fehler", text: "Batteriesystem Notfallabschaltung" },
  21405: { category: "Fehler", text: "Batteriesystem Schütze fehlerhaft" },
  21406: {
    category: "Fehler",
    text: "Batteriesystem BMS konnte nicht gestartet werden",
  },
  21407: {
    category: "Fehler",
    text: "Batteriesystem Schütze nicht geschlossen",
  },
  21408: {
    category: "Fehler",
    text: "Batteriesystem Precharge fehlgeschlagen",
  },
  21409: { category: "Fehler", text: "Batteriesystem Active Discharge Fehler" },
  21410: {
    category: "Fehler",
    text: "Batteriesystem Ein- oder Ausschalten fehlgeschlagen",
  },
  21411: { category: "Fehler", text: "Batteriesystem Zellspannung zu hoch" },
  21412: { category: "Fehler", text: "Batteriesystem Zelltemperatur zu hoch" },
  21413: { category: "Fehler", text: "Batteriesystem Temperatur zu hoch" },
  21414: { category: "Fehler", text: "Batteriesystem Zellspannung zu niedrig" },
  21415: {
    category: "Fehler",
    text: "Batteriesystem Zelltemperatur zu niedrig",
  },
  21416: { category: "Fehler", text: "Batteriesystem Ladestrom zu hoch" },
  21417: {
    category: "Fehler",
    text: "Batteriesystem Leistungsentnahme zu hoch",
  },
  21418: {
    category: "Fehler",
    text: "Batteriesystem Kommunikation Fehler OBC",
  },
  21419: {
    category: "Fehler",
    text: "Batteriesystem Eingangsspannung Fehler OBC",
  },
  21420: {
    category: "Fehler",
    text: "Batteriesystem Ausgangsspannung Fehler OBC",
  },
  21421: { category: "Fehler", text: "Batteriesystem OBC Temperatur erhöht" },
  21422: { category: "Fehler", text: "Batteriesystem OBC Temperatur zu hoch" },
  21423: { category: "Fehler", text: "Batteriesystem Notfallabschaltung OBC" },
  21424: { category: "Fehler", text: "Batteriesystem interner Fehler OBC" },
  21425: { category: "Fehler", text: "Batteriesystem Gesamtspannung zu hoch" },
  21426: {
    category: "Fehler",
    text: "Batteriesystem Gesamtspannung zu niedrig",
  },
  21427: { category: "Fehler", text: "Batteriesystem allgemeiner Fehler OBC" },
  21428: {
    category: "Fehler",
    text: "Batteriesystem Ladesteckerverriegelung Fehler",
  },
  21429: {
    category: "Fehler",
    text: "Batteriesystem einphasiges Laden Fehler",
  },
  21430: {
    category: "Fehler",
    text: "Batteriesystem Ausgangsspannung OBC zu hoch",
  },
  21431: {
    category: "Fehler",
    text: "Batteriesystem Ausgangsspannung OBC zu niedrig",
  },
  21432: { category: "Fehler", text: "Batteriesystem Kabelbruch Pumpe" },
  21433: {
    category: "Fehler",
    text: "Batteriesystem Kurzschluss gegen 24 V Pumpe",
  },
  21434: { category: "Fehler", text: "Batteriesystem Strom der Pumpe zu hoch" },
  21435: {
    category: "Fehler",
    text: "Batteriesystem Kurzschluss gegen Masse Pumpe",
  },
  21436: {
    category: "Fehler",
    text: "Batteriesystem Versorgung Pumpe unplausibel",
  },
  21437: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 1 Kabelbruch",
  },
  21438: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 1 Kurzschluss",
  },
  21439: {
    category: "Fehler",
    text: "Batteriesystem Signal Kable 1 Überstrom",
  },
  21440: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 1 Kurzschluss Masse",
  },
  21441: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 1 unplausibel",
  },
  21442: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 2 Kabelbruch",
  },
  21443: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 2 Kurzschluss",
  },
  21444: {
    category: "Fehler",
    text: "Batteriesystem Signal Kable 2 Überstrom",
  },
  21445: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 2 Kurzschluss Masse",
  },
  21446: {
    category: "Fehler",
    text: "Batteriesystem Signal Kabel 2 unplausibel",
  },
  21447: { category: "Fehler", text: "Batteriesystem Fehler beim Hochfahren" },
  21448: { category: "Fehler", text: "Batteriesystem CAN Fehler extern" },
  21449: { category: "Fehler", text: "Batteriesystem Ladezustand gering" },
  21450: { category: "Fehler", text: "Batteriesystem Ladezustand zu gering" },
  21451: { category: "Fehler", text: "Batteriesystem Ladezustand leer" },
  21452: {
    category: "Fehler",
    text: "Batteriesystem Isolationsüberwachung Fehler",
  },
  21453: { category: "Fehler", text: "Batteriesystem Isolation Warnung" },
  21454: { category: "Fehler", text: "Batteriesystem Isolation Fehler" },
  21455: { category: "Fehler", text: "Batteriesystem DCDC Fehler" },
  21456: { category: "Fehler", text: "Batteriesystem Vorwärm Warnung" },
  21500: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültige Drehzahl oder Drehmoment",
  },
  21501: { category: "Fehler", text: "E-Motor Fräse: Ungültiges Drehmoment" },
  21502: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültige Geschwindigkeit",
  },
  21503: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültiger Status Motor aktiv",
  },
  21504: { category: "Fehler", text: "E-Motor Fräse: Ungültige Drehrichtung" },
  21505: { category: "Fehler", text: "E-Motor Fräse: Ungültiger Status" },
  21506: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültiger Betriebsmodus",
  },
  21507: { category: "Fehler", text: "E-Motor Fräse: Ungültige Drehzahl" },
  21508: { category: "Fehler", text: "E-Motor Fräse: Ungültiger Status" },
  21509: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültige IGBT-Temperatur",
  },
  21510: {
    category: "Fehler",
    text: "E-Motor Fräse: Ungültige Temperatur Motor",
  },
  21511: {
    category: "Fehler",
    text: "E-Motor Fräse: UngültigeSpannung Batterie",
  },
  21512: { category: "Fehler", text: "E-Fräsmotor: Keine Kommunikation" },
  21513: {
    category: "Fehler",
    text: "E-Fräsmotor: Fehlerhafte Einstellung Drehmoment (über Limit)",
  },
  21514: { category: "Fehler", text: "E-Fräsmotor: HVIL Fehler" },
  21515: {
    category: "Fehler",
    text: "E-Fräsmotor: Fehler aktive Entladung des Motors",
  },
  21516: {
    category: "Fehler",
    text: "E-Fräsmotor: Temperatursensor Motor gibt einen Fehler aus",
  },
  21517: {
    category: "Fehler",
    text: "E-Fräsmotor: Temperatursensor MCU gibt einen Fehler aus",
  },
  21518: { category: "Fehler", text: "E-Fräsmotor: Temperaturwarnung Motor" },
  21519: { category: "Fehler", text: "E-Fräsmotor: Temperaturwarnung MCU" },
  21520: { category: "Fehler", text: "E-Fräsmotor: Überstannung HVDC" },
  21521: { category: "Fehler", text: "E-Fräsmotor: Unterspannung HVDC" },
  21522: {
    category: "Fehler",
    text: "E-Fräsmotor: 3 Phasen Überstrom Warnung",
  },
  21523: { category: "Fehler", text: "E-Fräsmotor: Zu hohe Belastung" },
  21524: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler zu hohe Motor-Temperatur",
  },
  21525: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler zu hohe MCU-Temperatur",
  },
  21526: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler HVDC Überspannung",
  },
  21527: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler HVDC Unterspannung",
  },
  21528: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler 3 Phasen Überstrom",
  },
  21529: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler MCU oder Motor zu starke Belastung",
  },
  21530: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler 12V Unterspannung",
  },
  21531: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler IGBT",
  },
  21532: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler Resolver",
  },
  21533: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler Stromsensor",
  },
  21534: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler HVDC Spannungssensor",
  },
  21535: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler VCM Kommunikationsfehler",
  },
  21536: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler Geschwindigkeit Motor",
  },
  21537: {
    category: "Fehler",
    text: "E-Fräsmotor: Schwerwiegender Fehler Motorphase verloren",
  },
  21538: { category: "Fehler", text: "Interface E-Motor Fräse CAN ist null" },
  21539: { category: "Fehler", text: "E-Motor Fräse: Ungültiges Drehmoment" },
  21540: {
    category: "Fehler",
    text: "Fraese aufgrund hoher Motorlast reduziert",
  },
  21541: {
    category: "Fehler",
    text: "Fraese aufgrund hoher Motorlast gestoppt",
  },
  21800: { category: "Fehler", text: "E-Mischmotor: Keine Kommunikation" },
  21801: {
    category: "Fehler",
    text: "E-Mischmotor: Fehlerhafte Einstellung Drehmoment (über Limit)",
  },
  21802: { category: "Fehler", text: "E-Mischmotor: HVIL Fehler" },
  21803: {
    category: "Fehler",
    text: "E-Mischmotor: Fehler aktive Entladung des Motors",
  },
  21804: {
    category: "Fehler",
    text: "E-Mischmotor: Temperatursensor Motor gibt einen Fehler aus",
  },
  21805: {
    category: "Fehler",
    text: "E-Mischmotor: Temperatursensor MCU gibt einen Fehler aus",
  },
  21806: { category: "Fehler", text: "E-Mischmotor: Temperaturwarnung Motor" },
  21807: { category: "Fehler", text: "E-Mischmotor: Temperaturwarnung MCU" },
  21808: { category: "Fehler", text: "E-Mischmotor: Unterspannung HVDC" },
  21809: { category: "Fehler", text: "E-Mischmotor: Unterspannung HVDC" },
  21810: {
    category: "Fehler",
    text: "E-Mischmotor: 3 Phasen Überstrom Warnung",
  },
  21811: { category: "Fehler", text: "E-Mischmotor: Zu hohe Belastung" },
  21812: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler zu hohe Motor-Temperatur",
  },
  21813: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler zu hohe MCU-Temperatur",
  },
  21814: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler HVDC Überspannung",
  },
  21815: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler HVDC Unterspannung",
  },
  21816: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler 3 Phasen Überstrom",
  },
  21817: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler MCU oder Motor zu starke Belastung",
  },
  21818: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler 12V Unterspannung",
  },
  21819: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler IGBT",
  },
  21820: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler Resolver",
  },
  21821: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler Stromsensor",
  },
  21822: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler HVDC Spannungssensor",
  },
  21823: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler VCM Kommunikationsfehler",
  },
  21824: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler Geschwindigkeit Motor",
  },
  21825: {
    category: "Fehler",
    text: "E-Mischmotor: Schwerwiegender Fehler Motorphase verloren",
  },
  21826: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige Drehzahl oder Drehmoment",
  },
  21827: { category: "Fehler", text: "E-Motor Mischer: Ungültiges Drehmoment" },
  21828: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige Geschwindigkeit",
  },
  21829: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültiger Status Motor aktiv",
  },
  21830: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige Drehrichtung",
  },
  21831: { category: "Fehler", text: "E-Motor Mischer: Ungültiger Status" },
  21832: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültiger Betriebsmodus",
  },
  21833: { category: "Fehler", text: "E-Motor Mischer: Ungültige Drehzahl" },
  21834: { category: "Fehler", text: "E-Motor Mischer: Ungültiger Status" },
  21835: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige IGBT-Temperatur",
  },
  21836: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige Temperatur Motor",
  },
  21837: {
    category: "Fehler",
    text: "E-Motor Mischer: Ungültige Spannung Batterie",
  },
  21838: { category: "Fehler", text: "Interface E-Motor Mischer CAN ist null" },
  22100: { category: "Fehler", text: "E-Hydromotor: Keine Kommunikation" },
  22101: {
    category: "Fehler",
    text: "E-Hydromotor: Fehlerhafte Einstellung Drehmoment (über Limit)",
  },
  22102: { category: "Fehler", text: "E-Hydromotor: HVIL Fehler" },
  22103: {
    category: "Fehler",
    text: "E-Hydromotor: Fehler aktive Entladung des Motors",
  },
  22104: {
    category: "Fehler",
    text: "E-Hydromotor: Temperatursensor Motor gibt einen Fehler aus",
  },
  22105: {
    category: "Fehler",
    text: "E-Hydromotor: Temperatursensor MCU gibt einen Fehler aus",
  },
  22106: { category: "Fehler", text: "E-Hydromotor: Temperaturwarnung Motor" },
  22107: { category: "Fehler", text: "E-Hydromotor: Temperaturwarnung MCU" },
  22108: { category: "Fehler", text: "E-Hydromotor: Unterspannung HVDC" },
  22109: { category: "Fehler", text: "E-Hydromotor: Unterspannung HVDC" },
  22110: {
    category: "Fehler",
    text: "E-Hydromotor: 3 Phasen Überstrom Warnung",
  },
  22111: { category: "Fehler", text: "E-Hydromotor: Zu hohe Belastung" },
  22112: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler zu hohe Motor-Temperatur",
  },
  22113: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler zu hohe MCU-Temperatur",
  },
  22114: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler HVDC Überspannung",
  },
  22115: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler HVDC Unterspannung",
  },
  22116: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler 3 Phasen Überstrom",
  },
  22117: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler MCU oder Motor zu starke Belastung",
  },
  22118: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler 12V Unterspannung",
  },
  22119: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler IGBT",
  },
  22120: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler Resolver",
  },
  22121: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler Stromsensor",
  },
  22122: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler HVDC Spannungssensor",
  },
  22123: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler VCM Kommunikationsfehler",
  },
  22124: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler Geschwindigkeit Motor",
  },
  22125: {
    category: "Fehler",
    text: "E-Hydromotor: Schwerwiegender Fehler Motorphase verloren",
  },
  22126: {
    category: "Fehler",
    text: "E-Motor Hydro: Ungültige Drehzahl oder Drehmoment",
  },
  22127: { category: "Fehler", text: "E-Motor Hydro: Ungültiges Drehmoment" },
  22128: {
    category: "Fehler",
    text: "E-Motor Hydro: Ungültige Geschwindigkeit",
  },
  22129: {
    category: "Fehler",
    text: "E-Motor Hydro: Ungültiger Status Motor aktiv",
  },
  22130: { category: "Fehler", text: "E-Motor Hydro: Ungültige Drehrichtung" },
  22131: { category: "Fehler", text: "E-Motor Hydro: Ungültiger Status" },
  22132: {
    category: "Fehler",
    text: "E-Motor Hydro: Ungültiger Betriebsmodus",
  },
  22133: { category: "Fehler", text: "E-Motor Hydro: Ungültige Drehzahl" },
  22134: { category: "Fehler", text: "E-Motor Hydro: Ungültiger Status" },
  22135: {
    category: "Fehler",
    text: "E-Motor Hydro: Ungültige IGBT-Temperatur",
  },
  22136: {
    category: "Fehler",
    text: "E-Motor Hydro: Ungültige Temperatur Motor",
  },
  22137: {
    category: "Fehler",
    text: "E-Motor Hydro: Ungültige Spannung Batterie",
  },
  22138: {
    category: "Fehler",
    text: "Klasse Hydromotor ist nicht initialisiert",
  },
  22139: {
    category: "Fehler",
    text: "Eingehendes Interface Diagnose ist nicht initialisiert in Klasse clsHydroMot",
  },
  22140: {
    category: "Fehler",
    text: "Eingehendes Interface Diagnose ist null in Klasse clsHydroMot",
  },
  22141: {
    category: "Fehler",
    text: "Eingehendes Interface CAN Bus ist nicht initialisiert in Klasse clsHydroMot",
  },
  22142: {
    category: "Fehler",
    text: "Eingehendes Interface CAN Bus ist null in Klasse clsHydroMot",
  },
  22143: {
    category: "Fehler",
    text: "Eingehendes Interface Überwachung ist nicht initialisiert in Klasse clsHydroMot",
  },
  22144: {
    category: "Fehler",
    text: "Eingehendes Interface Überwachung ist null in Klasse clsHydroMot",
  },
  22145: {
    category: "Fehler",
    text: "Eingehendes Interface Mischer ist nicht initialisiert in Klasse clsHydroMot",
  },
  22146: {
    category: "Fehler",
    text: "Eingehendes Interface Mischer ist null in Klasse clsHydroMot",
  },
  22147: {
    category: "Fehler",
    text: "Interface E-Motor Hydro-Motor CAN ist null",
  },
  22148: {
    category: "Fehler",
    text: "Klasse Hydromotor aus E-Feeding Library kann nicht initialisiert werden",
  },
  22149: { category: "Fehler", text: "Interface BMS ist null" },
  22150: { category: "Fehler", text: "Interface BMS ist nicht initialisiert" },
  22151: { category: "Fehler", text: "Interface LS Druck ist null" },
  22152: { category: "Fehler", text: "Interface Arbeitsdruck ist null" },
  22153: {
    category: "Fehler",
    text: "Interface LS Druck kann nicht konvertiert werden",
  },
  22154: {
    category: "Fehler",
    text: "Interface Arbeitsdruck kann nicht konvertiert werden",
  },
  22155: { category: "Fehler", text: "Interface Parameter ist null" },
  22156: {
    category: "Fehler",
    text: "Interface Parameter ist nicht initialisiert",
  },
  22157: { category: "Fehler", text: "Bereichsfehler Sensor LS Druck" },
  22158: { category: "Fehler", text: "Fehler beim Lesen des LS Druckes" },
  22159: { category: "Fehler", text: "Bereichsfehler Sensor Arbeitsdruck" },
  22160: { category: "Fehler", text: "Fehler beim Lesen des Arbeitsdruckes" },
  22161: {
    category: "Fehler",
    text: "Wasserpumpe des E-Hydromotors/OBC konnte nicht initialisiert werden",
  },
  22162: {
    category: "Fehler",
    text: "Interface Wasserpumpe E-Hydromotor/OBC ist null",
  },
  22163: {
    category: "Fehler",
    text: "Interface Wasserpumpe E-Hydromotor/OBC kann nicht konvertiert werden",
  },
  22164: {
    category: "Fehler",
    text: "Signal Wasserpumpe E-Hydromotor/OBC konnte nicht gesetzt werden",
  },
  22165: { category: "Fehler", text: "Interface OBC ist nicht initialisiert" },
  22166: { category: "Fehler", text: "Interface OBC ist null" },
  22300: {
    category: "Fehler",
    text: "Interface Ladestecker-Verriegelung aktiv E-Feeding ist null",
  },
  22301: {
    category: "Fehler",
    text: "Interface Ladestecker-Verriegelung aktiv E-Feeding kann nicht konvertiert werden",
  },
  22302: {
    category: "Fehler",
    text: "Interface Diagnose ist null in Klasse Ladestecker",
  },
  22303: {
    category: "Fehler",
    text: "Interface Diagnose ist nicht initialisiert in Klasse Ladestecker",
  },
  22304: {
    category: "Fehler",
    text: "Interface Can-Bus ist null in Klasse Ladestecker",
  },
  22305: {
    category: "Fehler",
    text: "Interface Can-Bus ist nicht initialisiert in Klasse Ladestecker",
  },
  22306: {
    category: "Fehler",
    text: "Interface Überwachung ist null in Klasse Ladestecker",
  },
  22307: {
    category: "Fehler",
    text: "Interface Überwachung ist nicht initialisiert in Klasse Ladestecker",
  },
  22308: {
    category: "Fehler",
    text: "Interface Parameter ist null in Klasse Ladestecker",
  },
  22309: {
    category: "Fehler",
    text: "Interface Parameter ist nicht initialisiert in Klasse Ladestecker",
  },
  22310: {
    category: "Fehler",
    text: "Interface Ladestecker-Verriegelung öffnen ist null",
  },
  22311: {
    category: "Fehler",
    text: "Interface Ladestecker-Verriegelung öffnen kann nicht konvertiert werden",
  },
  22312: {
    category: "Fehler",
    text: "Interface Ladestecker-Verriegelung schließen ist null",
  },
  22313: {
    category: "Fehler",
    text: "Interface Ladestecker-Verriegelung schließen kann nicht konvertiert werden",
  },
  22314: {
    category: "Fehler",
    text: "Fehler beim Setzen der Ladestecker-Verriegelung (öffnen)",
  },
  22315: {
    category: "Fehler",
    text: "Ladestecker öffnen und schließen sind gleichzeitig aktiv",
  },
  22316: {
    category: "Fehler",
    text: "Fehler beim Setzen der Ladestecker-Verriegelung (öffnen)",
  },
  22317: {
    category: "Fehler",
    text: "Klasse LadeStecker ist nicht initialisiert",
  },
  22318: {
    category: "Fehler",
    text: "Eingehender CAN-Bus ist null in Klasse LadeStecker",
  },
  22319: {
    category: "Fehler",
    text: "Interface BMS ist nicht initialisiert in Klasse BMS",
  },
  22320: { category: "Fehler", text: "Interface BMS ist null in Klasse BMS" },
  22321: {
    category: "Fehler",
    text: "AC Spannung außerhalb des gültigen Bereiches in Klasse Ladestecker",
  },
  22322: {
    category: "Fehler",
    text: "Ladestrom außerhalb des gültigen Bereiches in Klasse Ladestecker",
  },
  22323: {
    category: "Fehler",
    text: "J1772-Status fehlerhaft in Klasse LadeStecker",
  },
  22324: {
    category: "Fehler",
    text: "J1772-Status Interface kann nicht konvertiert werden in Klasse LadeStecker",
  },
  22400: { category: "Fehler", text: "E-Fahrmotor: Keine Kommunikation" },
  22401: {
    category: "Fehler",
    text: "E-Fahrmotor: Fehlerhafte Einstellung Drehmoment (über Limit)",
  },
  22402: { category: "Fehler", text: "E-Fahrmotor: HVIL Fehler" },
  22403: {
    category: "Fehler",
    text: "E-Fahrmotor: Fehler aktive Entladung des Motors",
  },
  22404: {
    category: "Fehler",
    text: "E-Fahrmotor: Temperatursensor Motor gibt einen Fehler aus",
  },
  22405: {
    category: "Fehler",
    text: "E-Fahrmotor: Temperatursensor MCU gibt einen Fehler aus",
  },
  22406: { category: "Fehler", text: "E-Fahrmotor: Temperaturwarnung Motor" },
  22407: { category: "Fehler", text: "E-Fahrmotor: Temperaturwarnung MCU" },
  22408: { category: "Fehler", text: "E-Fahrmotor: Unterspannung HVDC" },
  22409: { category: "Fehler", text: "E-Fahrmotor: Unterspannung HVDC" },
  22410: {
    category: "Fehler",
    text: "E-Fahrmotor: 3 Phasen Überstrom Warnung",
  },
  22411: { category: "Fehler", text: "E-Fahrmotor: Zu hohe Belastung" },
  22412: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler zu hohe Motor-Temperatur",
  },
  22413: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler zu hohe MCU-Temperatur",
  },
  22414: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler HVDC Überspannung",
  },
  22415: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler HVDC Unterspannung",
  },
  22417: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler MCU oder Motor zu starke Belastung",
  },
  22418: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler 12V Unterspannung",
  },
  22419: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler IGBT",
  },
  22420: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler Resolver",
  },
  22421: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler Stromsensor",
  },
  22422: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler HVDC Spannungssensor",
  },
  22423: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler VCM Kommunikationsfehler",
  },
  22424: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler Geschwindigkeit Motor",
  },
  22425: {
    category: "Fehler",
    text: "E-Fahrmotor: Schwerwiegender Fehler Motorphase verloren",
  },
  22426: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültige Drehzahl oder Drehmoment",
  },
  22427: { category: "Fehler", text: "E-Motor Fahren: Ungültiges Drehmoment" },
  22428: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültige Geschwindigkeit",
  },
  22429: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültiger Status Motor aktiv",
  },
  22430: { category: "Fehler", text: "E-Motor Fahren: Ungültige Drehrichtung" },
  22431: { category: "Fehler", text: "E-Motor Fahren: Ungültiger Status" },
  22432: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültiger Betriebsmodus",
  },
  22433: { category: "Fehler", text: "E-Motor Fahren: Ungültige Drehzahl" },
  22434: { category: "Fehler", text: "E-Motor Fahren: Ungültiger Status" },
  22435: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültige IGBT-Temperatur",
  },
  22436: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültige Temperatur Motor",
  },
  22437: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültige Spannung Batterie",
  },
  22438: {
    category: "Fehler",
    text: "Interface E-Motor Fahrantrieb CAN ist null",
  },
  22439: {
    category: "Fehler",
    text: "Klasse Fahrantrieb aus E-Feeding Library kann nicht initialisiert werden",
  },
  22440: { category: "Fehler", text: "Interface BMS ist null" },
  22441: { category: "Fehler", text: "Interface BMS ist nicht initialisiert" },
  22442: {
    category: "Fehler",
    text: "Wasserpumpe des Fahrantriebes konnte nicht initialisiert werden",
  },
  22443: {
    category: "Fehler",
    text: "Interface Wasserpumpe Fahrantrieb ist null",
  },
  22444: {
    category: "Fehler",
    text: "Interface Wasserpumpe Fahrantrieb kann nicht konvertiert werden",
  },
  22445: {
    category: "Fehler",
    text: "Signal Wasserpumpe Fahrantrieb konnte nicht gesetzt werden",
  },
  22446: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültiger Strom Batterie",
  },
  22447: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültiger Ladezustand Batterie",
  },
  22448: {
    category: "Fehler",
    text: "Ladezustand der Batterie ist über 90 %. Rekuparation ist deaktiviert.",
  },
  22449: {
    category: "Fehler",
    text: "Ladezustand der Batterie ist wieder unter 90 %. Rekuperation ist aktiviert.",
  },
  22450: {
    category: "Fehler",
    text: "Interface Elektromotor Hydraulik ist null in clsFahrantrieb",
  },
  22451: {
    category: "Fehler",
    text: "Interface Elektromotor Hydraulik ist nicht initialisiertr",
  },
  22452: {
    category: "Fehler",
    text: "E-Motor Fahren: Ungültige aktuelle Drehrichtung",
  },
  22539: {
    category: "Fehler",
    text: "Klasse Fräsmotor aus E-Feeding Library kann nicht initialisiert werden",
  },
  22540: { category: "Fehler", text: "Interface BMS ist null" },
  22541: { category: "Fehler", text: "Interface BMS ist nicht initialisiert" },
  22542: {
    category: "Fehler",
    text: "Wasserpumpe der Fräse konnte nicht initialisiert werden",
  },
  22543: { category: "Fehler", text: "Interface Wasserpumpe Fräse ist null" },
  22544: {
    category: "Fehler",
    text: "Interface Wasserpumpe Fräse kann nicht konvertiert werden",
  },
  22545: {
    category: "Fehler",
    text: "Signal Wasserpumpe Fräse konnte nicht gesetzt werden",
  },
  22546: {
    category: "Fehler",
    text: "Interface itfDrehzahlManagement_Fraese ist ungültig",
  },
  22547: {
    category: "Fehler",
    text: "Zielgewicht zu 98% erreicht. Fraese wird getoppt",
  },
  22600: {
    category: "Fehler",
    text: "Interface BMS ist nicht initialisiert in Klasse Heizung",
  },
  22601: {
    category: "Fehler",
    text: "Interface BMS ist null in Klasse Heizung",
  },
  22602: {
    category: "Fehler",
    text: "Klasse Heizung konnte nicht initialisiert werden",
  },
  22603: {
    category: "Fehler",
    text: "Fehlerhafte höchste Zelltemperatur festgestellt",
  },
  22604: {
    category: "Fehler",
    text: "Fehlerhafte niedrigste Zelltemperatur festgestellt",
  },
  22605: {
    category: "Fehler",
    text: "Interface Batterieheizung ist null in Klasse Überwachung",
  },
  22606: {
    category: "Fehler",
    text: "Interface Batterieheizung kann nicht konvertiert werden in Klasse Überwachung",
  },
  22607: {
    category: "Fehler",
    text: "Fehler beim Einschalten der Batterieheizung",
  },
  22608: {
    category: "Fehler",
    text: "Fehler beim Ausschalten der Batterieheizung",
  },
  22609: {
    category: "Fehler",
    text: "Interface BMS ist nicht initialisiert in Klasse Heizung",
  },
  22610: {
    category: "Fehler",
    text: "Interface BMS ist null in Klasse Heizung",
  },
  22611: {
    category: "Fehler",
    text: "Interface Diagnose ist nicht initialisiert in Klasse IMD",
  },
  22612: {
    category: "Fehler",
    text: "Interface Diagnose ist null in Klasse IMD",
  },
  22613: {
    category: "Fehler",
    text: "Klasse IMD aus efeeding konnte nicht richtig initialisiert werden",
  },
  22839: {
    category: "Fehler",
    text: "Klasse Mischermotor aus E-Feeding Library kann nicht initialisiert werden",
  },
  22840: { category: "Fehler", text: "Interface BMS ist null" },
  22841: { category: "Fehler", text: "Interface BMS ist nicht initialisiert" },
  22842: {
    category: "Fehler",
    text: "Wasserpumpe des Mischers konnte nicht initialisiert werden",
  },
  22843: { category: "Fehler", text: "Interface Wasserpumpe Mischer ist null" },
  22844: {
    category: "Fehler",
    text: "Interface Wasserpumpe Mischer kann nicht konvertiert werden",
  },
  22845: {
    category: "Fehler",
    text: "Signal Wasserpumpe Mischer konnte nicht gesetzt werden",
  },
  22846: {
    category: "Fehler",
    text: "Aufgrund der Zeitvorgabe im Rezept wird der Mischer abgeschaltet",
  },
  22847: {
    category: "Fehler",
    text: "Mischerdrezahl kann aufgrund des Mischerdrucks oder aufgrund der Motordrückung nicht erreicht werden",
  },
  22848: {
    category: "Fehler",
    text: "Mischer aufgrund hoher Motorlast reduziert",
  },
  22849: {
    category: "Fehler",
    text: "Mischer aufgrund hoher Motorlast gestoppt",
  },
}
